export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  CraftDateTime: { input: any; output: any }
  CraftNumber: { input: any; output: any }
  CraftQueryArgument: { input: any; output: any }
  TODO: { input: any; output: any }
}

export type AddAdvCommentInput = {
  /** Email Address. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Review. */
  message: Scalars['String']['input']
  /** Nickname. */
  nickname?: InputMaybe<Scalars['String']['input']>
  /** Review ID. */
  review_id: Scalars['Int']['input']
}

export type AddAdvCommentOutput = {
  __typename?: 'AddAdvCommentOutput'
  /** Commented Review. */
  review?: Maybe<Review>
  /** Status. */
  success?: Maybe<Scalars['Boolean']['output']>
}

export type AddAdvReviewInput = {
  /** Review. */
  detail: Scalars['String']['input']
  /** GDPR. */
  gdpr?: InputMaybe<Scalars['Boolean']['input']>
  /** Email Address. */
  guest_email?: InputMaybe<Scalars['String']['input']>
  /** Recommendation. */
  is_recommended?: InputMaybe<Scalars['Boolean']['input']>
  /** Advantages. */
  like_about?: InputMaybe<Scalars['String']['input']>
  /** Nickname. */
  nickname: Scalars['String']['input']
  /** Disadvantages. */
  not_like_about?: InputMaybe<Scalars['String']['input']>
  /** Product UID */
  productUid: Scalars['ID']['input']
  /** Product ID */
  product_id?: InputMaybe<Scalars['Int']['input']>
  /** Rating in Json format. Rating ID => Rating Value */
  ratings: Scalars['String']['input']
  /** Summary. */
  title: Scalars['String']['input']
  /** Path to tmp images location to save review images. */
  tmp_images_path?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type AddAdvReviewOutput = {
  __typename?: 'AddAdvReviewOutput'
  /** Status. */
  success?: Maybe<Scalars['Boolean']['output']>
}

export type AddAdvVoteInput = {
  /** Review ID. */
  review_id: Scalars['Int']['input']
  /** Nickname. */
  type: Scalars['String']['input']
}

export type AddAdvVoteOutput = {
  __typename?: 'AddAdvVoteOutput'
  /** Commented Review. */
  review?: Maybe<Review>
  /** Status. */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Defines the bundle products to add to the cart. */
export type AddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input']
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>
}

/** Contains details about the cart after adding bundle products. */
export type AddBundleProductsToCartOutput = {
  __typename?: 'AddBundleProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

/** Defines the configurable products to add to the cart. */
export type AddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input']
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>
}

/** Contains details about the cart after adding configurable products. */
export type AddConfigurableProductsToCartOutput = {
  __typename?: 'AddConfigurableProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

export type AddDownloadableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input']
  /** An array of downloadable products to add. */
  cart_items: Array<InputMaybe<DownloadableProductCartItemInput>>
}

/** Contains details about the cart after adding downloadable products. */
export type AddDownloadableProductsToCartOutput = {
  __typename?: 'AddDownloadableProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

/** Contains details about the cart after adding products to it. */
export type AddProductsToCartOutput = {
  __typename?: 'AddProductsToCartOutput'
  /** The cart after products have been added. */
  cart: Cart
  /** Contains errors encountered while adding an item to the cart. */
  userErrors: Array<Maybe<CartUserInputError>>
}

/** Contains products to add to an existing compare list. */
export type AddProductsToCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: Array<InputMaybe<Scalars['ID']['input']>>
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID']['input']
}

/** Contains the customer's wish list and any errors encountered. */
export type AddProductsToWishlistOutput = {
  __typename?: 'AddProductsToWishlistOutput'
  /** An array of errors encountered while adding products to a wish list. */
  userErrors: Array<Maybe<WishListUserInputError>>
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist
}

/** Defines the simple and group products to add to the cart. */
export type AddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>
}

/** Contains details about the cart after adding simple or group products. */
export type AddSimpleProductsToCartOutput = {
  __typename?: 'AddSimpleProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

/** Defines the virtual products to add to the cart. */
export type AddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>
}

/** Contains details about the cart after adding virtual products. */
export type AddVirtualProductsToCartOutput = {
  __typename?: 'AddVirtualProductsToCartOutput'
  /** The cart after adding products. */
  cart: Cart
}

/** Contains the resultant wish list and any error information. */
export type AddWishlistItemsToCartOutput = {
  __typename?: 'AddWishlistItemsToCartOutput'
  /** An array of errors encountered while adding products to the customer's cart. */
  addWishlistItemsToCartUserErrors: Array<Maybe<WishlistCartUserInputError>>
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars['Boolean']['output']
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist
}

export type AdditionalDataField = {
  field: Scalars['String']['input']
  value: Scalars['String']['input']
}

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation'
  /** Attribute code of the aggregation group. */
  attributeCode: Scalars['String']['output']
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']['output']>
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']['output']>
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>
  /** The relative position of the attribute in a layered navigation block. */
  position?: Maybe<Scalars['Int']['output']>
}

/** An implementation of `AggregationOptionInterface`. */
export type AggregationOption = AggregationOptionInterface & {
  __typename?: 'AggregationOption'
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']['output']>
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output']
}

/** Defines aggregation option fields. */
export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']['output']>
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output']
}

/** Filter category aggregations in layered navigation. */
export type AggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly?: InputMaybe<Scalars['Boolean']['input']>
}

/** An input object that specifies the filters used in product aggregations. */
export type AggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category?: InputMaybe<AggregationsCategoryFilterInput>
}

export type AmReviewSetting = {
  __typename?: 'AmReviewSetting'
  /** Available filter. */
  availableFilters?: Maybe<Array<Maybe<ReviewFilter>>>
  /** Available orders. */
  availableOrders?: Maybe<Array<Maybe<ReviewOrder>>>
  /** Сonsent Text. */
  getGdprText?: Maybe<Scalars['String']['output']>
  /** Review Image Width. */
  getReviewImageWidth?: Maybe<Scalars['String']['output']>
  /** Allow answer. */
  isAllowAnswer?: Maybe<Scalars['Boolean']['output']>
  /** Allow coupons. */
  isAllowCoupons?: Maybe<Scalars['Boolean']['output']>
  /** Allow guest. */
  isAllowGuest?: Maybe<Scalars['Boolean']['output']>
  /** Allow helpful. */
  isAllowHelpful?: Maybe<Scalars['Boolean']['output']>
  /** Allow images. */
  isAllowImages?: Maybe<Scalars['Boolean']['output']>
  /** Review Reminder. */
  isAllowReminder?: Maybe<Scalars['Boolean']['output']>
  /** Comments Enabled. */
  isCommentsEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Sorting enabled. */
  isFilteringEnabled?: Maybe<Scalars['Boolean']['output']>
  /** GDPR Consent. */
  isGdprEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Guest Can Comment. */
  isGuestCanComment?: Maybe<Scalars['Boolean']['output']>
  /** Is Guest Email Showed. */
  isGuestEmailShow?: Maybe<Scalars['Boolean']['output']>
  /** Is Images Required. */
  isImagesRequired?: Maybe<Scalars['Boolean']['output']>
  /** Pros and Cons. */
  isProsConsEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Recomended field enable. */
  isRecommendFieldEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Reminder Enabled. */
  isReminderEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Sorting enabled. */
  isSortingEnabled?: Maybe<Scalars['Boolean']['output']>
  /** Toolbar displayed. */
  isToolbarDisplayed?: Maybe<Scalars['Boolean']['output']>
  /** Reviews Per Page. */
  perPage?: Maybe<Scalars['Int']['output']>
  /** Available Ratings. */
  ratings?: Maybe<Array<Maybe<Rating>>>
  /** Images to Show. */
  slidesToShow?: Maybe<Scalars['Int']['output']>
}

export type AmReviewWidget = {
  __typename?: 'AmReviewWidget'
  /** Reviews from Current Category Only. */
  currentCategory?: Maybe<Scalars['Boolean']['output']>
  /** Reviews of Products which belong to the Same Categories Only. */
  currentProductCategory?: Maybe<Scalars['Boolean']['output']>
  /** Enable Slider. */
  enableSlider?: Maybe<Scalars['Boolean']['output']>
  items?: Maybe<Array<Maybe<AmReviewWidgetItem>>>
  /** Reviews Type. */
  reviewType?: Maybe<Scalars['Int']['output']>
  /** Number of Reviews to Show. */
  reviewsCount?: Maybe<Scalars['Int']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type AmReviewWidgetItem = {
  __typename?: 'AmReviewWidgetItem'
  /** Date. */
  date?: Maybe<Scalars['String']['output']>
  image?: Maybe<ProductImage>
  /** Product Name. */
  name?: Maybe<Scalars['String']['output']>
  /** Product URL. */
  productUrl?: Maybe<Scalars['String']['output']>
  /** Rating votes. */
  ratingVotes?: Maybe<Array<Maybe<RatingVote>>>
  /** Recommended Html. */
  recommendedHtml?: Maybe<Scalars['String']['output']>
  /** Review By. */
  reviewBy?: Maybe<Scalars['String']['output']>
  /** Review Message. */
  reviewMessage?: Maybe<Scalars['String']['output']>
}

export type AmbianceGallery = {
  __typename?: 'AmbianceGallery'
  /** The status of the image */
  disabled?: Maybe<Scalars['Boolean']['output']>
  /** The label for alt and title */
  label?: Maybe<Scalars['String']['output']>
  /** The sort order */
  position?: Maybe<Scalars['Int']['output']>
  /** The Image URL */
  url?: Maybe<Scalars['String']['output']>
}

/** Contains the applied coupon code. */
export type AppliedCoupon = {
  __typename?: 'AppliedCoupon'
  /** The coupon code the shopper applied to the card. */
  code: Scalars['String']['output']
}

/** Specifies the coupon code to apply to the cart. */
export type ApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** A valid coupon code. */
  coupon_code: Scalars['String']['input']
}

/** Contains details about the cart after applying a coupon. */
export type ApplyCouponToCartOutput = {
  __typename?: 'ApplyCouponToCartOutput'
  /** The cart after applying a coupon. */
  cart: Cart
}

/** Contains the results of the request to assign a compare list. */
export type AssignCompareListToCustomerOutput = {
  __typename?: 'AssignCompareListToCustomerOutput'
  /** The contents of the customer's compare list. */
  compareList?: Maybe<CompareList>
  /** Indicates whether the compare list was successfully assigned to the customer. */
  result: Scalars['Boolean']['output']
}

/** Contains details about the attribute, including the code and type. */
export type Attribute = {
  __typename?: 'Attribute'
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attributeCode?: Maybe<Scalars['String']['output']>
  /** Attribute options list. */
  attributeOptions?: Maybe<Array<Maybe<AttributeOption>>>
  /** The data type of the attribute. */
  attributeType?: Maybe<Scalars['String']['output']>
  /** The type of entity that defines the attribute. */
  entityType?: Maybe<Scalars['String']['output']>
  /** The frontend input type of the attribute. */
  inputType?: Maybe<Scalars['String']['output']>
  /** Details about the storefront properties configured for the attribute. */
  storefrontProperties?: Maybe<StorefrontProperties>
}

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']['input']>
  /** The type of entity that defines the attribute. */
  entity_type?: InputMaybe<Scalars['String']['input']>
}

/** Defines an attribute option. */
export type AttributeOption = {
  __typename?: 'AttributeOption'
  /** The color swatch when the attribute is a visual swatch */
  colorSwatch?: Maybe<SwatchData>
  /** The label assigned to the attribute option. */
  label?: Maybe<Scalars['String']['output']>
  /** The attribute option value. */
  value?: Maybe<Scalars['String']['output']>
}

/** Describes a payment method that the shopper can use to pay for the order. */
export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod'
  /** The payment method code. */
  code: Scalars['String']['output']
  /** The payment method image. */
  image: Scalars['String']['output']
  /** The payment method title. */
  title: Scalars['String']['output']
}

export type AvailablePaymentMethods = {
  __typename?: 'AvailablePaymentMethods'
  /** Array with payment methods */
  paymentMethods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>
}

/** Contains details about the possible shipping methods and carriers. */
export type AvailableShippingMethod = {
  __typename?: 'AvailableShippingMethod'
  /** The cost of shipping using this shipping method. */
  amount: Money
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars['Boolean']['output']
  /** @deprecated The field should not be used on the storefront. */
  baseAmount?: Maybe<Money>
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrierCode: Scalars['String']['output']
  /** The label for the carrier code. */
  carrierTitle: Scalars['String']['output']
  /** Describes an error condition. */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  methodCode?: Maybe<Scalars['String']['output']>
  /** The label for the shipping method code. The value could be null if no method is available. */
  methodTitle?: Maybe<Scalars['String']['output']>
  /** The cost of shipping using this shipping method, excluding tax. */
  priceExclTax: Money
  /** The cost of shipping using this shipping method, including tax. */
  priceInclTax: Money
}

export enum BatchMutationStatus {
  /** @deprecated  */
  FAILURE = 'FAILURE',
  /** @deprecated  */
  MIXED_RESULTS = 'MIXED_RESULTS',
  /** @deprecated  */
  SUCCESS = 'SUCCESS',
}

export type BergProduct = {
  __typename?: 'BergProduct'
  product: ProductInterface
  year?: Maybe<Scalars['Int']['output']>
}

/** Defines the billing address. */
export type BillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<CartAddressInput>
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id?: InputMaybe<Scalars['Int']['input']>
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping?: InputMaybe<Scalars['Boolean']['input']>
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars['Boolean']['input']>
}

/** Contains details about the billing address. */
export type BillingCartAddress = CartAddressInterface & {
  __typename?: 'BillingCartAddress'
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output']
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>
  /** An object containing the country label and code. */
  country: CartAddressCountry
  /** @deprecated The field is used only in shipping address. */
  customerNotes?: Maybe<Scalars['String']['output']>
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output']
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output']
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>
}

/** Contains details about an individual category that comprises a breadcrumb. */
export type Breadcrumb = {
  __typename?: 'Breadcrumb'
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  categoryId?: Maybe<Scalars['Int']['output']>
  /** The category level. */
  categoryLevel?: Maybe<Scalars['Int']['output']>
  /** The display name of the category. */
  categoryName?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `Breadcrumb` object. */
  categoryUid: Scalars['ID']['output']
  /** The URL key of the category. */
  categoryUrlKey?: Maybe<Scalars['String']['output']>
  /** The URL path of the category. */
  categoryUrlPath?: Maybe<Scalars['String']['output']>
}

/** An implementation for bundle product cart items. */
export type BundleCartItem = CartItemInterface & {
  __typename?: 'BundleCartItem'
  /** An array containing the bundle options the shopper selected. */
  bundleOptions: Array<Maybe<SelectedBundleOption>>
  /** An array containing the customizable options the shopper selected. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** The entered gift message for the cart item */
  giftMessage?: Maybe<GiftMessage>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output']
  /** PreOrder info */
  preorder?: Maybe<PreOrder>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output']
}

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type BundleCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'BundleCreditMemoItem'
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundleOptions?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output']
  /** The order item the credit memo is applied to. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product, including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of refunded items. */
  quantityRefunded?: Maybe<Scalars['Float']['output']>
}

/** Defines bundle product options for `InvoiceItemInterface`. */
export type BundleInvoiceItem = InvoiceItemInterface & {
  __typename?: 'BundleInvoiceItem'
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundleOptions?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output']
  /** Details about an individual order item. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of invoiced items. */
  quantityInvoiced?: Maybe<Scalars['Float']['output']>
}

/** Defines an individual item within a bundle product. */
export type BundleItem = {
  __typename?: 'BundleItem'
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']['output']>
  /** The range of prices for the product */
  priceRange: PriceRange
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']['output']>
  /** The display name of the item. */
  title?: Maybe<Scalars['String']['output']>
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `BundleItem` object. */
  uid?: Maybe<Scalars['ID']['output']>
}

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type BundleItemOption = {
  __typename?: 'BundleItemOption'
  /** Indicates whether the customer can change the number of items for this option. */
  canChangeQuantity?: Maybe<Scalars['Boolean']['output']>
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id?: Maybe<Scalars['Int']['output']>
  /** Indicates whether this option is the default option. */
  isDefault?: Maybe<Scalars['Boolean']['output']>
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']['output']>
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']['output']>
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']['output']>
  /** One of FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']['output']>
  /** The quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']['output']>
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars['ID']['output']
}

/** Defines the input for a bundle option. */
export type BundleOptionInput = {
  /** The ID of the option. */
  id: Scalars['Int']['input']
  /** The number of the selected item to add to the cart. */
  quantity: Scalars['Float']['input']
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars['String']['input']>>
}

/** Defines bundle product options for `OrderItemInterface`. */
export type BundleOrderItem = OrderItemInterface & {
  __typename?: 'BundleOrderItem'
  /** The total refunded amount */
  amountRefunded: Money
  /** A list of bundle options that are assigned to the bundle product. */
  bundleOptions?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The entered option for the base product, such as a logo or image. */
  enteredOptions?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output']
  product?: Maybe<ProductInterface>
  /** Product image */
  productImage?: Maybe<ProductImage>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price of the base product, including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The type of product, such as simple, configurable, etc. */
  productType?: Maybe<Scalars['String']['output']>
  /** URL key of the base product. */
  productUrlKey?: Maybe<Scalars['String']['output']>
  /** The number of canceled items. */
  quantityCanceled?: Maybe<Scalars['Float']['output']>
  /** The number of invoiced items. */
  quantityInvoiced?: Maybe<Scalars['Float']['output']>
  /** The number of units ordered for this item. */
  quantityOrdered?: Maybe<Scalars['Float']['output']>
  /** The number of refunded items. */
  quantityRefunded?: Maybe<Scalars['Float']['output']>
  /** The number of returned items. */
  quantityReturned?: Maybe<Scalars['Float']['output']>
  /** The number of shipped items. */
  quantityShipped?: Maybe<Scalars['Float']['output']>
  /** The total row amount */
  rowTotalIncludingTax: Money
  /** The selected options for the base product, such as color or size. */
  selectedOptions?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>
}

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'BundleProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    addOn?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    aerowall?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    ageRecommended?: Maybe<Scalars['Int']['output']>
    /** Ambiance Product Images */
    ambianceGallery?: Maybe<Array<Maybe<AmbianceGallery>>>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attributeSetId?: Maybe<Scalars['Int']['output']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonicalUrl?: Maybe<Scalars['String']['output']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    collaborationLicense?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    colorVariant?: Maybe<Scalars['String']['output']>
    /** Color Variants */
    colorVariants?: Maybe<Array<Maybe<ColorVariant>>>
    /** The product's country of origin. */
    countryOfManufacture?: Maybe<Scalars['String']['output']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    createdAt?: Maybe<Scalars['String']['output']>
    /** Crosssell Products */
    crosssellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    drive?: Maybe<Scalars['Int']['output']>
    /** Filterable attribute with Text */
    dynamicAttributes?: Maybe<Array<Maybe<DynamicAttribute>>>
    /** Indicates whether the bundle product has a dynamic price. */
    dynamicPrice?: Maybe<Scalars['Boolean']['output']>
    /** Indicates whether the bundle product has a dynamic SKU. */
    dynamicSku?: Maybe<Scalars['Boolean']['output']>
    /** Indicates whether the bundle product has a dynamically calculated weight. */
    dynamicWeight?: Maybe<Scalars['Boolean']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    electricalSupport?: Maybe<Scalars['Int']['output']>
    /** Craft entry type */
    entryType?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    framePlaybase?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    frameXlGokart?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gears?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['Int']['output']>
    /** Indicates whether a gift message is available. */
    giftMessageAvailable?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gokartType?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    handbrake?: Maybe<Scalars['Int']['output']>
    /** Highlight attributes */
    highlightedAttributes?: Maybe<Array<Maybe<HighlightAttribute>>>
    /** Highlight attributes PLP */
    highlightedAttributesPlp?: Maybe<Array<Maybe<HighlightAttribute>>>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Scalars['Int']['output']
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** @deprecated Use the `custom_attributes` field instead. */
    inclSafetynet?: Maybe<Scalars['Int']['output']>
    /** Whether the product is a main product or not. */
    isMainProduct: Scalars['Boolean']['output']
    /** An array containing information about individual bundle items. */
    items?: Maybe<Array<Maybe<BundleItem>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    jumpMat?: Maybe<Scalars['Int']['output']>
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxUserWeight?: Maybe<Scalars['Int']['output']>
    /** An array of media gallery objects. */
    mediaGallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    mediaGalleryEntries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    metaDescription?: Maybe<Scalars['String']['output']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    metaKeyword?: Maybe<Scalars['String']['output']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    metaTitle?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    minLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    model?: Maybe<Scalars['Int']['output']>
    /** The product name. Customers use this name to identify the product. */
    name: Scalars['String']['output']
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    newFromDate?: Maybe<Scalars['String']['output']>
    /** The end date for new product listings. */
    newToDate?: Maybe<Scalars['String']['output']>
    /** Product stock only x left count */
    onlyXLeftInStock?: Maybe<Scalars['Float']['output']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    optionsContainer?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pedals?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    playbaseSet?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    possibilityFor2ndSeat?: Maybe<Scalars['Int']['output']>
    /** PreOrder info */
    preorder?: Maybe<PreOrder>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    priceRange: PriceRange
    /** An array of `TierPrice` objects. */
    priceTiers?: Maybe<Array<Maybe<TierPrice>>>
    /** One of PRICE_RANGE or AS_LOW_AS. */
    priceView?: Maybe<PriceViewEnum>
    /** Product downloads */
    productDownloads?: Maybe<ProductDownload>
    /** An array of `ProductLinks` objects. */
    productLinks?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    productStatus?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pushRod?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityLine?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityStars?: Maybe<Scalars['Int']['output']>
    /** Review rating summary value. */
    ratingSummary?: Maybe<Scalars['Float']['output']>
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirectCode: Scalars['Int']['output']
    /** An array of products to be displayed in a Related Products block. */
    relatedProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relativeUrl?: Maybe<Scalars['String']['output']>
    /** Review amount of records. */
    reviewCount?: Maybe<Scalars['Int']['output']>
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    safetynetType?: Maybe<Scalars['Int']['output']>
    /** Indicates whether to ship bundle items together or individually. */
    shipBundleItems?: Maybe<ShipBundleItemsEnum>
    /** A short description of the product. Its use depends on the theme. */
    shortDescription?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeAirtrack?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeBeachwagon?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeClothing?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeJumpMat?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeStep?: Maybe<Scalars['Int']['output']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Scalars['String']['output']
    /** The relative path to the small image, which is used on catalog pages. */
    smallImage?: Maybe<ProductImage>
    /** Get list of spareparts per product(group), per year */
    sparepartLinks?: Maybe<Array<Maybe<BergProduct>>>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    specialFromDate?: Maybe<Scalars['String']['output']>
    /** The discounted price of the product. */
    specialPrice?: Maybe<Scalars['Float']['output']>
    /** The end date for a product with a special price. */
    specialToDate?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    springType?: Maybe<Scalars['Int']['output']>
    /** Stock status of the product */
    stockStatus?: Maybe<ProductStockStatus>
    /** The file name of a swatch image. */
    swatchImage?: Maybe<Scalars['String']['output']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrice?: Maybe<Scalars['Float']['output']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineShape?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineType?: Maybe<Scalars['Int']['output']>
    /** Tweakwise ID */
    tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
    /** PreOrder info */
    tweakwiseTemplates?: Maybe<TweakwiseTemplates>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    typeId?: Maybe<Scalars['String']['output']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']['output']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updatedAt?: Maybe<Scalars['String']['output']>
    /** Upsell Products */
    upsellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    urlKey: Scalars['String']['output']
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    urlPath?: Maybe<Scalars['String']['output']>
    /** URL rewrites list */
    urlRewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    urlSuffix?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    uvProtection?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    warranty?: Maybe<Scalars['Int']['output']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    wheelLights?: Maybe<Scalars['Int']['output']>
  }

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Defines a single bundle product. */
export type BundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<BundleOptionInput>>
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** The quantity and SKU of the bundle product. */
  data: CartItemInput
}

/** Defines bundle product options for `ShipmentItemInterface`. */
export type BundleShipmentItem = ShipmentItemInterface & {
  __typename?: 'BundleShipmentItem'
  /** A list of bundle options that are assigned to a shipped product. */
  bundleOptions?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output']
  /** The order item associated with the shipment item. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of shipped items. */
  quantityShipped: Scalars['Float']['output']
}

/** Defines bundle product options for `WishlistItemInterface`. */
export type BundleWishlistItem = WishlistItemInterface & {
  __typename?: 'BundleWishlistItem'
  /** The date and time the item was added to the wish list. */
  addedAt: Scalars['String']['output']
  /** An array containing information about the selected bundle items. */
  bundleOptions?: Maybe<Array<Maybe<SelectedBundleOption>>>
  /** Custom options selected for the wish list item. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output']
}

/** Contains the contents and other details about a guest or customer cart. */
export type Cart = {
  __typename?: 'Cart'
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  appliedCoupons?: Maybe<Array<Maybe<AppliedCoupon>>>
  /** An array of available payment methods. */
  availablePaymentMethods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>
  /** The billing address assigned to the cart. */
  billingAddress?: Maybe<BillingCartAddress>
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars['String']['output']>
  /** The entered gift message for the cart */
  giftMessage?: Maybe<GiftMessage>
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID']['output']
  /** Indicates whether the cart contains only virtual products. */
  isVirtual: Scalars['Boolean']['output']
  itemErrors: Array<Maybe<CartItemError>>
  items: Array<Maybe<CartItemInterface>>
  /** Last Added UID */
  lastItemUid?: Maybe<Scalars['ID']['output']>
  /** Pricing details for the quote. */
  prices?: Maybe<CartPrices>
  /** Indicates which payment method was applied to the cart. */
  selectedPaymentMethod?: Maybe<SelectedPaymentMethod>
  /** An array of shipping addresses assigned to the cart. */
  shippingAddresses: Array<Maybe<ShippingCartAddress>>
  /** The total number of items in the cart. */
  totalQuantity: Scalars['Float']['output']
}

/** Contains details the country in a billing or shipping address. */
export type CartAddressCountry = {
  __typename?: 'CartAddressCountry'
  /** The country code. */
  code: Scalars['String']['output']
  /** The display label for the country. */
  label: Scalars['String']['output']
}

/** Defines the billing or shipping address to be applied to the cart. */
export type CartAddressInput = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['input']
  /** The company specified for the billing or shipping address. */
  company?: InputMaybe<Scalars['String']['input']>
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars['String']['input']
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['input']
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['input']
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars['String']['input']>
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars['String']['input']>
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars['Int']['input']>
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars['Boolean']['input']>
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars['String']['input']>>
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars['String']['input']>
}

export type CartAddressInterface = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output']
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>
  /** An object containing the country label and code. */
  country: CartAddressCountry
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output']
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output']
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>
}

/** Contains details about the region in a billing or shipping address. */
export type CartAddressRegion = {
  __typename?: 'CartAddressRegion'
  /** The state or province code. */
  code?: Maybe<Scalars['String']['output']>
  /** The display label for the region. */
  label?: Maybe<Scalars['String']['output']>
  /** The unique ID for a pre-defined region. */
  regionId?: Maybe<Scalars['Int']['output']>
}

/** Contains information about discounts applied to the cart. */
export type CartDiscount = {
  __typename?: 'CartDiscount'
  /** The amount of the discount applied to the item. */
  amount: Money
  /** The description of the discount. */
  label: Array<Maybe<Scalars['String']['output']>>
}

export type CartItemError = {
  __typename?: 'CartItemError'
  code: CartItemErrorCode
  id: Scalars['String']['output']
  message: Scalars['String']['output']
}

export enum CartItemErrorCode {
  /** @deprecated  */
  ITEM_INCREMENTS = 'ITEM_INCREMENTS',
  /** @deprecated  */
  ITEM_QTY = 'ITEM_QTY',
  /** @deprecated  */
  NO_SUCH_PRODUCT = 'NO_SUCH_PRODUCT',
  /** @deprecated  */
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  /** @deprecated  */
  UNDEFINED = 'UNDEFINED',
  /** @deprecated  */
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

/** Defines an item to be added to the cart. */
export type CartItemInput = {
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>
  /** For a child product, the SKU of its parent product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>
  /** The amount or number of an item to add. */
  quantity: Scalars['Float']['input']
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** The SKU of the product. */
  sku: Scalars['String']['input']
}

/** An interface for products in a cart. */
export type CartItemInterface = {
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output']
  /** PreOrder info */
  preorder?: Maybe<PreOrder>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output']
}

/** Contains details about the price of the item, including taxes and discounts. */
export type CartItemPrices = {
  __typename?: 'CartItemPrices'
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** An array of FPTs applied to the cart item. */
  fixedProductTaxes?: Maybe<Array<Maybe<FixedProductTax>>>
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: Money
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  priceIncludingTax: Money
  /** The value of the price multiplied by the quantity of the item. */
  rowTotal: Money
  /** The value of `row_total` plus the tax applied to the item. */
  rowTotalIncludingTax: Money
  /** The total of all discounts applied to the item. */
  totalItemDiscount?: Maybe<Money>
}

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type CartItemQuantity = {
  __typename?: 'CartItemQuantity'
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cartItemId: Scalars['Int']['output']
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars['Float']['output']
}

/** Contains details about the price of a selected customizable value. */
export type CartItemSelectedOptionValuePrice = {
  __typename?: 'CartItemSelectedOptionValuePrice'
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: PriceTypeEnum
  /** A string that describes the unit of the value. */
  units: Scalars['String']['output']
  /** A price value. */
  value: Scalars['Float']['output']
}

/** A single item to be updated. */
export type CartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']['input']>
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']['input']>
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** Gift message details for the cart item */
  gift_message?: InputMaybe<GiftMessageInput>
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']['input']>
}

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type CartPrices = {
  __typename?: 'CartPrices'
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  appliedTaxes?: Maybe<Array<Maybe<CartTaxItem>>>
  /** @deprecated Use discounts instead. */
  discount?: Maybe<CartDiscount>
  /** An array containing all discounts applied to the cart. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The total, including discounts, taxes, shipping, and other fees. */
  grandTotal?: Maybe<Money>
  /** The subtotal without any applied taxes. */
  subtotalExcludingTax?: Maybe<Money>
  /** The subtotal including any applied taxes. */
  subtotalIncludingTax?: Maybe<Money>
  /** The subtotal with any discounts applied, but not taxes. */
  subtotalWithDiscountExcludingTax?: Maybe<Money>
}

/** Contains tax information about an item in the cart. */
export type CartTaxItem = {
  __typename?: 'CartTaxItem'
  /** The amount of tax applied to the item. */
  amount: Money
  /** The description of the tax. */
  label: Scalars['String']['output']
}

/** An error encountered while adding an item to the the cart. */
export type CartUserInputError = {
  __typename?: 'CartUserInputError'
  /** A cart-specific error code. */
  code: CartUserInputErrorType
  /** A localized error message. */
  message: Scalars['String']['output']
}

export enum CartUserInputErrorType {
  /** @deprecated  */
  INSUFFICIENT_STOCK = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NOT_SALABLE = 'NOT_SALABLE',
  /** @deprecated  */
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  UNDEFINED = 'UNDEFINED',
}

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<FilterEqualTypeInput>
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<FilterEqualTypeInput>
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<FilterEqualTypeInput>
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<FilterEqualTypeInput>
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<FilterEqualTypeInput>
}

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  availableSortBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonicalUrl?: Maybe<Scalars['String']['output']>
  childrenCount?: Maybe<Scalars['String']['output']>
  /** Contains a category CMS block. */
  cmsBlock?: Maybe<CmsBlock>
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  createdAt?: Maybe<Scalars['String']['output']>
  customLayoutUpdateFile?: Maybe<Scalars['String']['output']>
  /** The attribute to use for sorting. */
  defaultSortBy?: Maybe<Scalars['String']['output']>
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>
  displayMode?: Maybe<Scalars['String']['output']>
  filterPriceRange?: Maybe<Scalars['Float']['output']>
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>
  image?: Maybe<Scalars['String']['output']>
  includeInMenu?: Maybe<Scalars['Int']['output']>
  isAnchor?: Maybe<Scalars['Int']['output']>
  landingPage?: Maybe<Scalars['Int']['output']>
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  metaTitle?: Maybe<Scalars['String']['output']>
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>
  /** The full category path. */
  path?: Maybe<Scalars['String']['output']>
  /** The category path within the store. */
  pathInStore?: Maybe<Scalars['String']['output']>
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  productCount?: Maybe<Scalars['Int']['output']>
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>
  tweakwiseCrosssellGroupCode?: Maybe<Scalars['String']['output']>
  tweakwiseCrosssellTemplate?: Maybe<Scalars['Int']['output']>
  tweakwiseFeaturedTemplate?: Maybe<Scalars['Int']['output']>
  tweakwiseFilterValuesWhitelist?: Maybe<Scalars['String']['output']>
  tweakwiseFilterWhitelist?: Maybe<Scalars['String']['output']>
  /** Tweakwise ID */
  tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
  tweakwiseShoppingcartCrosssellGroupCode?: Maybe<Scalars['String']['output']>
  tweakwiseShoppingcartCrosssellTemplate?: Maybe<Scalars['Int']['output']>
  tweakwiseUpsellGroupCode?: Maybe<Scalars['String']['output']>
  tweakwiseUpsellTemplate?: Maybe<Scalars['Int']['output']>
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID']['output']
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updatedAt?: Maybe<Scalars['String']['output']>
  /** The URL key assigned to the category. */
  urlKey?: Maybe<Scalars['String']['output']>
  /** The URL path assigned to the category. */
  urlPath?: Maybe<Scalars['String']['output']>
  /** The part of the category URL that is appended after the url key */
  urlSuffix?: Maybe<Scalars['String']['output']>
}

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ProductAttributeSortInput>
}

/** Contains details about the products assigned to a category. */
export type CategoryProducts = {
  __typename?: 'CategoryProducts'
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>
  /** Pagination metadata. */
  pageInfo?: Maybe<SearchResultPageInfo>
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type CategoryResult = {
  __typename?: 'CategoryResult'
  /** A list of categories that match the filter criteria. */
  items?: Maybe<Array<Maybe<CategoryTree>>>
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  pageInfo?: Maybe<SearchResultPageInfo>
  /** The total number of categories that match the criteria. */
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** Contains the hierarchy of categories. */
export type CategoryTree = CategoryInterface &
  RoutableInterface & {
    __typename?: 'CategoryTree'
    availableSortBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>
    /** An array of breadcrumb items. */
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
    canonicalUrl?: Maybe<Scalars['String']['output']>
    /** A tree of child categories. */
    children?: Maybe<Array<Maybe<CategoryTree>>>
    childrenCount?: Maybe<Scalars['String']['output']>
    /** Contains a category CMS block. */
    cmsBlock?: Maybe<CmsBlock>
    /**
     * The timestamp indicating when the category was created.
     * @deprecated The field should not be used on the storefront.
     */
    createdAt?: Maybe<Scalars['String']['output']>
    customLayoutUpdateFile?: Maybe<Scalars['String']['output']>
    /** The attribute to use for sorting. */
    defaultSortBy?: Maybe<Scalars['String']['output']>
    /** An optional description of the category. */
    description?: Maybe<Scalars['String']['output']>
    displayMode?: Maybe<Scalars['String']['output']>
    /** Craft entry type */
    entryType?: Maybe<Scalars['String']['output']>
    filterPriceRange?: Maybe<Scalars['Float']['output']>
    id: Scalars['Int']['output']
    image?: Maybe<Scalars['String']['output']>
    includeInMenu?: Maybe<Scalars['Int']['output']>
    isAnchor?: Maybe<Scalars['Int']['output']>
    landingPage?: Maybe<Scalars['Int']['output']>
    /** The depth of the category within the tree. */
    level?: Maybe<Scalars['Int']['output']>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaKeywords?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    /** The full category path. */
    path?: Maybe<Scalars['String']['output']>
    /** The category path within the store. */
    pathInStore?: Maybe<Scalars['String']['output']>
    /** The position of the category relative to other categories at the same level in tree. */
    position?: Maybe<Scalars['Int']['output']>
    /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
    productCount?: Maybe<Scalars['Int']['output']>
    /** The list of products assigned to the category. */
    products?: Maybe<CategoryProducts>
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirectCode: Scalars['Int']['output']
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relativeUrl?: Maybe<Scalars['String']['output']>
    tweakwiseCrosssellGroupCode?: Maybe<Scalars['String']['output']>
    tweakwiseCrosssellTemplate?: Maybe<Scalars['Int']['output']>
    tweakwiseFeaturedTemplate?: Maybe<Scalars['Int']['output']>
    tweakwiseFilterValuesWhitelist?: Maybe<Scalars['String']['output']>
    tweakwiseFilterWhitelist?: Maybe<Scalars['String']['output']>
    /** Tweakwise ID */
    tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
    tweakwiseShoppingcartCrosssellGroupCode?: Maybe<Scalars['String']['output']>
    tweakwiseShoppingcartCrosssellTemplate?: Maybe<Scalars['Int']['output']>
    tweakwiseUpsellGroupCode?: Maybe<Scalars['String']['output']>
    tweakwiseUpsellTemplate?: Maybe<Scalars['Int']['output']>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /** The unique ID for a `CategoryInterface` object. */
    uid: Scalars['ID']['output']
    /**
     * The timestamp indicating when the category was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updatedAt?: Maybe<Scalars['String']['output']>
    urlKey: Scalars['String']['output']
    /** The URL path assigned to the category. */
    urlPath?: Maybe<Scalars['String']['output']>
    /** The part of the category URL that is appended after the url key */
    urlSuffix?: Maybe<Scalars['String']['output']>
  }

/** Contains the hierarchy of categories. */
export type CategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<ProductAttributeSortInput>
}

/** Defines details about an individual checkout agreement. */
export type CheckoutAgreement = {
  __typename?: 'CheckoutAgreement'
  /** The ID for a checkout agreement. */
  agreementId: Scalars['Int']['output']
  /** The checkbox text for the checkout agreement. */
  checkboxText: Scalars['String']['output']
  /** Required. The text of the agreement. */
  content: Scalars['String']['output']
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  contentHeight?: Maybe<Scalars['String']['output']>
  /** Indicates whether the `content` text is in HTML format. */
  isHtml: Scalars['Boolean']['output']
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: CheckoutAgreementMode
  /** The name given to the condition. */
  name: Scalars['String']['output']
}

/** Indicates how agreements are accepted. */
export enum CheckoutAgreementMode {
  /**
   * Conditions are automatically accepted upon checkout.
   * @deprecated
   */
  AUTO = 'AUTO',
  /**
   * Shoppers must manually accept the conditions to place an order.
   * @deprecated
   */
  MANUAL = 'MANUAL',
}

/** An error encountered while adding an item to the cart. */
export type CheckoutUserInputError = {
  __typename?: 'CheckoutUserInputError'
  /** An error code that is specific to Checkout. */
  code: CheckoutUserInputErrorCodes
  /** A localized error message. */
  message: Scalars['String']['output']
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars['String']['output']>>
}

export enum CheckoutUserInputErrorCodes {
  /** @deprecated  */
  INSUFFICIENT_STOCK = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NOT_SALABLE = 'NOT_SALABLE',
  /** @deprecated  */
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  REORDER_NOT_AVAILABLE = 'REORDER_NOT_AVAILABLE',
  /** @deprecated  */
  UNDEFINED = 'UNDEFINED',
}

/** Contains details about a specific CMS block. */
export type CmsBlock = {
  __typename?: 'CmsBlock'
  /** The content of the CMS block in raw HTML. */
  content?: Maybe<Scalars['String']['output']>
  /** The CMS block identifier. */
  identifier?: Maybe<Scalars['String']['output']>
  /** The title assigned to the CMS block. */
  title?: Maybe<Scalars['String']['output']>
}

/** Contains an array CMS block items. */
export type CmsBlocks = {
  __typename?: 'CmsBlocks'
  /** An array of CMS blocks. */
  items?: Maybe<Array<Maybe<CmsBlock>>>
}

/** Contains details about a CMS page. */
export type CmsPage = RoutableInterface & {
  __typename?: 'CmsPage'
  /** The content of the CMS page in raw HTML. */
  content?: Maybe<Scalars['String']['output']>
  /** The heading that displays at the top of the CMS page. */
  contentHeading?: Maybe<Scalars['String']['output']>
  /** Craft entry type */
  entryType?: Maybe<Scalars['String']['output']>
  /** The ID of a CMS page. */
  identifier?: Maybe<Scalars['String']['output']>
  /** A brief description of the page for search results listings. */
  metaDescription?: Maybe<Scalars['String']['output']>
  /** A brief description of the page for search results listings. */
  metaKeywords?: Maybe<Scalars['String']['output']>
  /** A page title that is indexed by search engines and appears in search results listings. */
  metaTitle?: Maybe<Scalars['String']['output']>
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  pageLayout?: Maybe<Scalars['String']['output']>
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode: Scalars['Int']['output']
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relativeUrl?: Maybe<Scalars['String']['output']>
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title?: Maybe<Scalars['String']['output']>
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  urlKey?: Maybe<Scalars['String']['output']>
}

/** The status of a unique_code */
export enum CodeStatus {
  /** @deprecated  */
  EXPORTED = 'EXPORTED',
  /** @deprecated  */
  NEW = 'NEW',
  /** @deprecated  */
  USED = 'USED',
}

export type ColorSwatch = {
  __typename?: 'ColorSwatch'
  type: Scalars['Int']['output']
  value: Scalars['String']['output']
}

export type ColorSwatchData = SwatchDataInterface & {
  __typename?: 'ColorSwatchData'
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>
}

export type ColorVariant = {
  __typename?: 'ColorVariant'
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>
  /** The url to the Color Variant image. If not set, the url to the thumbnail is used */
  image?: Maybe<Scalars['String']['output']>
  /** Whether the product is the current product or not. */
  isCurrent: Scalars['Boolean']['output']
  /** Whether the product is a main product or not. */
  isMainProduct: Scalars['Boolean']['output']
  /** Whether the product is salable or not. */
  isSalable: Scalars['Boolean']['output']
  /** The modelname for a color variant */
  modelName?: Maybe<Scalars['String']['output']>
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>
  /** The status of the product; `1 = enabled`, `2 = disabled`. */
  status?: Maybe<Scalars['Int']['output']>
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output']
  /** The product URL Key */
  url?: Maybe<Scalars['String']['output']>
}

export type Comment = {
  __typename?: 'Comment'
  /** Created at. */
  createdAt?: Maybe<Scalars['String']['output']>
  /** Customer id. */
  customerId?: Maybe<Scalars['Int']['output']>
  /** Email. */
  email?: Maybe<Scalars['String']['output']>
  /** Comment id. */
  id?: Maybe<Scalars['Int']['output']>
  /** Message. */
  message?: Maybe<Scalars['String']['output']>
  /** Nickname. */
  nickname?: Maybe<Scalars['String']['output']>
  /** Review id. */
  reviewId?: Maybe<Scalars['Int']['output']>
  /** Session id. */
  sessionId?: Maybe<Scalars['String']['output']>
  /** Status. */
  status?: Maybe<Scalars['Int']['output']>
  /** Store id. */
  storeId?: Maybe<Scalars['Int']['output']>
  /** Updated at. */
  updatedAt?: Maybe<Scalars['String']['output']>
}

/** Contains an attribute code that is used for product comparisons. */
export type ComparableAttribute = {
  __typename?: 'ComparableAttribute'
  /** An attribute code that is enabled for product comparisons. */
  code: Scalars['String']['output']
  /** The label of the attribute code. */
  label: Scalars['String']['output']
}

/** Defines an object used to iterate through items for product comparisons. */
export type ComparableItem = {
  __typename?: 'ComparableItem'
  /** An array of product attributes that can be used to compare products. */
  attributes: Array<Maybe<ProductAttribute>>
  /** Details about a product in a compare list. */
  product: ProductInterface
  /** The unique ID of an item in a compare list. */
  uid: Scalars['ID']['output']
}

/** Contains iterable information such as the array of items, the count, and attributes that represent the compare list. */
export type CompareList = {
  __typename?: 'CompareList'
  /** An array of attributes that can be used for comparing products. */
  attributes?: Maybe<Array<Maybe<ComparableAttribute>>>
  /** The number of items in the compare list. */
  itemCount: Scalars['Int']['output']
  /** An array of products to compare. */
  items?: Maybe<Array<Maybe<ComparableItem>>>
  /** The unique ID assigned to the compare list. */
  uid: Scalars['ID']['output']
}

export type ComplexTextValue = {
  __typename?: 'ComplexTextValue'
  /** Text that can contain HTML tags. */
  html: Scalars['String']['output']
}

/** Contains details about a configurable product attribute option. */
export type ConfigurableAttributeOption = {
  __typename?: 'ConfigurableAttributeOption'
  /** The ID assigned to the attribute. */
  code?: Maybe<Scalars['String']['output']>
  /** A string that describes the configurable attribute option. */
  label?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars['ID']['output']
  /** A unique index number assigned to the configurable product option. */
  valueIndex?: Maybe<Scalars['Int']['output']>
}

/** An implementation for configurable product cart items. */
export type ConfigurableCartItem = CartItemInterface & {
  __typename?: 'ConfigurableCartItem'
  /** An array containing the configuranle options the shopper selected. */
  configurableOptions: Array<Maybe<SelectedConfigurableOption>>
  /** Product details of the cart item. */
  configuredVariant: ProductInterface
  /** An array containing the customizable options the shopper selected. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** The entered gift message for the cart item */
  giftMessage?: Maybe<GiftMessage>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output']
  /** PreOrder info */
  preorder?: Maybe<PreOrder>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output']
}

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type ConfigurableOptionAvailableForSelection = {
  __typename?: 'ConfigurableOptionAvailableForSelection'
  /** An attribute code that uniquely identifies a configurable option. */
  attributeCode: Scalars['String']['output']
  /** An array of selectable option value IDs. */
  optionValueUids: Array<Maybe<Scalars['ID']['output']>>
}

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'ConfigurableProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    addOn?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    aerowall?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    ageRecommended?: Maybe<Scalars['Int']['output']>
    /** Ambiance Product Images */
    ambianceGallery?: Maybe<Array<Maybe<AmbianceGallery>>>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attributeSetId?: Maybe<Scalars['Int']['output']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonicalUrl?: Maybe<Scalars['String']['output']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    collaborationLicense?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    colorVariant?: Maybe<Scalars['String']['output']>
    /** Color Variants */
    colorVariants?: Maybe<Array<Maybe<ColorVariant>>>
    /** An array of options for the configurable product. */
    configurableOptions?: Maybe<Array<Maybe<ConfigurableProductOptions>>>
    /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
    configurableProductOptionsSelection?: Maybe<ConfigurableProductOptionsSelection>
    /** The product's country of origin. */
    countryOfManufacture?: Maybe<Scalars['String']['output']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    createdAt?: Maybe<Scalars['String']['output']>
    /** Crosssell Products */
    crosssellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    drive?: Maybe<Scalars['Int']['output']>
    /** Filterable attribute with Text */
    dynamicAttributes?: Maybe<Array<Maybe<DynamicAttribute>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    electricalSupport?: Maybe<Scalars['Int']['output']>
    /** Craft entry type */
    entryType?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    framePlaybase?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    frameXlGokart?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gears?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['Int']['output']>
    /** Indicates whether a gift message is available. */
    giftMessageAvailable?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gokartType?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    handbrake?: Maybe<Scalars['Int']['output']>
    /** Highlight attributes */
    highlightedAttributes?: Maybe<Array<Maybe<HighlightAttribute>>>
    /** Highlight attributes PLP */
    highlightedAttributesPlp?: Maybe<Array<Maybe<HighlightAttribute>>>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Scalars['Int']['output']
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** @deprecated Use the `custom_attributes` field instead. */
    inclSafetynet?: Maybe<Scalars['Int']['output']>
    /** Whether the product is a main product or not. */
    isMainProduct: Scalars['Boolean']['output']
    /** @deprecated Use the `custom_attributes` field instead. */
    jumpMat?: Maybe<Scalars['Int']['output']>
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxUserWeight?: Maybe<Scalars['Int']['output']>
    /** An array of media gallery objects. */
    mediaGallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    mediaGalleryEntries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    metaDescription?: Maybe<Scalars['String']['output']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    metaKeyword?: Maybe<Scalars['String']['output']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    metaTitle?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    minLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    model?: Maybe<Scalars['Int']['output']>
    /** The product name. Customers use this name to identify the product. */
    name: Scalars['String']['output']
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    newFromDate?: Maybe<Scalars['String']['output']>
    /** The end date for new product listings. */
    newToDate?: Maybe<Scalars['String']['output']>
    /** Product stock only x left count */
    onlyXLeftInStock?: Maybe<Scalars['Float']['output']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    optionsContainer?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pedals?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    playbaseSet?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    possibilityFor2ndSeat?: Maybe<Scalars['Int']['output']>
    /** PreOrder info */
    preorder?: Maybe<PreOrder>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    priceRange: PriceRange
    /** An array of `TierPrice` objects. */
    priceTiers?: Maybe<Array<Maybe<TierPrice>>>
    /** Product downloads */
    productDownloads?: Maybe<ProductDownload>
    /** An array of `ProductLinks` objects. */
    productLinks?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    productStatus?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pushRod?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityLine?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityStars?: Maybe<Scalars['Int']['output']>
    /** Review rating summary value. */
    ratingSummary?: Maybe<Scalars['Float']['output']>
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirectCode: Scalars['Int']['output']
    /** An array of products to be displayed in a Related Products block. */
    relatedProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relativeUrl?: Maybe<Scalars['String']['output']>
    /** Review amount of records. */
    reviewCount?: Maybe<Scalars['Int']['output']>
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    safetynetType?: Maybe<Scalars['Int']['output']>
    /** A short description of the product. Its use depends on the theme. */
    shortDescription?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeAirtrack?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeBeachwagon?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeClothing?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeJumpMat?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeStep?: Maybe<Scalars['Int']['output']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Scalars['String']['output']
    /** The relative path to the small image, which is used on catalog pages. */
    smallImage?: Maybe<ProductImage>
    /** Get list of spareparts per product(group), per year */
    sparepartLinks?: Maybe<Array<Maybe<BergProduct>>>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    specialFromDate?: Maybe<Scalars['String']['output']>
    /** The discounted price of the product. */
    specialPrice?: Maybe<Scalars['Float']['output']>
    /** The end date for a product with a special price. */
    specialToDate?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    springType?: Maybe<Scalars['Int']['output']>
    /** Stock status of the product */
    stockStatus?: Maybe<ProductStockStatus>
    /** The file name of a swatch image. */
    swatchImage?: Maybe<Scalars['String']['output']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrice?: Maybe<Scalars['Float']['output']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineShape?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineType?: Maybe<Scalars['Int']['output']>
    /** Tweakwise ID */
    tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
    /** PreOrder info */
    tweakwiseTemplates?: Maybe<TweakwiseTemplates>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    typeId?: Maybe<Scalars['String']['output']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']['output']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updatedAt?: Maybe<Scalars['String']['output']>
    /** Upsell Products */
    upsellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    urlKey: Scalars['String']['output']
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    urlPath?: Maybe<Scalars['String']['output']>
    /** URL rewrites list */
    urlRewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    urlSuffix?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    uvProtection?: Maybe<Scalars['Int']['output']>
    /** An array of simple product variants. */
    variants?: Maybe<Array<Maybe<ConfigurableVariant>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    warranty?: Maybe<Scalars['Int']['output']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    wheelLights?: Maybe<Scalars['Int']['output']>
  }

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductConfigurableProductOptionsSelectionArgs = {
  configurableOptionValueUids?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type ConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** The quantity and SKU of the configurable product. */
  data: CartItemInput
  /** The SKU of the parent configurable product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>
  /** Deprecated. Use `CartItemInput.sku` instead. */
  variant_sku?: InputMaybe<Scalars['String']['input']>
}

/** Contains details about configurable product options. */
export type ConfigurableProductOption = {
  __typename?: 'ConfigurableProductOption'
  /** An attribute code that uniquely identifies a configurable option. */
  attributeCode: Scalars['String']['output']
  /** The display name of the option. */
  label: Scalars['String']['output']
  /** The unique ID of the configurable option. */
  uid: Scalars['ID']['output']
  /** An array of values that are applicable for this option. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionValue>>>
}

/** Defines a value for a configurable product option. */
export type ConfigurableProductOptionValue = {
  __typename?: 'ConfigurableProductOptionValue'
  /** Indicates whether the product is available with this selected option. */
  isAvailable: Scalars['Boolean']['output']
  /** Indicates whether the value is the default. */
  isUseDefault: Scalars['Boolean']['output']
  /** The display name of the value. */
  label: Scalars['String']['output']
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch?: Maybe<SwatchDataInterface>
  /** The unique ID of the value. */
  uid: Scalars['ID']['output']
}

/** Defines configurable attributes for the specified product. */
export type ConfigurableProductOptions = {
  __typename?: 'ConfigurableProductOptions'
  /** A string that identifies the attribute. */
  attributeCode?: Maybe<Scalars['String']['output']>
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attributeId?: Maybe<Scalars['String']['output']>
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attributeIdV2?: Maybe<Scalars['Int']['output']>
  /** The unique ID for an `Attribute` object. */
  attributeUid: Scalars['ID']['output']
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>
  /** A displayed string that describes the configurable product option. */
  label?: Maybe<Scalars['String']['output']>
  /** A number that indicates the order in which the attribute is displayed. */
  position?: Maybe<Scalars['Int']['output']>
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  productId?: Maybe<Scalars['Int']['output']>
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars['ID']['output']
  /** Indicates whether the option is the default. */
  useDefault?: Maybe<Scalars['Boolean']['output']>
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>
}

/** Contains metadata corresponding to the selected configurable options. */
export type ConfigurableProductOptionsSelection = {
  __typename?: 'ConfigurableProductOptionsSelection'
  /** An array of all possible configurable options. */
  configurableOptions?: Maybe<Array<Maybe<ConfigurableProductOption>>>
  /** An array of all initial possible configurable options. */
  initialConfigurableOptions?: Maybe<Array<Maybe<ConfigurableProductOption>>>
  /** Product images and videos corresponding to the specified configurable options selection. */
  mediaGallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /** The configurable options available for further selection based on the current selection. */
  optionsAvailableForSelection?: Maybe<
    Array<Maybe<ConfigurableOptionAvailableForSelection>>
  >
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant?: Maybe<SimpleProduct>
}

/** Contains the index number assigned to a configurable product option. */
export type ConfigurableProductOptionsValues = {
  __typename?: 'ConfigurableProductOptionsValues'
  /** The label of the product on the default store. */
  defaultLabel?: Maybe<Scalars['String']['output']>
  /** The label of the product. */
  label?: Maybe<Scalars['String']['output']>
  /** The label of the product on the current store. */
  storeLabel?: Maybe<Scalars['String']['output']>
  /** Swatch data for a configurable product option. */
  swatchData?: Maybe<SwatchDataInterface>
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid?: Maybe<Scalars['ID']['output']>
  /** Indicates whether to use the default_label. */
  useDefaultValue?: Maybe<Scalars['Boolean']['output']>
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  valueIndex?: Maybe<Scalars['Int']['output']>
}

/** Contains all the simple product variants of a configurable product. */
export type ConfigurableVariant = {
  __typename?: 'ConfigurableVariant'
  /** An array of configurable attribute options. */
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>
  /** An array of linked simple products. */
  product?: Maybe<SimpleProduct>
}

/** A configurable product wish list item. */
export type ConfigurableWishlistItem = WishlistItemInterface & {
  __typename?: 'ConfigurableWishlistItem'
  /** The date and time the item was added to the wish list. */
  addedAt: Scalars['String']['output']
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  childSku: Scalars['String']['output']
  /** An array of selected configurable options. */
  configurableOptions?: Maybe<Array<Maybe<SelectedConfigurableOption>>>
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configuredVariant?: Maybe<ProductInterface>
  /** Custom options selected for the wish list item. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output']
}

export type Country = {
  __typename?: 'Country'
  /** An array of regions within a particular country. */
  availableRegions?: Maybe<Array<Maybe<Region>>>
  /** The name of the country in English. */
  fullNameEnglish?: Maybe<Scalars['String']['output']>
  /** The name of the country in the current locale. */
  fullNameLocale?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `Country` object. */
  id?: Maybe<Scalars['String']['output']>
  /** The three-letter abbreviation of the country, such as USA. */
  threeLetterAbbreviation?: Maybe<Scalars['String']['output']>
  /** The two-letter abbreviation of the country, such as US. */
  twoLetterAbbreviation?: Maybe<Scalars['String']['output']>
}

/** The list of country codes. */
export enum CountryCodeEnum {
  /**
   * Andorra
   * @deprecated
   */
  AD = 'AD',
  /**
   * United Arab Emirates
   * @deprecated
   */
  AE = 'AE',
  /**
   * Afghanistan
   * @deprecated
   */
  AF = 'AF',
  /**
   * Antigua & Barbuda
   * @deprecated
   */
  AG = 'AG',
  /**
   * Anguilla
   * @deprecated
   */
  AI = 'AI',
  /**
   * Albania
   * @deprecated
   */
  AL = 'AL',
  /**
   * Armenia
   * @deprecated
   */
  AM = 'AM',
  /**
   * Netherlands Antilles
   * @deprecated
   */
  AN = 'AN',
  /**
   * Angola
   * @deprecated
   */
  AO = 'AO',
  /**
   * Antarctica
   * @deprecated
   */
  AQ = 'AQ',
  /**
   * Argentina
   * @deprecated
   */
  AR = 'AR',
  /**
   * American Samoa
   * @deprecated
   */
  AS = 'AS',
  /**
   * Austria
   * @deprecated
   */
  AT = 'AT',
  /**
   * Australia
   * @deprecated
   */
  AU = 'AU',
  /**
   * Aruba
   * @deprecated
   */
  AW = 'AW',
  /**
   * Åland Islands
   * @deprecated
   */
  AX = 'AX',
  /**
   * Azerbaijan
   * @deprecated
   */
  AZ = 'AZ',
  /**
   * Bosnia & Herzegovina
   * @deprecated
   */
  BA = 'BA',
  /**
   * Barbados
   * @deprecated
   */
  BB = 'BB',
  /**
   * Bangladesh
   * @deprecated
   */
  BD = 'BD',
  /**
   * Belgium
   * @deprecated
   */
  BE = 'BE',
  /**
   * Burkina Faso
   * @deprecated
   */
  BF = 'BF',
  /**
   * Bulgaria
   * @deprecated
   */
  BG = 'BG',
  /**
   * Bahrain
   * @deprecated
   */
  BH = 'BH',
  /**
   * Burundi
   * @deprecated
   */
  BI = 'BI',
  /**
   * Benin
   * @deprecated
   */
  BJ = 'BJ',
  /**
   * St. Barthélemy
   * @deprecated
   */
  BL = 'BL',
  /**
   * Bermuda
   * @deprecated
   */
  BM = 'BM',
  /**
   * Brunei
   * @deprecated
   */
  BN = 'BN',
  /**
   * Bolivia
   * @deprecated
   */
  BO = 'BO',
  /**
   * Brazil
   * @deprecated
   */
  BR = 'BR',
  /**
   * Bahamas
   * @deprecated
   */
  BS = 'BS',
  /**
   * Bhutan
   * @deprecated
   */
  BT = 'BT',
  /**
   * Bouvet Island
   * @deprecated
   */
  BV = 'BV',
  /**
   * Botswana
   * @deprecated
   */
  BW = 'BW',
  /**
   * Belarus
   * @deprecated
   */
  BY = 'BY',
  /**
   * Belize
   * @deprecated
   */
  BZ = 'BZ',
  /**
   * Canada
   * @deprecated
   */
  CA = 'CA',
  /**
   * Cocos (Keeling) Islands
   * @deprecated
   */
  CC = 'CC',
  /**
   * Congo-Kinshasa
   * @deprecated
   */
  CD = 'CD',
  /**
   * Central African Republic
   * @deprecated
   */
  CF = 'CF',
  /**
   * Congo-Brazzaville
   * @deprecated
   */
  CG = 'CG',
  /**
   * Switzerland
   * @deprecated
   */
  CH = 'CH',
  /**
   * Côte d’Ivoire
   * @deprecated
   */
  CI = 'CI',
  /**
   * Cook Islands
   * @deprecated
   */
  CK = 'CK',
  /**
   * Chile
   * @deprecated
   */
  CL = 'CL',
  /**
   * Cameroon
   * @deprecated
   */
  CM = 'CM',
  /**
   * China
   * @deprecated
   */
  CN = 'CN',
  /**
   * Colombia
   * @deprecated
   */
  CO = 'CO',
  /**
   * Costa Rica
   * @deprecated
   */
  CR = 'CR',
  /**
   * Cuba
   * @deprecated
   */
  CU = 'CU',
  /**
   * Cape Verde
   * @deprecated
   */
  CV = 'CV',
  /**
   * Christmas Island
   * @deprecated
   */
  CX = 'CX',
  /**
   * Cyprus
   * @deprecated
   */
  CY = 'CY',
  /**
   * Czech Republic
   * @deprecated
   */
  CZ = 'CZ',
  /**
   * Germany
   * @deprecated
   */
  DE = 'DE',
  /**
   * Djibouti
   * @deprecated
   */
  DJ = 'DJ',
  /**
   * Denmark
   * @deprecated
   */
  DK = 'DK',
  /**
   * Dominica
   * @deprecated
   */
  DM = 'DM',
  /**
   * Dominican Republic
   * @deprecated
   */
  DO = 'DO',
  /**
   * Algeria
   * @deprecated
   */
  DZ = 'DZ',
  /**
   * Ecuador
   * @deprecated
   */
  EC = 'EC',
  /**
   * Estonia
   * @deprecated
   */
  EE = 'EE',
  /**
   * Egypt
   * @deprecated
   */
  EG = 'EG',
  /**
   * Western Sahara
   * @deprecated
   */
  EH = 'EH',
  /**
   * Eritrea
   * @deprecated
   */
  ER = 'ER',
  /**
   * Spain
   * @deprecated
   */
  ES = 'ES',
  /**
   * Ethiopia
   * @deprecated
   */
  ET = 'ET',
  /**
   * Finland
   * @deprecated
   */
  FI = 'FI',
  /**
   * Fiji
   * @deprecated
   */
  FJ = 'FJ',
  /**
   * Falkland Islands
   * @deprecated
   */
  FK = 'FK',
  /**
   * Micronesia
   * @deprecated
   */
  FM = 'FM',
  /**
   * Faroe Islands
   * @deprecated
   */
  FO = 'FO',
  /**
   * France
   * @deprecated
   */
  FR = 'FR',
  /**
   * Gabon
   * @deprecated
   */
  GA = 'GA',
  /**
   * United Kingdom
   * @deprecated
   */
  GB = 'GB',
  /**
   * Grenada
   * @deprecated
   */
  GD = 'GD',
  /**
   * Georgia
   * @deprecated
   */
  GE = 'GE',
  /**
   * French Guiana
   * @deprecated
   */
  GF = 'GF',
  /**
   * Guernsey
   * @deprecated
   */
  GG = 'GG',
  /**
   * Ghana
   * @deprecated
   */
  GH = 'GH',
  /**
   * Gibraltar
   * @deprecated
   */
  GI = 'GI',
  /**
   * Greenland
   * @deprecated
   */
  GL = 'GL',
  /**
   * Gambia
   * @deprecated
   */
  GM = 'GM',
  /**
   * Guinea
   * @deprecated
   */
  GN = 'GN',
  /**
   * Guadeloupe
   * @deprecated
   */
  GP = 'GP',
  /**
   * Equatorial Guinea
   * @deprecated
   */
  GQ = 'GQ',
  /**
   * Greece
   * @deprecated
   */
  GR = 'GR',
  /**
   * South Georgia & South Sandwich Islands
   * @deprecated
   */
  GS = 'GS',
  /**
   * Guatemala
   * @deprecated
   */
  GT = 'GT',
  /**
   * Guam
   * @deprecated
   */
  GU = 'GU',
  /**
   * Guinea-Bissau
   * @deprecated
   */
  GW = 'GW',
  /**
   * Guyana
   * @deprecated
   */
  GY = 'GY',
  /**
   * Hong Kong SAR China
   * @deprecated
   */
  HK = 'HK',
  /**
   * Heard &amp; McDonald Islands
   * @deprecated
   */
  HM = 'HM',
  /**
   * Honduras
   * @deprecated
   */
  HN = 'HN',
  /**
   * Croatia
   * @deprecated
   */
  HR = 'HR',
  /**
   * Haiti
   * @deprecated
   */
  HT = 'HT',
  /**
   * Hungary
   * @deprecated
   */
  HU = 'HU',
  /**
   * Indonesia
   * @deprecated
   */
  ID = 'ID',
  /**
   * Ireland
   * @deprecated
   */
  IE = 'IE',
  /**
   * Israel
   * @deprecated
   */
  IL = 'IL',
  /**
   * Isle of Man
   * @deprecated
   */
  IM = 'IM',
  /**
   * India
   * @deprecated
   */
  IN = 'IN',
  /**
   * British Indian Ocean Territory
   * @deprecated
   */
  IO = 'IO',
  /**
   * Iraq
   * @deprecated
   */
  IQ = 'IQ',
  /**
   * Iran
   * @deprecated
   */
  IR = 'IR',
  /**
   * Iceland
   * @deprecated
   */
  IS = 'IS',
  /**
   * Italy
   * @deprecated
   */
  IT = 'IT',
  /**
   * Jersey
   * @deprecated
   */
  JE = 'JE',
  /**
   * Jamaica
   * @deprecated
   */
  JM = 'JM',
  /**
   * Jordan
   * @deprecated
   */
  JO = 'JO',
  /**
   * Japan
   * @deprecated
   */
  JP = 'JP',
  /**
   * Kenya
   * @deprecated
   */
  KE = 'KE',
  /**
   * Kyrgyzstan
   * @deprecated
   */
  KG = 'KG',
  /**
   * Cambodia
   * @deprecated
   */
  KH = 'KH',
  /**
   * Kiribati
   * @deprecated
   */
  KI = 'KI',
  /**
   * Comoros
   * @deprecated
   */
  KM = 'KM',
  /**
   * St. Kitts & Nevis
   * @deprecated
   */
  KN = 'KN',
  /**
   * North Korea
   * @deprecated
   */
  KP = 'KP',
  /**
   * South Korea
   * @deprecated
   */
  KR = 'KR',
  /**
   * Kuwait
   * @deprecated
   */
  KW = 'KW',
  /**
   * Cayman Islands
   * @deprecated
   */
  KY = 'KY',
  /**
   * Kazakhstan
   * @deprecated
   */
  KZ = 'KZ',
  /**
   * Laos
   * @deprecated
   */
  LA = 'LA',
  /**
   * Lebanon
   * @deprecated
   */
  LB = 'LB',
  /**
   * St. Lucia
   * @deprecated
   */
  LC = 'LC',
  /**
   * Liechtenstein
   * @deprecated
   */
  LI = 'LI',
  /**
   * Sri Lanka
   * @deprecated
   */
  LK = 'LK',
  /**
   * Liberia
   * @deprecated
   */
  LR = 'LR',
  /**
   * Lesotho
   * @deprecated
   */
  LS = 'LS',
  /**
   * Lithuania
   * @deprecated
   */
  LT = 'LT',
  /**
   * Luxembourg
   * @deprecated
   */
  LU = 'LU',
  /**
   * Latvia
   * @deprecated
   */
  LV = 'LV',
  /**
   * Libya
   * @deprecated
   */
  LY = 'LY',
  /**
   * Morocco
   * @deprecated
   */
  MA = 'MA',
  /**
   * Monaco
   * @deprecated
   */
  MC = 'MC',
  /**
   * Moldova
   * @deprecated
   */
  MD = 'MD',
  /**
   * Montenegro
   * @deprecated
   */
  ME = 'ME',
  /**
   * St. Martin
   * @deprecated
   */
  MF = 'MF',
  /**
   * Madagascar
   * @deprecated
   */
  MG = 'MG',
  /**
   * Marshall Islands
   * @deprecated
   */
  MH = 'MH',
  /**
   * Macedonia
   * @deprecated
   */
  MK = 'MK',
  /**
   * Mali
   * @deprecated
   */
  ML = 'ML',
  /**
   * Myanmar (Burma)
   * @deprecated
   */
  MM = 'MM',
  /**
   * Mongolia
   * @deprecated
   */
  MN = 'MN',
  /**
   * Macau SAR China
   * @deprecated
   */
  MO = 'MO',
  /**
   * Northern Mariana Islands
   * @deprecated
   */
  MP = 'MP',
  /**
   * Martinique
   * @deprecated
   */
  MQ = 'MQ',
  /**
   * Mauritania
   * @deprecated
   */
  MR = 'MR',
  /**
   * Montserrat
   * @deprecated
   */
  MS = 'MS',
  /**
   * Malta
   * @deprecated
   */
  MT = 'MT',
  /**
   * Mauritius
   * @deprecated
   */
  MU = 'MU',
  /**
   * Maldives
   * @deprecated
   */
  MV = 'MV',
  /**
   * Malawi
   * @deprecated
   */
  MW = 'MW',
  /**
   * Mexico
   * @deprecated
   */
  MX = 'MX',
  /**
   * Malaysia
   * @deprecated
   */
  MY = 'MY',
  /**
   * Mozambique
   * @deprecated
   */
  MZ = 'MZ',
  /**
   * Namibia
   * @deprecated
   */
  NA = 'NA',
  /**
   * New Caledonia
   * @deprecated
   */
  NC = 'NC',
  /**
   * Niger
   * @deprecated
   */
  NE = 'NE',
  /**
   * Norfolk Island
   * @deprecated
   */
  NF = 'NF',
  /**
   * Nigeria
   * @deprecated
   */
  NG = 'NG',
  /**
   * Nicaragua
   * @deprecated
   */
  NI = 'NI',
  /**
   * Netherlands
   * @deprecated
   */
  NL = 'NL',
  /**
   * Norway
   * @deprecated
   */
  NO = 'NO',
  /**
   * Nepal
   * @deprecated
   */
  NP = 'NP',
  /**
   * Nauru
   * @deprecated
   */
  NR = 'NR',
  /**
   * Niue
   * @deprecated
   */
  NU = 'NU',
  /**
   * New Zealand
   * @deprecated
   */
  NZ = 'NZ',
  /**
   * Oman
   * @deprecated
   */
  OM = 'OM',
  /**
   * Panama
   * @deprecated
   */
  PA = 'PA',
  /**
   * Peru
   * @deprecated
   */
  PE = 'PE',
  /**
   * French Polynesia
   * @deprecated
   */
  PF = 'PF',
  /**
   * Papua New Guinea
   * @deprecated
   */
  PG = 'PG',
  /**
   * Philippines
   * @deprecated
   */
  PH = 'PH',
  /**
   * Pakistan
   * @deprecated
   */
  PK = 'PK',
  /**
   * Poland
   * @deprecated
   */
  PL = 'PL',
  /**
   * St. Pierre & Miquelon
   * @deprecated
   */
  PM = 'PM',
  /**
   * Pitcairn Islands
   * @deprecated
   */
  PN = 'PN',
  /**
   * Palestinian Territories
   * @deprecated
   */
  PS = 'PS',
  /**
   * Portugal
   * @deprecated
   */
  PT = 'PT',
  /**
   * Palau
   * @deprecated
   */
  PW = 'PW',
  /**
   * Paraguay
   * @deprecated
   */
  PY = 'PY',
  /**
   * Qatar
   * @deprecated
   */
  QA = 'QA',
  /**
   * Réunion
   * @deprecated
   */
  RE = 'RE',
  /**
   * Romania
   * @deprecated
   */
  RO = 'RO',
  /**
   * Serbia
   * @deprecated
   */
  RS = 'RS',
  /**
   * Russia
   * @deprecated
   */
  RU = 'RU',
  /**
   * Rwanda
   * @deprecated
   */
  RW = 'RW',
  /**
   * Saudi Arabia
   * @deprecated
   */
  SA = 'SA',
  /**
   * Solomon Islands
   * @deprecated
   */
  SB = 'SB',
  /**
   * Seychelles
   * @deprecated
   */
  SC = 'SC',
  /**
   * Sudan
   * @deprecated
   */
  SD = 'SD',
  /**
   * Sweden
   * @deprecated
   */
  SE = 'SE',
  /**
   * Singapore
   * @deprecated
   */
  SG = 'SG',
  /**
   * St. Helena
   * @deprecated
   */
  SH = 'SH',
  /**
   * Slovenia
   * @deprecated
   */
  SI = 'SI',
  /**
   * Svalbard & Jan Mayen
   * @deprecated
   */
  SJ = 'SJ',
  /**
   * Slovakia
   * @deprecated
   */
  SK = 'SK',
  /**
   * Sierra Leone
   * @deprecated
   */
  SL = 'SL',
  /**
   * San Marino
   * @deprecated
   */
  SM = 'SM',
  /**
   * Senegal
   * @deprecated
   */
  SN = 'SN',
  /**
   * Somalia
   * @deprecated
   */
  SO = 'SO',
  /**
   * Suriname
   * @deprecated
   */
  SR = 'SR',
  /**
   * São Tomé & Príncipe
   * @deprecated
   */
  ST = 'ST',
  /**
   * El Salvador
   * @deprecated
   */
  SV = 'SV',
  /**
   * Syria
   * @deprecated
   */
  SY = 'SY',
  /**
   * Swaziland
   * @deprecated
   */
  SZ = 'SZ',
  /**
   * Turks & Caicos Islands
   * @deprecated
   */
  TC = 'TC',
  /**
   * Chad
   * @deprecated
   */
  TD = 'TD',
  /**
   * French Southern Territories
   * @deprecated
   */
  TF = 'TF',
  /**
   * Togo
   * @deprecated
   */
  TG = 'TG',
  /**
   * Thailand
   * @deprecated
   */
  TH = 'TH',
  /**
   * Tajikistan
   * @deprecated
   */
  TJ = 'TJ',
  /**
   * Tokelau
   * @deprecated
   */
  TK = 'TK',
  /**
   * Timor-Leste
   * @deprecated
   */
  TL = 'TL',
  /**
   * Turkmenistan
   * @deprecated
   */
  TM = 'TM',
  /**
   * Tunisia
   * @deprecated
   */
  TN = 'TN',
  /**
   * Tonga
   * @deprecated
   */
  TO = 'TO',
  /**
   * Turkey
   * @deprecated
   */
  TR = 'TR',
  /**
   * Trinidad & Tobago
   * @deprecated
   */
  TT = 'TT',
  /**
   * Tuvalu
   * @deprecated
   */
  TV = 'TV',
  /**
   * Taiwan
   * @deprecated
   */
  TW = 'TW',
  /**
   * Tanzania
   * @deprecated
   */
  TZ = 'TZ',
  /**
   * Ukraine
   * @deprecated
   */
  UA = 'UA',
  /**
   * Uganda
   * @deprecated
   */
  UG = 'UG',
  /**
   * U.S. Outlying Islands
   * @deprecated
   */
  UM = 'UM',
  /**
   * United States
   * @deprecated
   */
  US = 'US',
  /**
   * Uruguay
   * @deprecated
   */
  UY = 'UY',
  /**
   * Uzbekistan
   * @deprecated
   */
  UZ = 'UZ',
  /**
   * Vatican City
   * @deprecated
   */
  VA = 'VA',
  /**
   * St. Vincent & Grenadines
   * @deprecated
   */
  VC = 'VC',
  /**
   * Venezuela
   * @deprecated
   */
  VE = 'VE',
  /**
   * British Virgin Islands
   * @deprecated
   */
  VG = 'VG',
  /**
   * U.S. Virgin Islands
   * @deprecated
   */
  VI = 'VI',
  /**
   * Vietnam
   * @deprecated
   */
  VN = 'VN',
  /**
   * Vanuatu
   * @deprecated
   */
  VU = 'VU',
  /**
   * Wallis & Futuna
   * @deprecated
   */
  WF = 'WF',
  /**
   * Samoa
   * @deprecated
   */
  WS = 'WS',
  /**
   * Yemen
   * @deprecated
   */
  YE = 'YE',
  /**
   * Mayotte
   * @deprecated
   */
  YT = 'YT',
  /**
   * South Africa
   * @deprecated
   */
  ZA = 'ZA',
  /**
   * Zambia
   * @deprecated
   */
  ZM = 'ZM',
  /**
   * Zimbabwe
   * @deprecated
   */
  ZW = 'ZW',
}

export type CraftAccountAccountEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftAccountAccountEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    iconLinks: Array<Maybe<CraftIconLinksSuperTableField>>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftAccountAccountEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftAccountAccountEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftAccountAccountEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftAccountAccountEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftAccountAccountEntryIconLinksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftAccountAccountEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftAccountAccountEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftAccountAccountEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftAccountAccountEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftAccountAccountEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftAccountSectionEntryUnion = CraftAccountAccountEntry

export type CraftAddress = CraftAddressInterface &
  CraftElementInterface & {
    __typename?: 'CraftAddress'
    /** First line of the address */
    addressLine1?: Maybe<Scalars['String']['output']>
    /** Second line of the address */
    addressLine2?: Maybe<Scalars['String']['output']>
    /** Administrative area. */
    administrativeArea?: Maybe<Scalars['String']['output']>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** Two-letter country code */
    countryCode: Scalars['String']['output']
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Dependent locality */
    dependentLocality?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The first name on the address. */
    firstName?: Maybe<Scalars['String']['output']>
    /** The full name on the address. */
    fullName?: Maybe<Scalars['String']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The last name on the address. */
    lastName?: Maybe<Scalars['String']['output']>
    /** Latitude */
    latitude?: Maybe<Scalars['String']['output']>
    /** Locality */
    locality?: Maybe<Scalars['String']['output']>
    /** Longitude */
    longitude?: Maybe<Scalars['String']['output']>
    /** Organization name */
    organization?: Maybe<Scalars['String']['output']>
    /** Organization tax ID */
    organizationTaxId?: Maybe<Scalars['String']['output']>
    /** The user’s photo. */
    photo?: Maybe<CraftAssetInterface>
    /** Postal code */
    postalCode?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** Sorting code */
    sortingCode?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftAddressCountArgs = {
  field: Scalars['String']['input']
}

/** This is the interface implemented by all addresses. */
export type CraftAddressInterface = {
  /** First line of the address */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** Second line of the address */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** Administrative area. */
  administrativeArea?: Maybe<Scalars['String']['output']>
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** Two-letter country code */
  countryCode: Scalars['String']['output']
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** Dependent locality */
  dependentLocality?: Maybe<Scalars['String']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The first name on the address. */
  firstName?: Maybe<Scalars['String']['output']>
  /** The full name on the address. */
  fullName?: Maybe<Scalars['String']['output']>
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The last name on the address. */
  lastName?: Maybe<Scalars['String']['output']>
  /** Latitude */
  latitude?: Maybe<Scalars['String']['output']>
  /** Locality */
  locality?: Maybe<Scalars['String']['output']>
  /** Longitude */
  longitude?: Maybe<Scalars['String']['output']>
  /** Organization name */
  organization?: Maybe<Scalars['String']['output']>
  /** Organization tax ID */
  organizationTaxId?: Maybe<Scalars['String']['output']>
  /** The user’s photo. */
  photo?: Maybe<CraftAssetInterface>
  /** Postal code */
  postalCode?: Maybe<Scalars['String']['output']>
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /** Sorting code */
  sortingCode?: Maybe<Scalars['String']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
}

/** This is the interface implemented by all addresses. */
export type CraftAddressInterfaceCountArgs = {
  field: Scalars['String']['input']
}

export type CraftAssetCriteriaInput = {
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the assets’ files’ last-modified dates. */
  dateModified?: InputMaybe<Scalars['String']['input']>
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the assets’ filenames. */
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the folders the assets belong to, per the folders’ IDs. */
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on whether the assets have alternative text. */
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the assets’ image heights. */
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  /** Broadens the query results to include assets from any of the subfolders of the folder specified by `folderId`. */
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the assets’ file kinds. */
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the assets’ file sizes (in bytes). */
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the user the assets were uploaded by, per the user’s ID. */
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the volumes the assets belong to, per the volumes’ handles. */
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the volumes the assets belong to, per the volumes’ IDs. */
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the assets’ image widths. */
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** A list of transform handles to preload. */
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterface = {
  /** Alternative text for the asset. */
  alt?: Maybe<Scalars['String']['output']>
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The file extension for the asset file. */
  extension: Scalars['String']['output']
  /** The filename of the asset file. */
  filename: Scalars['String']['output']
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
  /** The ID of the folder that the asset belongs to. */
  folderId: Scalars['Int']['output']
  /** Returns the file’s format. */
  format?: Maybe<Scalars['String']['output']>
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint: Scalars['Boolean']['output']
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']['output']>
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']['output']>
  /** The file kind. */
  kind: Scalars['String']['output']
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']['output']>
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CraftAssetInterface>
  /** The asset’s path in the volume. */
  path: Scalars['String']['output']
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CraftAssetInterface>
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']['output']>
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']['output']>
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']['output']>
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterfaceCountArgs = {
  field: Scalars['String']['input']
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterfaceFormatArgs = {
  format?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  immediately?: InputMaybe<Scalars['Boolean']['input']>
  interlace?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  transform?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterfaceHeightArgs = {
  format?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  immediately?: InputMaybe<Scalars['Boolean']['input']>
  interlace?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  transform?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterfaceNextArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterfacePrevArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterfaceSrcsetArgs = {
  sizes: Array<Scalars['String']['input']>
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterfaceUrlArgs = {
  format?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  immediately?: InputMaybe<Scalars['Boolean']['input']>
  interlace?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  transform?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

/** This is the interface implemented by all assets. */
export type CraftAssetInterfaceWidthArgs = {
  format?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  immediately?: InputMaybe<Scalars['Boolean']['input']>
  interlace?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  transform?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export type CraftBlockTitleWithStylingBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftBlockTitleWithStylingBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    fontSize?: Maybe<Scalars['String']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    text?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftBlockTitleWithStylingBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftBlockTitleWithStylingBlockTypeFontSizeArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftBlockTitleWithStylingSuperTableField =
  CraftBlockTitleWithStylingBlockType

export type CraftCategoryBannersBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftCategoryBannersBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    bannerLink?: Maybe<CraftLinkFieldLink>
    bannerTitle?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    isVisibleOnFilter?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    position?: Maybe<Scalars['CraftNumber']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftCategoryBannersBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftCategoryBannersBlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCategoryBannersSuperTableField = CraftCategoryBannersBlockType

export type CraftCategoryCategoryEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftCategoryCategoryEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftCategoryCategoryEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryCategoryEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryCategoryEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftCategoryCategoryEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryCategoryEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryCategoryEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryCategoryEntryPageBlocksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCategoryCategoryEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryCategoryEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryCriteriaInput = {
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `ancestorOf`. */
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results to only elements that are ancestors of another element in its structure, provided by its ID. */
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `descendantOf`. */
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results to only elements that are descendants of another element in its structure provided by its ID. */
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  /** Whether to only return categories that the user has permission to edit. */
  editable?: InputMaybe<Scalars['Boolean']['input']>
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the category groups the categories belong to per the group’s handles. */
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the category groups the categories belong to, per the groups’ IDs. */
  groupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on whether the elements have any descendants in their structure. */
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on whether the elements are “leaves” in their structure (element with no descendants). */
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ level within the structure. */
  level?: InputMaybe<Scalars['Int']['input']>
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results to only the entry that comes immediately after another element in its structure, provided by its ID. */
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>
  /** Narrows the query results to only entries that are positioned after another element in its structure, provided by its ID. */
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results to only entries that are positioned before another element in its structure, provided by its ID. */
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to only the entry that comes immediately before another element in its structure, provided by its ID. */
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines which structure data should be joined into the query. */
  structureId?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Explicitly determines whether the query should join in the structure data. */
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftCategoryPageContentCategoryEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftCategoryPageContentCategoryEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    categoryBanners: Array<Maybe<CraftCategoryBannersSuperTableField>>
    categoryProductPageBlocks: Array<
      Maybe<CraftCategoryProductPageBlocksMatrixField>
    >
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    quickFilters: Array<Maybe<CraftQuickFiltersSuperTableField>>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    richText1?: Maybe<Scalars['String']['output']>
    richText2?: Maybe<Scalars['String']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    title2?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftCategoryPageContentCategoryEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryEntryCategoryBannersArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCategoryPageContentCategoryEntryCategoryProductPageBlocksArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftCategoryPageContentCategoryEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftCategoryPageContentCategoryEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCategoryPageContentCategoryEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryEntryQuickFiltersArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCategoryPageContentCategoryLandingEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftCategoryPageContentCategoryLandingEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      quickFilters: Array<Maybe<CraftQuickFiltersSuperTableField>>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      richText1?: Maybe<Scalars['String']['output']>
      richText2?: Maybe<Scalars['String']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftCategoryPageContentCategoryLandingEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryLandingEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryLandingEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftCategoryPageContentCategoryLandingEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryLandingEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryLandingEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryLandingEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryLandingEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCategoryPageContentCategoryLandingEntryQuickFiltersArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCategoryPageContentSectionEntryUnion =
  | CraftCategoryPageContentCategoryEntry
  | CraftCategoryPageContentCategoryLandingEntry

export type CraftCategoryProductPageBlocksCategoryImageWithProductOverviewBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftCategoryProductPageBlocksCategoryImageWithProductOverviewBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      blockTitle?: Maybe<Scalars['String']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      items: Array<Maybe<CraftItemsSuperTableField>>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      text?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftCategoryProductPageBlocksCategoryImageWithProductOverviewBlockTypeCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftCategoryProductPageBlocksCategoryImageWithProductOverviewBlockTypeItemsArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftCategoryProductPageBlocksMatrixField =
  CraftCategoryProductPageBlocksCategoryImageWithProductOverviewBlockType

export type CraftCategorySectionEntryUnion = CraftCategoryCategoryEntry

export type CraftCheckoutFooterGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftCheckoutFooterGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    iconLinks: Array<Maybe<CraftIconLinksSuperTableField>>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftCheckoutFooterGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftCheckoutFooterGlobalSetIconLinksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCheckoutGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftCheckoutGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The name of the global set. */
    name: Scalars['String']['output']
    richText1?: Maybe<Scalars['String']['output']>
    richText2?: Maybe<Scalars['String']['output']>
    richText3?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    text1?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    title2?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftCheckoutGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftCollapsibleTextsBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftCollapsibleTextsBlockType'
    answer?: Maybe<Scalars['String']['output']>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    question?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftCollapsibleTextsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftCollapsibleTextsSuperTableField =
  CraftCollapsibleTextsBlockType

export type CraftColumnsBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftColumnsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    columnLink?: Maybe<CraftLinkFieldLink>
    columnTitle?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    specifications: Array<Maybe<CraftSpecificationsMatrixField>>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    text?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftColumnsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftColumnsBlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftColumnsBlockTypeSpecificationsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftColumnsSuperTableField = CraftColumnsBlockType

export type CraftContactContactEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftContactContactEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    richTextSimple1?: Maybe<Scalars['String']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    title2?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftContactContactEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftContactContactEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftContactContactEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftContactContactEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftContactContactEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftContactContactEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftContactContactEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftContactContactEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftContactContactEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftContactGlobalGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftContactGlobalGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    siteGlobalContact: Array<Maybe<CraftSiteGlobalContactSuperTableField>>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftContactGlobalGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftContactGlobalGlobalSetSiteGlobalContactArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftContactSectionEntryUnion = CraftContactContactEntry

export type CraftCustomerServiceFaqPageEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftCustomerServiceFaqPageEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    faqItems: Array<Maybe<CraftFaqItemsMatrixField>>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    image2: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    number?: Maybe<Scalars['CraftNumber']['output']>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftCustomerServiceFaqPageEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceFaqPageEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceFaqPageEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftCustomerServiceFaqPageEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceFaqPageEntryFaqItemsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCustomerServiceFaqPageEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCustomerServiceFaqPageEntryImage2Args = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftCustomerServiceFaqPageEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceFaqPageEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceFaqPageEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceFaqPageEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftCustomerServiceOverviewCustomerServiceOverviewEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      email?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      phoneNumber?: Maybe<Scalars['String']['output']>
      phoneNumberLink?: Maybe<CraftLinkFieldLink>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      subtitle2?: Maybe<Scalars['String']['output']>
      text1?: Maybe<Scalars['String']['output']>
      text2?: Maybe<Scalars['String']['output']>
      time1?: Maybe<Scalars['CraftDateTime']['output']>
      time2?: Maybe<Scalars['CraftDateTime']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      title2?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
      weekDays?: Maybe<Array<Maybe<Scalars['String']['output']>>>
    }

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftCustomerServiceOverviewCustomerServiceOverviewEntryWeekDaysArgs =
  {
    label?: InputMaybe<Scalars['Boolean']['input']>
  }

export type CraftCustomerServiceOverviewSectionEntryUnion =
  CraftCustomerServiceOverviewCustomerServiceOverviewEntry

export type CraftCustomerServiceSectionEntryUnion =
  CraftCustomerServiceFaqPageEntry

export type CraftDisclaimersGlobalGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftDisclaimersGlobalGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The name of the global set. */
    name: Scalars['String']['output']
    richTextSimple1?: Maybe<Scalars['String']['output']>
    richTextSimple2?: Maybe<Scalars['String']['output']>
    richTextSimple3?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftDisclaimersGlobalGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftEcommerceGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftEcommerceGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    linkField?: Maybe<CraftLinkFieldLink>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftEcommerceGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftElement = CraftElementInterface & {
  __typename?: 'CraftElement'
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
}

export type CraftElementCountArgs = {
  field: Scalars['String']['input']
}

/** This is the interface implemented by all elements. */
export type CraftElementInterface = {
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
}

/** This is the interface implemented by all elements. */
export type CraftElementInterfaceCountArgs = {
  field: Scalars['String']['input']
}

export type CraftEntryCriteriaInput = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to only entries that were posted on or after a certain date. */
  after?: InputMaybe<Scalars['String']['input']>
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `ancestorOf`. */
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results to only elements that are ancestors of another element in its structure, provided by its ID. */
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results based on the user group the entries’ authors belong to. */
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the user group the entries’ authors belong to, per the groups’ IDs. */
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the entries’ authors. */
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to only entries that were posted before a certain date. */
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `descendantOf`. */
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results to only elements that are descendants of another element in its structure provided by its ID. */
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Whether to only return entries that the user has permission to edit. */
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the entries’ expiry dates. */
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on whether the elements have any descendants in their structure. */
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on whether the elements are “leaves” in their structure (element with no descendants). */
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ level within the structure. */
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to only the entry that comes immediately after another element in its structure, provided by its ID. */
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to only entries that are positioned after another element in its structure, provided by its ID. */
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results to only entries that are positioned before another element in its structure, provided by its ID. */
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  /** Narrows the query results based on the entries’ post dates. */
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to only the entry that comes immediately before another element in its structure, provided by its ID. */
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>
  /** Narrows the query results based on the section handles the entries belong to. */
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the sections the entries belong to, per the sections’ IDs. */
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Determines which structure data should be joined into the query. */
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the entries’ entry type handles. */
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the entries’ entry types, per the types’ IDs. */
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Explicitly determines whether the query should join in the structure data. */
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterface = {
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CraftEntryInterface>
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']['output']>
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']['output']>
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children: Array<CraftEntryInterface>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CraftEntryInterface>
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']['output']>
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']['output']>
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** Whether the element is enabled for the site. */
  enabledForSite?: Maybe<Scalars['Boolean']['output']>
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']['output']>
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>
  /** The same element in other locales. */
  localized: Array<CraftEntryInterface>
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CraftEntryInterface>
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<CraftEntryInterface>
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['CraftDateTime']['output']>
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CraftEntryInterface>
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']['output']>
  /** The revision notes (from the `revisions` table). */
  revisionNotes?: Maybe<Scalars['String']['output']>
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the section that contains the entry. */
  sectionHandle: Scalars['String']['output']
  /** The ID of the section that contains the entry. */
  sectionId: Scalars['Int']['output']
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']['output']>
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The handle of the entry type that contains the entry. */
  typeHandle: Scalars['String']['output']
  /** The ID of the entry type that contains the entry. */
  typeId: Scalars['Int']['output']
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterfaceAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterfaceChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterfaceCountArgs = {
  field: Scalars['String']['input']
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterfaceDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterfaceLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterfaceNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterfaceParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

/** This is the interface implemented by all entries. */
export type CraftEntryInterfacePrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftFaqItemsFaqItemBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftFaqItemsFaqItemBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    faqTitle?: Maybe<Scalars['String']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    showOnFaqOverview?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    text?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    urlKey?: Maybe<Scalars['String']['output']>
  }

export type CraftFaqItemsFaqItemBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftFaqItemsMatrixField = CraftFaqItemsFaqItemBlockType

export type CraftFooterGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftFooterGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    linkGroups: Array<Maybe<CraftLinkGroupsMatrixField>>
    links: Array<Maybe<CraftLinksSuperTableField>>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    text1?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    title2?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftFooterGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftFooterGlobalSetLinkGroupsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftFooterGlobalSetLinksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftForgotPasswordForgotPasswordEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftForgotPasswordForgotPasswordEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    text1?: Maybe<Scalars['String']['output']>
    text2?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    title2?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftForgotPasswordForgotPasswordEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftForgotPasswordForgotPasswordEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftForgotPasswordForgotPasswordEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftForgotPasswordForgotPasswordEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftForgotPasswordForgotPasswordEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftForgotPasswordForgotPasswordEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftForgotPasswordForgotPasswordEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftForgotPasswordForgotPasswordEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftForgotPasswordSectionEntryUnion =
  CraftForgotPasswordForgotPasswordEntry

export type CraftGenericBlockLinksGenericBlockLinkEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftGenericBlockLinksGenericBlockLinkEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      linkField?: Maybe<CraftLinkFieldLink>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      text1?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftGenericBlockLinksGenericBlockLinkEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftGenericBlockLinksGenericBlockLinkEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftGenericBlockLinksGenericBlockLinkEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftGenericBlockLinksGenericBlockLinkEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftGenericBlockLinksGenericBlockLinkEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftGenericBlockLinksGenericBlockLinkEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftGenericBlockLinksGenericBlockLinkEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftGenericBlockLinksGenericBlockLinkEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftGenericBlockLinksGenericBlockLinkEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftGenericBlockLinksSectionEntryUnion =
  CraftGenericBlockLinksGenericBlockLinkEntry

/** This is the interface implemented by all global sets. */
export type CraftGlobalSetInterface = {
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The handle of the global set. */
  handle: Scalars['String']['output']
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The name of the global set. */
  name: Scalars['String']['output']
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
}

/** This is the interface implemented by all global sets. */
export type CraftGlobalSetInterfaceCountArgs = {
  field: Scalars['String']['input']
}

export type CraftHeroLinksBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftHeroLinksBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    buttonType?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    linkItem?: Maybe<CraftLinkFieldLink>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftHeroLinksBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftHeroLinksSuperTableField = CraftHeroLinksBlockType

export type CraftHomepageHomepageEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftHomepageHomepageEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    lightswitchChecked?: Maybe<Scalars['Boolean']['output']>
    lightswitchChecked2?: Maybe<Scalars['Boolean']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftHomepageHomepageEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftHomepageHomepageEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftHomepageHomepageEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftHomepageHomepageEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftHomepageHomepageEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftHomepageHomepageEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftHomepageHomepageEntryPageBlocksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftHomepageHomepageEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftHomepageHomepageEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftHomepageSectionEntryUnion = CraftHomepageHomepageEntry

export type CraftIconLinksBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftIconLinksBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    linkIcon: Array<Maybe<CraftAssetInterface>>
    linkItem?: Maybe<CraftLinkFieldLink>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftIconLinksBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftIconLinksBlockTypeLinkIconArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftIconLinksSuperTableField = CraftIconLinksBlockType

export type CraftImageWithProductOverviewsImageWithProductOverviewBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftImageWithProductOverviewsImageWithProductOverviewBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      blockTitle?: Maybe<Scalars['String']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      items: Array<Maybe<CraftItemsSuperTableField>>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      text?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftImageWithProductOverviewsImageWithProductOverviewBlockTypeCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftImageWithProductOverviewsImageWithProductOverviewBlockTypeItemsArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftImageWithProductOverviewsMatrixField =
  CraftImageWithProductOverviewsImageWithProductOverviewBlockType

export type CraftInformationBalanceBikesInformationBalanceBikesEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationBalanceBikesInformationBalanceBikesEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      informationItemShort: Array<Maybe<CraftInformationItemShortMatrixField>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      lightswitchChecked?: Maybe<Scalars['Boolean']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryInformationItemShortArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationBalanceBikesInformationBalanceBikesEntryPageBlocksArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationBalanceBikesInformationBalanceBikesEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationBalanceBikesSectionEntryUnion =
  CraftInformationBalanceBikesInformationBalanceBikesEntry

export type CraftInformationGoCartsInformationGoCartsEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationGoCartsInformationGoCartsEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      informationItemShort: Array<Maybe<CraftInformationItemShortMatrixField>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      lightswitchChecked?: Maybe<Scalars['Boolean']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationGoCartsInformationGoCartsEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationGoCartsInformationGoCartsEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationGoCartsInformationGoCartsEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInformationGoCartsInformationGoCartsEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationGoCartsInformationGoCartsEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftInformationGoCartsInformationGoCartsEntryInformationItemShortArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationGoCartsInformationGoCartsEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationGoCartsInformationGoCartsEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationGoCartsInformationGoCartsEntryPageBlocksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftInformationGoCartsInformationGoCartsEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationGoCartsInformationGoCartsEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationGoCartsSectionEntryUnion =
  CraftInformationGoCartsInformationGoCartsEntry

export type CraftInformationItemShortInformationItemFieldsBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftInformationItemShortInformationItemFieldsBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      informationSubject: Array<Maybe<CraftEntryInterface>>
      itemTitle?: Maybe<Scalars['String']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      richText?: Maybe<Scalars['String']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      showLink?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationItemShortInformationItemFieldsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInformationItemShortInformationItemFieldsBlockTypeInformationSubjectArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationItemShortMatrixField =
  CraftInformationItemShortInformationItemFieldsBlockType

export type CraftInformationItemSubjectsInformationItemSubjectEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationItemSubjectsInformationItemSubjectEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationItemSubjectsInformationItemSubjectEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationItemSubjectsInformationItemSubjectEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationItemSubjectsInformationItemSubjectEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInformationItemSubjectsInformationItemSubjectEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationItemSubjectsInformationItemSubjectEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationItemSubjectsInformationItemSubjectEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationItemSubjectsInformationItemSubjectEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationItemSubjectsInformationItemSubjectEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationItemSubjectsSectionEntryUnion =
  CraftInformationItemSubjectsInformationItemSubjectEntry

export type CraftInformationItemsBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftInformationItemsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    itemLink?: Maybe<CraftLinkFieldLink>
    itemTitle?: Maybe<Scalars['String']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    text?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    youtubeId?: Maybe<Scalars['String']['output']>
  }

export type CraftInformationItemsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInformationItemsSuperTableField =
  CraftInformationItemsBlockType

export type CraftInformationOverviewInformationOverviewEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationOverviewInformationOverviewEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationOverviewInformationOverviewEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationOverviewInformationOverviewEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationOverviewInformationOverviewEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInformationOverviewInformationOverviewEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationOverviewInformationOverviewEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftInformationOverviewInformationOverviewEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationOverviewInformationOverviewEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationOverviewInformationOverviewEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationOverviewInformationOverviewEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationOverviewSectionEntryUnion =
  CraftInformationOverviewInformationOverviewEntry

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      informationItemShort: Array<Maybe<CraftInformationItemShortMatrixField>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      lightswitchChecked?: Maybe<Scalars['Boolean']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryInformationItemShortArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryNextArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryPageBlocksArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntryPrevArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationPlaygroundEquipmentSectionEntryUnion =
  CraftInformationPlaygroundEquipmentInformationPlaygroundEquipmentEntry

export type CraftInformationRideOnCarsInformationRideOnCarsEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationRideOnCarsInformationRideOnCarsEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      informationItemShort: Array<Maybe<CraftInformationItemShortMatrixField>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      lightswitchChecked?: Maybe<Scalars['Boolean']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationRideOnCarsInformationRideOnCarsEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationRideOnCarsInformationRideOnCarsEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationRideOnCarsInformationRideOnCarsEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInformationRideOnCarsInformationRideOnCarsEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationRideOnCarsInformationRideOnCarsEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftInformationRideOnCarsInformationRideOnCarsEntryInformationItemShortArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationRideOnCarsInformationRideOnCarsEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationRideOnCarsInformationRideOnCarsEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationRideOnCarsInformationRideOnCarsEntryPageBlocksArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationRideOnCarsInformationRideOnCarsEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationRideOnCarsInformationRideOnCarsEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationRideOnCarsSectionEntryUnion =
  CraftInformationRideOnCarsInformationRideOnCarsEntry

export type CraftInformationScootersInformationScootersEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationScootersInformationScootersEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      informationItemShort: Array<Maybe<CraftInformationItemShortMatrixField>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      lightswitchChecked?: Maybe<Scalars['Boolean']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationScootersInformationScootersEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationScootersInformationScootersEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationScootersInformationScootersEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInformationScootersInformationScootersEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationScootersInformationScootersEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftInformationScootersInformationScootersEntryInformationItemShortArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationScootersInformationScootersEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationScootersInformationScootersEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationScootersInformationScootersEntryPageBlocksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftInformationScootersInformationScootersEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationScootersInformationScootersEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationScootersSectionEntryUnion =
  CraftInformationScootersInformationScootersEntry

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      number?: Maybe<Scalars['CraftNumber']['output']>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryNextArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntryPrevArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectBalanceBikesSectionEntryUnion =
  CraftInformationSubjectBalanceBikesInformationSubjectBalanceBikesEntry

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationSubjectGoCartsInformationSubjectGoCartsEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      number?: Maybe<Scalars['CraftNumber']['output']>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryNextArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectGoCartsInformationSubjectGoCartsEntryPrevArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectGoCartsSectionEntryUnion =
  CraftInformationSubjectGoCartsInformationSubjectGoCartsEntry

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      number?: Maybe<Scalars['CraftNumber']['output']>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryNextArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntryPrevArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectPlaygroundEquipmentSectionEntryUnion =
  CraftInformationSubjectPlaygroundEquipmentInformationSubjectPlaygroundEquipmentEntry

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      number?: Maybe<Scalars['CraftNumber']['output']>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryNextArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntryPrevArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectRideOnCarsSectionEntryUnion =
  CraftInformationSubjectRideOnCarsInformationSubjectRideOnCarsEntry

export type CraftInformationSubjectScootersInformationSubjectScootersEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationSubjectScootersInformationSubjectScootersEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      number?: Maybe<Scalars['CraftNumber']['output']>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryNextArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectScootersInformationSubjectScootersEntryPrevArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectScootersSectionEntryUnion =
  CraftInformationSubjectScootersInformationSubjectScootersEntry

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      number?: Maybe<Scalars['CraftNumber']['output']>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryCountArgs =
  {
    field: Scalars['String']['input']
  }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryImageArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateModified?: InputMaybe<Scalars['String']['input']>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    folderId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasAlt?: InputMaybe<Scalars['Boolean']['input']>
    height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
    kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    volumeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryNextArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryParentArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntryPrevArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationSubjectTrampolinesSectionEntryUnion =
  CraftInformationSubjectTrampolinesInformationSubjectTrampolinesEntry

export type CraftInformationTrampolinesInformationTrampolinesEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftInformationTrampolinesInformationTrampolinesEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      informationItemShort: Array<Maybe<CraftInformationItemShortMatrixField>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      lightswitchChecked?: Maybe<Scalars['Boolean']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftInformationTrampolinesInformationTrampolinesEntryAncestorsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationTrampolinesInformationTrampolinesEntryChildrenArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationTrampolinesInformationTrampolinesEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInformationTrampolinesInformationTrampolinesEntryDescendantsArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationTrampolinesInformationTrampolinesEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftInformationTrampolinesInformationTrampolinesEntryInformationItemShortArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationTrampolinesInformationTrampolinesEntryLocalizedArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftInformationTrampolinesInformationTrampolinesEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationTrampolinesInformationTrampolinesEntryPageBlocksArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftInformationTrampolinesInformationTrampolinesEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationTrampolinesInformationTrampolinesEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftInformationTrampolinesSectionEntryUnion =
  CraftInformationTrampolinesInformationTrampolinesEntry

export type CraftInstagramImagesGlobalGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftInstagramImagesGlobalGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    imageWithProductOverviews: Array<
      Maybe<CraftImageWithProductOverviewsMatrixField>
    >
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftInstagramImagesGlobalGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftInstagramImagesGlobalGlobalSetImageWithProductOverviewsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftItemsBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftItemsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    description?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    itemTitle?: Maybe<Scalars['String']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    products: Array<Maybe<CraftEntryInterface>>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftItemsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftItemsBlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftItemsBlockTypeProductsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftItemsSuperTableField = CraftItemsBlockType

/** This is the interface implemented by all links. */
export type CraftLinkFieldLink = {
  __typename?: 'CraftLinkFieldLink'
  ariaLabel?: Maybe<Scalars['String']['output']>
  customText?: Maybe<Scalars['String']['output']>
  element?: Maybe<CraftElementInterface>
  target?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type CraftLinkGroupLinksBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftLinkGroupLinksBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    linkItem?: Maybe<CraftLinkFieldLink>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftLinkGroupLinksBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftLinkGroupLinksSuperTableField = CraftLinkGroupLinksBlockType

export type CraftLinkGroupsLinkGroupBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftLinkGroupsLinkGroupBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    groupTitle?: Maybe<Scalars['String']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    links: Array<Maybe<CraftLinksSuperTableField>>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftLinkGroupsLinkGroupBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftLinkGroupsLinkGroupBlockTypeLinksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftLinkGroupsMatrixField = CraftLinkGroupsLinkGroupBlockType

export type CraftLinksBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftLinksBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    linkItem?: Maybe<CraftLinkFieldLink>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftLinksBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftLinksSuperTableField = CraftLinksBlockType

export type CraftLoginLoginEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftLoginLoginEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    richTextSimple1?: Maybe<Scalars['String']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    text1?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftLoginLoginEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftLoginLoginEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftLoginLoginEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftLoginLoginEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftLoginLoginEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftLoginLoginEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftLoginLoginEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftLoginLoginEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftLoginSectionEntryUnion = CraftLoginLoginEntry

/** This is the interface implemented by all matrix blocks. */
export type CraftMatrixBlockInterface = {
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The ID of the field that owns the matrix block. */
  fieldId: Scalars['Int']['output']
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The ID of the primary owner of the Matrix block. */
  primaryOwnerId: Scalars['Int']['output']
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The handle of the matrix block’s type. */
  typeHandle: Scalars['String']['output']
  /** The ID of the matrix block’s type. */
  typeId: Scalars['Int']['output']
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
}

/** This is the interface implemented by all matrix blocks. */
export type CraftMatrixBlockInterfaceCountArgs = {
  field: Scalars['String']['input']
}

export type CraftMediaAsset = CraftAssetInterface &
  CraftElementInterface & {
    __typename?: 'CraftMediaAsset'
    /** Alternative text for the asset. */
    alt?: Maybe<Scalars['String']['output']>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the asset file was last modified. */
    dateModified?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The file extension for the asset file. */
    extension: Scalars['String']['output']
    /** The filename of the asset file. */
    filename: Scalars['String']['output']
    /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
    focalPoint?: Maybe<Array<Maybe<Scalars['Float']['output']>>>
    /** The ID of the folder that the asset belongs to. */
    folderId: Scalars['Int']['output']
    /** Returns the file’s format. */
    format?: Maybe<Scalars['String']['output']>
    /** Whether a user-defined focal point is set on the asset. */
    hasFocalPoint: Scalars['Boolean']['output']
    /** The height in pixels or null if it’s not an image. */
    height?: Maybe<Scalars['Int']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** An `<img>` tag based on this asset. */
    img?: Maybe<Scalars['String']['output']>
    /** The file kind. */
    kind: Scalars['String']['output']
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The file’s MIME type, if it can be determined. */
    mimeType?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftAssetInterface>
    /** The asset’s path in the volume. */
    path: Scalars['String']['output']
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftAssetInterface>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The file size in bytes. */
    size?: Maybe<Scalars['String']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
    srcset?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
    url?: Maybe<Scalars['String']['output']>
    /** The ID of the volume that the asset belongs to. */
    volumeId?: Maybe<Scalars['Int']['output']>
    /** The width in pixels or null if it’s not an image. */
    width?: Maybe<Scalars['Int']['output']>
  }

export type CraftMediaAssetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftMediaAssetFormatArgs = {
  format?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  immediately?: InputMaybe<Scalars['Boolean']['input']>
  interlace?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  transform?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export type CraftMediaAssetHeightArgs = {
  format?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  immediately?: InputMaybe<Scalars['Boolean']['input']>
  interlace?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  transform?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export type CraftMediaAssetNextArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftMediaAssetPrevArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftMediaAssetSrcsetArgs = {
  sizes: Array<Scalars['String']['input']>
}

export type CraftMediaAssetUrlArgs = {
  format?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  immediately?: InputMaybe<Scalars['Boolean']['input']>
  interlace?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  transform?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export type CraftMediaAssetWidthArgs = {
  format?: InputMaybe<Scalars['String']['input']>
  handle?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  immediately?: InputMaybe<Scalars['Boolean']['input']>
  interlace?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  transform?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export type CraftMenuGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftMenuGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    links: Array<Maybe<CraftLinksSuperTableField>>
    menuItems: Array<Maybe<CraftMenuItemsMatrixField>>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftMenuGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftMenuGlobalSetImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftMenuGlobalSetLinksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftMenuGlobalSetMenuItemsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftMenuItemsMatrixField = CraftMenuItemsMenuItemBlockType

export type CraftMenuItemsMenuItemBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftMenuItemsMenuItemBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    categoryId?: Maybe<Scalars['CraftNumber']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    menuItem: Array<Maybe<CraftEntryInterface>>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftMenuItemsMenuItemBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftMenuItemsMenuItemBlockTypeMenuItemArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsMenuItemEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftMenuItemsMenuItemEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    genericBlockLink: Array<Maybe<CraftEntryInterface>>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    menuLists: Array<Maybe<CraftMenuListsMatrixField>>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftMenuItemsMenuItemEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsMenuItemEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsMenuItemEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftMenuItemsMenuItemEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsMenuItemEntryGenericBlockLinkArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsMenuItemEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftMenuItemsMenuItemEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsMenuItemEntryMenuListsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftMenuItemsMenuItemEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsMenuItemEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsMenuItemEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftMenuItemsSectionEntryUnion = CraftMenuItemsMenuItemEntry

export type CraftMenuListsMatrixField = CraftMenuListsMenuColumnBlockType

export type CraftMenuListsMenuColumnBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftMenuListsMenuColumnBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    linkGroupLinks: Array<Maybe<CraftLinkGroupLinksSuperTableField>>
    linkGroupTitle?: Maybe<Scalars['String']['output']>
    links: Array<Maybe<CraftLinksSuperTableField>>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftMenuListsMenuColumnBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftMenuListsMenuColumnBlockTypeLinkGroupLinksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftMenuListsMenuColumnBlockTypeLinksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksAccordionInformationBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftPageBlocksAccordionInformationBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      blockTitle?: Maybe<Scalars['String']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      informationItems: Array<Maybe<CraftInformationItemsSuperTableField>>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftPageBlocksAccordionInformationBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksAccordionInformationBlockTypeInformationItemsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksCompareSpecificationsBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftPageBlocksCompareSpecificationsBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      columns: Array<Maybe<CraftColumnsSuperTableField>>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      showLabels?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftPageBlocksCompareSpecificationsBlockTypeColumnsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksCompareSpecificationsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksFeaturedCategoriesBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksFeaturedCategoriesBlockType'
    anchorLinkId?: Maybe<Scalars['String']['output']>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    categories: Array<Maybe<CraftEntryInterface>>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    featuredCategoriesTitle?: Maybe<Scalars['String']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftPageBlocksFeaturedCategoriesBlockTypeCategoriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageBlocksFeaturedCategoriesBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksHeroBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksHeroBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    background: Array<Maybe<CraftAssetInterface>>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    heroLinks: Array<Maybe<CraftHeroLinksSuperTableField>>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    titleWithPartialStyling: Array<
      Maybe<CraftTitleWithPartialStylingSuperTableField>
    >
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftPageBlocksHeroBlockTypeBackgroundArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksHeroBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksHeroBlockTypeHeroLinksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksHeroBlockTypeTitleWithPartialStylingArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksHighlightBannerLinkBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftPageBlocksHighlightBannerLinkBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      fullWidth?: Maybe<Scalars['Boolean']['output']>
      highlightedItem: Array<Maybe<CraftEntryInterface>>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      showIcon?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      variant?: Maybe<Scalars['String']['output']>
    }

export type CraftPageBlocksHighlightBannerLinkBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksHighlightBannerLinkBlockTypeHighlightedItemArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageBlocksHighlightBannerLinkBlockTypeVariantArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftPageBlocksImageBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksImageBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftPageBlocksImageBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksImageBlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksImageContentBannerBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksImageContentBannerBlockType'
    anchorLinkId?: Maybe<Scalars['String']['output']>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    blockLink?: Maybe<CraftLinkFieldLink>
    colorTheme?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    imageAlignment?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    richText?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    titleWithPartialStyling: Array<
      Maybe<CraftTitleWithPartialStylingSuperTableField>
    >
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftPageBlocksImageContentBannerBlockTypeColorThemeArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftPageBlocksImageContentBannerBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksImageContentBannerBlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksImageContentBannerBlockTypeTitleWithPartialStylingArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftPageBlocksImageWithProductOverviewBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftPageBlocksImageWithProductOverviewBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      blockTitle?: Maybe<Scalars['String']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      items: Array<Maybe<CraftItemsSuperTableField>>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      text?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftPageBlocksImageWithProductOverviewBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksImageWithProductOverviewBlockTypeItemsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksMatrixField =
  | CraftPageBlocksAccordionInformationBlockType
  | CraftPageBlocksCompareSpecificationsBlockType
  | CraftPageBlocksFeaturedCategoriesBlockType
  | CraftPageBlocksHeroBlockType
  | CraftPageBlocksHighlightBannerLinkBlockType
  | CraftPageBlocksImageBlockType
  | CraftPageBlocksImageContentBannerBlockType
  | CraftPageBlocksImageWithProductOverviewBlockType
  | CraftPageBlocksNewsBlockType
  | CraftPageBlocksProductRecommendationsBlockType
  | CraftPageBlocksSimpleContentBlockType
  | CraftPageBlocksTextColumnsBlockType
  | CraftPageBlocksWizardSliderBlockType
  | CraftPageBlocksYoutubeVideoBlockType

export type CraftPageBlocksNewsBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksNewsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    newsItems: Array<Maybe<CraftEntryInterface>>
    newsSubtitle?: Maybe<Scalars['String']['output']>
    newsTitle?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftPageBlocksNewsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksNewsBlockTypeNewsItemsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageBlocksProductRecommendationsBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftPageBlocksProductRecommendationsBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      blockTitle?: Maybe<Scalars['String']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      tweakwiseTemplateId?: Maybe<Scalars['CraftNumber']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftPageBlocksProductRecommendationsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksSimpleContentBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksSimpleContentBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    blockLink?: Maybe<CraftLinkFieldLink>
    blockTitleWithStyling: Array<
      Maybe<CraftBlockTitleWithStylingSuperTableField>
    >
    containerWidth?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    readLessText?: Maybe<Scalars['String']['output']>
    readMoreLinesMobile?: Maybe<Scalars['CraftNumber']['output']>
    readMoreLinesTabletAndDesktop?: Maybe<Scalars['CraftNumber']['output']>
    readMoreMobile?: Maybe<Scalars['Boolean']['output']>
    readMoreTabletAndDesktop?: Maybe<Scalars['Boolean']['output']>
    readMoreText?: Maybe<Scalars['String']['output']>
    richText?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftPageBlocksSimpleContentBlockTypeBlockTitleWithStylingArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksSimpleContentBlockTypeContainerWidthArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftPageBlocksSimpleContentBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksTextColumnsBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksTextColumnsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    colorTheme?: Maybe<Scalars['String']['output']>
    containerWidth?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    readLessText?: Maybe<Scalars['String']['output']>
    readMoreLinesMobile?: Maybe<Scalars['CraftNumber']['output']>
    readMoreMobile?: Maybe<Scalars['Boolean']['output']>
    readMoreText?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    textColumns: Array<Maybe<CraftTextColumnsSuperTableField>>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftPageBlocksTextColumnsBlockTypeColorThemeArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftPageBlocksTextColumnsBlockTypeContainerWidthArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftPageBlocksTextColumnsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksTextColumnsBlockTypeTextColumnsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksWizardSliderBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksWizardSliderBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    blockTitle?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    text?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    wizardSteps: Array<Maybe<CraftWizardStepsSuperTableField>>
  }

export type CraftPageBlocksWizardSliderBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksWizardSliderBlockTypeWizardStepsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageBlocksYoutubeVideoBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftPageBlocksYoutubeVideoBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    placeholder: Array<Maybe<CraftAssetInterface>>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    youtubeId?: Maybe<Scalars['String']['output']>
  }

export type CraftPageBlocksYoutubeVideoBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageBlocksYoutubeVideoBlockTypePlaceholderArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageDefaultEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftPageDefaultEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    lightswitchChecked?: Maybe<Scalars['Boolean']['output']>
    lightswitchChecked2?: Maybe<Scalars['Boolean']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftPageDefaultEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageDefaultEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageDefaultEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftPageDefaultEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageDefaultEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageDefaultEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageDefaultEntryPageBlocksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftPageDefaultEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageDefaultEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftPageSectionEntryUnion = CraftPageDefaultEntry

export type CraftProductPageBlocksBlockSeparationBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftProductPageBlocksBlockSeparationBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftProductPageBlocksBlockSeparationBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductPageBlocksHighlightBannerLinkBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftProductPageBlocksHighlightBannerLinkBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      highlightedItem: Array<Maybe<CraftEntryInterface>>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      showIcon?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      variant?: Maybe<Scalars['String']['output']>
    }

export type CraftProductPageBlocksHighlightBannerLinkBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductPageBlocksHighlightBannerLinkBlockTypeHighlightedItemArgs =
  {
    address1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    address2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    after?: InputMaybe<Scalars['String']['input']>
    ancestorDist?: InputMaybe<Scalars['Int']['input']>
    ancestorOf?: InputMaybe<Scalars['Int']['input']>
    authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    authorGroupId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    authorId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    before?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    country?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    descendantDist?: InputMaybe<Scalars['Int']['input']>
    descendantOf?: InputMaybe<Scalars['Int']['input']>
    disclaimer?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    editable?: InputMaybe<Scalars['Boolean']['input']>
    email?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    genericBlockLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    image?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    image2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    latitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    leaves?: InputMaybe<Scalars['Boolean']['input']>
    level?: InputMaybe<Scalars['Int']['input']>
    lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
    lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    linkField?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    longitude?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaDescription?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    metaTitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
    number?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    phoneNumber?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    phoneNumberLink?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    positionedAfter?: InputMaybe<Scalars['Int']['input']>
    positionedBefore?: InputMaybe<Scalars['Int']['input']>
    postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
    productTypes?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    richText1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richText2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    richTextSimple4?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    search?: InputMaybe<Scalars['String']['input']>
    section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    sectionId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    show?: InputMaybe<Scalars['Boolean']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    storeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    structureId?: InputMaybe<Scalars['Int']['input']>
    subtitle?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    subtitle2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    text2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time1?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    time2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title2?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    title3?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    website?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    weekDays?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    withStructure?: InputMaybe<Scalars['Boolean']['input']>
    zipcode?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
  }

export type CraftProductPageBlocksHighlightBannerLinkBlockTypeVariantArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftProductPageBlocksImageContentBannerBlockType =
  CraftElementInterface &
    CraftMatrixBlockInterface & {
      __typename?: 'CraftProductPageBlocksImageContentBannerBlockType'
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** The ID of the field that owns the matrix block. */
      fieldId: Scalars['Int']['output']
      genericItem: Array<Maybe<CraftEntryInterface>>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The ID of the primary owner of the Matrix block. */
      primaryOwnerId: Scalars['Int']['output']
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /** The sort order of the matrix block within the owner element field. */
      sortOrder?: Maybe<Scalars['Int']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the matrix block’s type. */
      typeHandle: Scalars['String']['output']
      /** The ID of the matrix block’s type. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
    }

export type CraftProductPageBlocksImageContentBannerBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductPageBlocksImageContentBannerBlockTypeGenericItemArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageBlocksImageContentBannerBlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftProductPageBlocksMatrixField =
  | CraftProductPageBlocksBlockSeparationBlockType
  | CraftProductPageBlocksHighlightBannerLinkBlockType
  | CraftProductPageBlocksImageContentBannerBlockType
  | CraftProductPageBlocksUspsBlockType

export type CraftProductPageBlocksUspsBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftProductPageBlocksUspsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    blockTitle?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    genericItems: Array<Maybe<CraftEntryInterface>>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftProductPageBlocksUspsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductPageBlocksUspsBlockTypeGenericItemsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageContentContentBlocksEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftProductPageContentContentBlocksEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    productPageBlocks: Array<Maybe<CraftProductPageBlocksMatrixField>>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
    usps: Array<Maybe<CraftUspsSuperTableField>>
  }

export type CraftProductPageContentContentBlocksEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageContentContentBlocksEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageContentContentBlocksEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductPageContentContentBlocksEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageContentContentBlocksEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageContentContentBlocksEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageContentContentBlocksEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageContentContentBlocksEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageContentContentBlocksEntryProductPageBlocksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftProductPageContentContentBlocksEntryUspsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftProductPageContentSectionEntryUnion =
  CraftProductPageContentContentBlocksEntry

export type CraftProductPageGenericItemsImageContentItemEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftProductPageGenericItemsImageContentItemEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      text1?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftProductPageGenericItemsImageContentItemEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsImageContentItemEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsImageContentItemEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductPageGenericItemsImageContentItemEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsImageContentItemEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsImageContentItemEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsImageContentItemEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsImageContentItemEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsSectionEntryUnion =
  | CraftProductPageGenericItemsImageContentItemEntry
  | CraftProductPageGenericItemsUspEntry

export type CraftProductPageGenericItemsUspEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftProductPageGenericItemsUspEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    text1?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftProductPageGenericItemsUspEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsUspEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsUspEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductPageGenericItemsUspEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsUspEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftProductPageGenericItemsUspEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsUspEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsUspEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductPageGenericItemsUspEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductRegistrationProductRegistrationEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftProductRegistrationProductRegistrationEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      collapsibleTexts: Array<Maybe<CraftCollapsibleTextsSuperTableField>>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      richText1?: Maybe<Scalars['String']['output']>
      richTextSimple1?: Maybe<Scalars['String']['output']>
      richTextSimple2?: Maybe<Scalars['String']['output']>
      richTextSimple3?: Maybe<Scalars['String']['output']>
      richTextSimple4?: Maybe<Scalars['String']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      subtitle2?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      title2?: Maybe<Scalars['String']['output']>
      title3?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftProductRegistrationProductRegistrationEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductRegistrationProductRegistrationEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductRegistrationProductRegistrationEntryCollapsibleTextsArgs =
  {
    dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
    inReverse?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    preferSites?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    primaryOwnerId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    relatedTo?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAll?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
    relatedToCategories?: InputMaybe<
      Array<InputMaybe<CraftCategoryCriteriaInput>>
    >
    relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
    relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
    relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
    search?: InputMaybe<Scalars['String']['input']>
    site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    siteId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    siteSettingsId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    typeId?: InputMaybe<
      Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
    >
    uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    unique?: InputMaybe<Scalars['Boolean']['input']>
    uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  }

export type CraftProductRegistrationProductRegistrationEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductRegistrationProductRegistrationEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductRegistrationProductRegistrationEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftProductRegistrationProductRegistrationEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductRegistrationProductRegistrationEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductRegistrationProductRegistrationEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductRegistrationProductRegistrationEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductRegistrationSectionEntryUnion =
  CraftProductRegistrationProductRegistrationEntry

export type CraftProductTypesProductTypeEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftProductTypesProductTypeEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    lightswitchUnchecked?: Maybe<Scalars['Boolean']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftProductTypesProductTypeEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductTypesProductTypeEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductTypesProductTypeEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductTypesProductTypeEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductTypesProductTypeEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductTypesProductTypeEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductTypesProductTypeEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductTypesProductTypeEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductTypesSectionEntryUnion =
  CraftProductTypesProductTypeEntry

export type CraftProductsProductEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftProductsProductEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    text1?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftProductsProductEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductsProductEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductsProductEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftProductsProductEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductsProductEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductsProductEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductsProductEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductsProductEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftProductsSectionEntryUnion = CraftProductsProductEntry

export type CraftQuickFiltersBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftQuickFiltersBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    filterLink?: Maybe<CraftLinkFieldLink>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    quickFilterName?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftQuickFiltersBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftQuickFiltersBlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftQuickFiltersSuperTableField = CraftQuickFiltersBlockType

export type CraftRequestLicensePlateRequestLicensePlateEntry =
  CraftElementInterface &
    CraftEntryInterface & {
      __typename?: 'CraftRequestLicensePlateRequestLicensePlateEntry'
      /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
      ancestors: Array<CraftEntryInterface>
      /** Whether the element is archived. */
      archived?: Maybe<Scalars['Boolean']['output']>
      /** Returns the entry’s canonical ID. */
      canonicalId?: Maybe<Scalars['Int']['output']>
      /** Returns the entry’s canonical UUID. */
      canonicalUid?: Maybe<Scalars['String']['output']>
      /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
      children: Array<CraftEntryInterface>
      /** Return a number of related elements for a field. */
      count?: Maybe<Scalars['Int']['output']>
      /** The date the element was created. */
      dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The date the element was last updated. */
      dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
      /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
      descendants: Array<CraftEntryInterface>
      /** The draft ID (from the `drafts` table). */
      draftId?: Maybe<Scalars['Int']['output']>
      /** The name of the draft. */
      draftName?: Maybe<Scalars['String']['output']>
      /** The notes for the draft. */
      draftNotes?: Maybe<Scalars['String']['output']>
      /** Whether the element is enabled. */
      enabled?: Maybe<Scalars['Boolean']['output']>
      /** Whether the element is enabled for the site. */
      enabledForSite?: Maybe<Scalars['Boolean']['output']>
      /** The expiry date of the entry. */
      expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** The ID of the entity */
      id?: Maybe<Scalars['ID']['output']>
      image: Array<Maybe<CraftAssetInterface>>
      /** Returns whether this is a draft. */
      isDraft?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is a revision. */
      isRevision?: Maybe<Scalars['Boolean']['output']>
      /** Returns whether this is an unpublished draft. */
      isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
      /** The language of the site element is associated with. */
      language?: Maybe<Scalars['String']['output']>
      /** The element’s level within its structure */
      level?: Maybe<Scalars['Int']['output']>
      /** The element’s left position within its structure. */
      lft?: Maybe<Scalars['Int']['output']>
      /** The same element in other locales. */
      localized: Array<CraftEntryInterface>
      metaDescription?: Maybe<Scalars['String']['output']>
      metaTitle?: Maybe<Scalars['String']['output']>
      /** Returns the next element relative to this one, from a given set of criteria. */
      next?: Maybe<CraftEntryInterface>
      /** The entry’s parent, if the section is a structure. */
      parent?: Maybe<CraftEntryInterface>
      /** The entry’s post date. */
      postDate?: Maybe<Scalars['CraftDateTime']['output']>
      /** Returns the previous element relative to this one, from a given set of criteria. */
      prev?: Maybe<CraftEntryInterface>
      /** The revision ID (from the `revisions` table). */
      revisionId?: Maybe<Scalars['Int']['output']>
      /** The revision notes (from the `revisions` table). */
      revisionNotes?: Maybe<Scalars['String']['output']>
      /** The element’s right position within its structure. */
      rgt?: Maybe<Scalars['Int']['output']>
      richText1?: Maybe<Scalars['String']['output']>
      richText2?: Maybe<Scalars['String']['output']>
      /** The element’s structure’s root ID */
      root?: Maybe<Scalars['Int']['output']>
      /** The element’s search score, if the `search` parameter was used when querying for the element. */
      searchScore?: Maybe<Scalars['Int']['output']>
      /** The handle of the section that contains the entry. */
      sectionHandle: Scalars['String']['output']
      /** The ID of the section that contains the entry. */
      sectionId: Scalars['Int']['output']
      /** The handle of the site the element is associated with. */
      siteHandle?: Maybe<Scalars['String']['output']>
      /** The ID of the site the element is associated with. */
      siteId?: Maybe<Scalars['Int']['output']>
      /** The unique identifier for an element-site relation. */
      siteSettingsId?: Maybe<Scalars['ID']['output']>
      /** The element’s slug. */
      slug?: Maybe<Scalars['String']['output']>
      /**
       * Returns the entry’s canonical ID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
       */
      sourceId?: Maybe<Scalars['Int']['output']>
      /**
       * Returns the entry’s canonical UUID.
       * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
       */
      sourceUid?: Maybe<Scalars['String']['output']>
      /** The element’s status. */
      status?: Maybe<Scalars['String']['output']>
      /** The element’s structure ID. */
      structureId?: Maybe<Scalars['Int']['output']>
      subtitle?: Maybe<Scalars['String']['output']>
      subtitle2?: Maybe<Scalars['String']['output']>
      text1?: Maybe<Scalars['String']['output']>
      text2?: Maybe<Scalars['String']['output']>
      /** The element’s title. */
      title?: Maybe<Scalars['String']['output']>
      title2?: Maybe<Scalars['String']['output']>
      title3?: Maybe<Scalars['String']['output']>
      /** Whether the element has been soft-deleted. */
      trashed?: Maybe<Scalars['Boolean']['output']>
      /** The handle of the entry type that contains the entry. */
      typeHandle: Scalars['String']['output']
      /** The ID of the entry type that contains the entry. */
      typeId: Scalars['Int']['output']
      /** The UID of the entity */
      uid?: Maybe<Scalars['String']['output']>
      /** The element’s URI. */
      uri?: Maybe<Scalars['String']['output']>
      /** The element’s full URL */
      url?: Maybe<Scalars['String']['output']>
    }

export type CraftRequestLicensePlateRequestLicensePlateEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftRequestLicensePlateRequestLicensePlateEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftRequestLicensePlateRequestLicensePlateEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftRequestLicensePlateRequestLicensePlateEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftRequestLicensePlateRequestLicensePlateEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftRequestLicensePlateRequestLicensePlateEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftRequestLicensePlateRequestLicensePlateEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftRequestLicensePlateRequestLicensePlateEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftRequestLicensePlateRequestLicensePlateEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftRequestLicensePlateSectionEntryUnion =
  CraftRequestLicensePlateRequestLicensePlateEntry

export type CraftReviewReviewEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftReviewReviewEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    richTextSimple1?: Maybe<Scalars['String']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftReviewReviewEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftReviewReviewEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftReviewReviewEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftReviewReviewEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftReviewReviewEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftReviewReviewEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftReviewReviewEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftReviewReviewEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftReviewSectionEntryUnion = CraftReviewReviewEntry

export type CraftSearchSearchEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftSearchSearchEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    pageBlocks: Array<Maybe<CraftPageBlocksMatrixField>>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftSearchSearchEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSearchSearchEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSearchSearchEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftSearchSearchEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSearchSearchEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSearchSearchEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSearchSearchEntryPageBlocksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftSearchSearchEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSearchSearchEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSearchSectionEntryUnion = CraftSearchSearchEntry

export type CraftSeoGlobalGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftSeoGlobalGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaKeywords?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftSeoGlobalGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftSiteGlobalContactBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftSiteGlobalContactBlockType'
    addressLocality?: Maybe<Scalars['String']['output']>
    addressPostalCode?: Maybe<Scalars['String']['output']>
    addressStreet?: Maybe<Scalars['String']['output']>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    emailCustomerService?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    facebook?: Maybe<CraftLinkFieldLink>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    instagram?: Maybe<CraftLinkFieldLink>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    linkedin?: Maybe<CraftLinkFieldLink>
    organizationUrl?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    telephoneCustomerService?: Maybe<Scalars['String']['output']>
    telephoneHeadquarters?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    youtube?: Maybe<CraftLinkFieldLink>
  }

export type CraftSiteGlobalContactBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftSiteGlobalContactSuperTableField =
  CraftSiteGlobalContactBlockType

export type CraftSparepartsSectionEntryUnion = CraftSparepartsSparepartsEntry

export type CraftSparepartsSparepartsEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftSparepartsSparepartsEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    richText1?: Maybe<Scalars['String']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftSparepartsSparepartsEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSparepartsSparepartsEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSparepartsSparepartsEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftSparepartsSparepartsEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSparepartsSparepartsEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftSparepartsSparepartsEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSparepartsSparepartsEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSparepartsSparepartsEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSparepartsSparepartsEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftSpecificationsMatrixField =
  CraftSpecificationsSpecificationBlockType

export type CraftSpecificationsSpecificationBlockType = CraftElementInterface &
  CraftMatrixBlockInterface & {
    __typename?: 'CraftSpecificationsSpecificationBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the matrix block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Matrix block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the matrix block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    specificationLabel?: Maybe<Scalars['String']['output']>
    specificationValue?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the matrix block’s type. */
    typeHandle: Scalars['String']['output']
    /** The ID of the matrix block’s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftSpecificationsSpecificationBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftStoreLocatorSectionEntryUnion =
  CraftStoreLocatorStoreLocatorEntry

export type CraftStoreLocatorStoreLocatorEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftStoreLocatorStoreLocatorEntry'
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    disclaimer?: Maybe<Scalars['String']['output']>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    genericBlockLink: Array<Maybe<CraftEntryInterface>>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    subtitle?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
  }

export type CraftStoreLocatorStoreLocatorEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoreLocatorStoreLocatorEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoreLocatorStoreLocatorEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftStoreLocatorStoreLocatorEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoreLocatorStoreLocatorEntryGenericBlockLinkArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoreLocatorStoreLocatorEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftStoreLocatorStoreLocatorEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoreLocatorStoreLocatorEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoreLocatorStoreLocatorEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoreLocatorStoreLocatorEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoresSectionEntryUnion = CraftStoresStoreEntry

export type CraftStoresStoreEntry = CraftElementInterface &
  CraftEntryInterface & {
    __typename?: 'CraftStoresStoreEntry'
    address1?: Maybe<Scalars['String']['output']>
    address2?: Maybe<Scalars['String']['output']>
    /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
    ancestors: Array<CraftEntryInterface>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Returns the entry’s canonical ID. */
    canonicalId?: Maybe<Scalars['Int']['output']>
    /** Returns the entry’s canonical UUID. */
    canonicalUid?: Maybe<Scalars['String']['output']>
    /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
    children: Array<CraftEntryInterface>
    city?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    country?: Maybe<Scalars['String']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
    descendants: Array<CraftEntryInterface>
    /** The draft ID (from the `drafts` table). */
    draftId?: Maybe<Scalars['Int']['output']>
    /** The name of the draft. */
    draftName?: Maybe<Scalars['String']['output']>
    /** The notes for the draft. */
    draftNotes?: Maybe<Scalars['String']['output']>
    email?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** Whether the element is enabled for the site. */
    enabledForSite?: Maybe<Scalars['Boolean']['output']>
    /** The expiry date of the entry. */
    expiryDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** Returns whether this is a draft. */
    isDraft?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is a revision. */
    isRevision?: Maybe<Scalars['Boolean']['output']>
    /** Returns whether this is an unpublished draft. */
    isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    latitude?: Maybe<Scalars['CraftNumber']['output']>
    /** The element’s level within its structure */
    level?: Maybe<Scalars['Int']['output']>
    /** The element’s left position within its structure. */
    lft?: Maybe<Scalars['Int']['output']>
    /** The same element in other locales. */
    localized: Array<CraftEntryInterface>
    longitude?: Maybe<Scalars['CraftNumber']['output']>
    metaDescription?: Maybe<Scalars['String']['output']>
    metaTitle?: Maybe<Scalars['String']['output']>
    /** Returns the next element relative to this one, from a given set of criteria. */
    next?: Maybe<CraftEntryInterface>
    /** The entry’s parent, if the section is a structure. */
    parent?: Maybe<CraftEntryInterface>
    phoneNumber?: Maybe<Scalars['String']['output']>
    phoneNumberLink?: Maybe<CraftLinkFieldLink>
    /** The entry’s post date. */
    postDate?: Maybe<Scalars['CraftDateTime']['output']>
    /** Returns the previous element relative to this one, from a given set of criteria. */
    prev?: Maybe<CraftEntryInterface>
    productTypes: Array<Maybe<CraftEntryInterface>>
    /** The revision ID (from the `revisions` table). */
    revisionId?: Maybe<Scalars['Int']['output']>
    /** The revision notes (from the `revisions` table). */
    revisionNotes?: Maybe<Scalars['String']['output']>
    /** The element’s right position within its structure. */
    rgt?: Maybe<Scalars['Int']['output']>
    /** The element’s structure’s root ID */
    root?: Maybe<Scalars['Int']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the section that contains the entry. */
    sectionHandle: Scalars['String']['output']
    /** The ID of the section that contains the entry. */
    sectionId: Scalars['Int']['output']
    show?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /**
     * Returns the entry’s canonical ID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
     */
    sourceId?: Maybe<Scalars['Int']['output']>
    /**
     * Returns the entry’s canonical UUID.
     * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
     */
    sourceUid?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    storeId?: Maybe<Scalars['String']['output']>
    /** The element’s structure ID. */
    structureId?: Maybe<Scalars['Int']['output']>
    text1?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the entry type that contains the entry. */
    typeHandle: Scalars['String']['output']
    /** The ID of the entry type that contains the entry. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The element’s full URL */
    url?: Maybe<Scalars['String']['output']>
    website?: Maybe<Scalars['String']['output']>
    zipcode?: Maybe<Scalars['String']['output']>
  }

export type CraftStoresStoreEntryAncestorsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoresStoreEntryChildrenArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoresStoreEntryCountArgs = {
  field: Scalars['String']['input']
}

export type CraftStoresStoreEntryDescendantsArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoresStoreEntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftStoresStoreEntryLocalizedArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoresStoreEntryNextArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoresStoreEntryParentArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoresStoreEntryPrevArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type CraftStoresStoreEntryProductTypesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

/** This is the interface implemented by all Super Table blocks. */
export type CraftSuperTableBlockInterface = {
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The ID of the field that owns the Super Table block. */
  fieldId: Scalars['Int']['output']
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The ID of the primary owner of the Super Table block. */
  primaryOwnerId: Scalars['Int']['output']
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /** The sort order of the Super Table block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The ID of the Super Table block‘s type. */
  typeId: Scalars['Int']['output']
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
}

/** This is the interface implemented by all Super Table blocks. */
export type CraftSuperTableBlockInterfaceCountArgs = {
  field: Scalars['String']['input']
}

export type CraftTagCriteriaInput = {
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the tag groups the tags belong to per the group’s handles. */
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the tag groups the tags belong to, per the groups’ IDs. */
  groupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftTextColumnsBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftTextColumnsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    columnTitle?: Maybe<Scalars['String']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    text?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftTextColumnsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftTextColumnsSuperTableField = CraftTextColumnsBlockType

export type CraftTitleWithPartialStylingBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftTitleWithPartialStylingBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    fontSize?: Maybe<Scalars['String']['output']>
    fontWeight?: Maybe<Scalars['String']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    startOnNewLine?: Maybe<Scalars['Boolean']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    text?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    uppercase?: Maybe<Scalars['Boolean']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftTitleWithPartialStylingBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftTitleWithPartialStylingBlockTypeFontSizeArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftTitleWithPartialStylingBlockTypeFontWeightArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>
}

export type CraftTitleWithPartialStylingSuperTableField =
  CraftTitleWithPartialStylingBlockType

export type CraftUser = CraftElementInterface &
  CraftUserInterface & {
    __typename?: 'CraftUser'
    /** The user’s addresses. */
    addresses?: Maybe<Array<Maybe<CraftAddressInterface>>>
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The user’s email. */
    email?: Maybe<Scalars['String']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The user’s first name. */
    firstName?: Maybe<Scalars['String']['output']>
    /** The user’s first name or username. */
    friendlyName?: Maybe<Scalars['String']['output']>
    /** The user’s full name. */
    fullName?: Maybe<Scalars['String']['output']>
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The user’s last name. */
    lastName?: Maybe<Scalars['String']['output']>
    /** The user’s full name or username. */
    name: Scalars['String']['output']
    /** The user’s photo. */
    photo?: Maybe<CraftAssetInterface>
    /** The user’s preferences. */
    preferences: Scalars['String']['output']
    /** The user’s preferred language. */
    preferredLanguage?: Maybe<Scalars['String']['output']>
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    /** The username. */
    username?: Maybe<Scalars['String']['output']>
  }

export type CraftUserAddressesArgs = {
  administrativeArea?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  ownerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftUserCountArgs = {
  field: Scalars['String']['input']
}

export type CraftUserCriteriaInput = {
  /** Narrows the query results based on whether the users have uploaded any assets. */
  assetUploaders?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on whether the users are listed as the author of any entries. */
  authors?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the users’ email addresses. */
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the users’ first names. */
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the users’ full names. */
  fullName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the user group the users belong to. */
  group?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the user group the users belong to, per the groups’ IDs. */
  groupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to only users that have (or don’t have) a user photo. */
  hasPhoto?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the users’ last names. */
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Narrows the query results based on the users’ usernames. */
  username?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** This is the interface implemented by all users. */
export type CraftUserInterface = {
  /** The user’s addresses. */
  addresses?: Maybe<Array<Maybe<CraftAddressInterface>>>
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>
  /** Return a number of related elements for a field. */
  count?: Maybe<Scalars['Int']['output']>
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
  /** The user’s email. */
  email?: Maybe<Scalars['String']['output']>
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>
  /** The user’s first name. */
  firstName?: Maybe<Scalars['String']['output']>
  /** The user’s first name or username. */
  friendlyName?: Maybe<Scalars['String']['output']>
  /** The user’s full name. */
  fullName?: Maybe<Scalars['String']['output']>
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>
  /** The user’s last name. */
  lastName?: Maybe<Scalars['String']['output']>
  /** The user’s full name or username. */
  name: Scalars['String']['output']
  /** The user’s photo. */
  photo?: Maybe<CraftAssetInterface>
  /** The user’s preferences. */
  preferences: Scalars['String']['output']
  /** The user’s preferred language. */
  preferredLanguage?: Maybe<Scalars['String']['output']>
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>
  /** The username. */
  username?: Maybe<Scalars['String']['output']>
}

/** This is the interface implemented by all users. */
export type CraftUserInterfaceAddressesArgs = {
  administrativeArea?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  ownerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** This is the interface implemented by all users. */
export type CraftUserInterfaceCountArgs = {
  field: Scalars['String']['input']
}

export type CraftUspsBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftUspsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    showIcon?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    uspItem?: Maybe<Scalars['String']['output']>
  }

export type CraftUspsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftUspsGlobalGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftUspsGlobalGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    usps: Array<Maybe<CraftUspsSuperTableField>>
  }

export type CraftUspsGlobalGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftUspsGlobalGlobalSetUspsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftUspsProductPageGlobalSet = CraftElementInterface &
  CraftGlobalSetInterface & {
    __typename?: 'CraftUspsProductPageGlobalSet'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The handle of the global set. */
    handle: Scalars['String']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The name of the global set. */
    name: Scalars['String']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
    usps: Array<Maybe<CraftUspsSuperTableField>>
  }

export type CraftUspsProductPageGlobalSetCountArgs = {
  field: Scalars['String']['input']
}

export type CraftUspsProductPageGlobalSetUspsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fieldId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  primaryOwnerId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftUspsSuperTableField = CraftUspsBlockType

export type CraftWizardStepsBlockType = CraftElementInterface &
  CraftSuperTableBlockInterface & {
    __typename?: 'CraftWizardStepsBlockType'
    /** Whether the element is archived. */
    archived?: Maybe<Scalars['Boolean']['output']>
    /** Return a number of related elements for a field. */
    count?: Maybe<Scalars['Int']['output']>
    /** The date the element was created. */
    dateCreated?: Maybe<Scalars['CraftDateTime']['output']>
    /** The date the element was last updated. */
    dateUpdated?: Maybe<Scalars['CraftDateTime']['output']>
    /** Whether the element is enabled. */
    enabled?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the field that owns the Super Table block. */
    fieldId: Scalars['Int']['output']
    /** The ID of the entity */
    id?: Maybe<Scalars['ID']['output']>
    image: Array<Maybe<CraftAssetInterface>>
    /** The language of the site element is associated with. */
    language?: Maybe<Scalars['String']['output']>
    /** The ID of the primary owner of the Super Table block. */
    primaryOwnerId: Scalars['Int']['output']
    /** The element’s search score, if the `search` parameter was used when querying for the element. */
    searchScore?: Maybe<Scalars['Int']['output']>
    /** The handle of the site the element is associated with. */
    siteHandle?: Maybe<Scalars['String']['output']>
    /** The ID of the site the element is associated with. */
    siteId?: Maybe<Scalars['Int']['output']>
    /** The unique identifier for an element-site relation. */
    siteSettingsId?: Maybe<Scalars['ID']['output']>
    /** The element’s slug. */
    slug?: Maybe<Scalars['String']['output']>
    /** The sort order of the Super Table block within the owner element field. */
    sortOrder?: Maybe<Scalars['Int']['output']>
    /** The element’s status. */
    status?: Maybe<Scalars['String']['output']>
    stepTitle?: Maybe<Scalars['String']['output']>
    text?: Maybe<Scalars['String']['output']>
    /** The element’s title. */
    title?: Maybe<Scalars['String']['output']>
    /** Whether the element has been soft-deleted. */
    trashed?: Maybe<Scalars['Boolean']['output']>
    /** The ID of the Super Table block‘s type. */
    typeId: Scalars['Int']['output']
    /** The UID of the entity */
    uid?: Maybe<Scalars['String']['output']>
    /** The element’s URI. */
    uri?: Maybe<Scalars['String']['output']>
  }

export type CraftWizardStepsBlockTypeCountArgs = {
  field: Scalars['String']['input']
}

export type CraftWizardStepsBlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CraftWizardStepsSuperTableField = CraftWizardStepsBlockType

/** Contains an array of product IDs to use for creating a compare list. */
export type CreateCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

/** Assigns a specific `cart_id` to the empty cart. */
export type CreateEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id?: InputMaybe<Scalars['String']['input']>
}

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type CreatePayflowProTokenOutput = {
  __typename?: 'CreatePayflowProTokenOutput'
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  responseMessage: Scalars['String']['output']
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int']['output']
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  resultCode: Scalars['Int']['output']
  /** A secure token generated by PayPal. */
  secureToken: Scalars['String']['output']
  /** A secure token ID generated by PayPal. */
  secureTokenId: Scalars['String']['output']
}

/** Defines a new product review. */
export type CreateProductReviewInput = {
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String']['input']
  /** The ratings details by category. For example, Price: 5 stars, Quality: 4 stars, etc. */
  ratings: Array<InputMaybe<ProductReviewRatingInput>>
  /** The SKU of the reviewed product. */
  sku: Scalars['String']['input']
  /** The summary (title) of the review. */
  summary: Scalars['String']['input']
  /** The review text. */
  text: Scalars['String']['input']
}

/** Contains the completed product review. */
export type CreateProductReviewOutput = {
  __typename?: 'CreateProductReviewOutput'
  /** Product review details. */
  review: ProductReview
}

/** Required fields for Payflow Pro and Payments Pro credit card payments. */
export type CreditCardDetailsInput = {
  /** The credit card expiration month. */
  cc_exp_month: Scalars['Int']['input']
  /** The credit card expiration year. */
  cc_exp_year: Scalars['Int']['input']
  /** The last 4 digits of the credit card. */
  cc_last_4: Scalars['Int']['input']
  /** The credit card type. */
  cc_type: Scalars['String']['input']
}

/** Contains credit memo details. */
export type CreditMemo = {
  __typename?: 'CreditMemo'
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID']['output']
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>
  /** The sequential credit memo number. */
  number: Scalars['String']['output']
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>
}

export type CreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'CreditMemoItem'
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output']
  /** The order item the credit memo is applied to. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product, including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of refunded items. */
  quantityRefunded?: Maybe<Scalars['Float']['output']>
}

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output']
  /** The order item the credit memo is applied to. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product, including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of refunded items. */
  quantityRefunded?: Maybe<Scalars['Float']['output']>
}

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  __typename?: 'CreditMemoTotal'
  /** An adjustment manually applied to the order. */
  adjustment: Money
  /** The final base grand total amount in the base currency. */
  baseGrandTotal: Money
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The final total amount, including shipping, discounts, and taxes. */
  grandTotal: Money
  /** Details about the shipping and handling costs for the credit memo. */
  shippingHandling?: Maybe<ShippingHandling>
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>
  /** The shipping amount for the credit memo. */
  totalShipping: Money
  /** The amount of tax applied to the credit memo. */
  totalTax: Money
}

export type Currency = {
  __typename?: 'Currency'
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  availableCurrencyCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The base currency set for the store, such as USD. */
  baseCurrencyCode?: Maybe<Scalars['String']['output']>
  /** The symbol for the specified base currency, such as $. */
  baseCurrencySymbol?: Maybe<Scalars['String']['output']>
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  defaultDisplayCurrecyCode?: Maybe<Scalars['String']['output']>
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  defaultDisplayCurrecySymbol?: Maybe<Scalars['String']['output']>
  /** The currency that is displayed by default, such as USD. */
  defaultDisplayCurrencyCode?: Maybe<Scalars['String']['output']>
  /** The currency symbol that is displayed by default, such as $. */
  defaultDisplayCurrencySymbol?: Maybe<Scalars['String']['output']>
  /** An array of exchange rates for currencies defined in the store. */
  exchangeRates?: Maybe<Array<Maybe<ExchangeRate>>>
}

/** The list of available currency codes. */
export enum CurrencyEnum {
  /** @deprecated  */
  AED = 'AED',
  /** @deprecated  */
  AFN = 'AFN',
  /** @deprecated  */
  ALL = 'ALL',
  /** @deprecated  */
  AMD = 'AMD',
  /** @deprecated  */
  ANG = 'ANG',
  /** @deprecated  */
  AOA = 'AOA',
  /** @deprecated  */
  ARS = 'ARS',
  /** @deprecated  */
  AUD = 'AUD',
  /** @deprecated  */
  AWG = 'AWG',
  /** @deprecated  */
  AZM = 'AZM',
  /** @deprecated  */
  AZN = 'AZN',
  /** @deprecated  */
  BAM = 'BAM',
  /** @deprecated  */
  BBD = 'BBD',
  /** @deprecated  */
  BDT = 'BDT',
  /** @deprecated  */
  BGN = 'BGN',
  /** @deprecated  */
  BHD = 'BHD',
  /** @deprecated  */
  BIF = 'BIF',
  /** @deprecated  */
  BMD = 'BMD',
  /** @deprecated  */
  BND = 'BND',
  /** @deprecated  */
  BOB = 'BOB',
  /** @deprecated  */
  BRL = 'BRL',
  /** @deprecated  */
  BSD = 'BSD',
  /** @deprecated  */
  BTN = 'BTN',
  /** @deprecated  */
  BUK = 'BUK',
  /** @deprecated  */
  BWP = 'BWP',
  /** @deprecated  */
  BYN = 'BYN',
  /** @deprecated  */
  BZD = 'BZD',
  /** @deprecated  */
  CAD = 'CAD',
  /** @deprecated  */
  CDF = 'CDF',
  /** @deprecated  */
  CHE = 'CHE',
  /** @deprecated  */
  CHF = 'CHF',
  /** @deprecated  */
  CHW = 'CHW',
  /** @deprecated  */
  CLP = 'CLP',
  /** @deprecated  */
  CNY = 'CNY',
  /** @deprecated  */
  COP = 'COP',
  /** @deprecated  */
  CRC = 'CRC',
  /** @deprecated  */
  CUP = 'CUP',
  /** @deprecated  */
  CVE = 'CVE',
  /** @deprecated  */
  CZK = 'CZK',
  /** @deprecated  */
  DJF = 'DJF',
  /** @deprecated  */
  DKK = 'DKK',
  /** @deprecated  */
  DOP = 'DOP',
  /** @deprecated  */
  DZD = 'DZD',
  /** @deprecated  */
  EEK = 'EEK',
  /** @deprecated  */
  EGP = 'EGP',
  /** @deprecated  */
  ERN = 'ERN',
  /** @deprecated  */
  ETB = 'ETB',
  /** @deprecated  */
  EUR = 'EUR',
  /** @deprecated  */
  FJD = 'FJD',
  /** @deprecated  */
  FKP = 'FKP',
  /** @deprecated  */
  GBP = 'GBP',
  /** @deprecated  */
  GEK = 'GEK',
  /** @deprecated  */
  GEL = 'GEL',
  /** @deprecated  */
  GHS = 'GHS',
  /** @deprecated  */
  GIP = 'GIP',
  /** @deprecated  */
  GMD = 'GMD',
  /** @deprecated  */
  GNF = 'GNF',
  /** @deprecated  */
  GQE = 'GQE',
  /** @deprecated  */
  GTQ = 'GTQ',
  /** @deprecated  */
  GYD = 'GYD',
  /** @deprecated  */
  HKD = 'HKD',
  /** @deprecated  */
  HNL = 'HNL',
  /** @deprecated  */
  HRK = 'HRK',
  /** @deprecated  */
  HTG = 'HTG',
  /** @deprecated  */
  HUF = 'HUF',
  /** @deprecated  */
  IDR = 'IDR',
  /** @deprecated  */
  ILS = 'ILS',
  /** @deprecated  */
  INR = 'INR',
  /** @deprecated  */
  IQD = 'IQD',
  /** @deprecated  */
  IRR = 'IRR',
  /** @deprecated  */
  ISK = 'ISK',
  /** @deprecated  */
  JMD = 'JMD',
  /** @deprecated  */
  JOD = 'JOD',
  /** @deprecated  */
  JPY = 'JPY',
  /** @deprecated  */
  KES = 'KES',
  /** @deprecated  */
  KGS = 'KGS',
  /** @deprecated  */
  KHR = 'KHR',
  /** @deprecated  */
  KMF = 'KMF',
  /** @deprecated  */
  KPW = 'KPW',
  /** @deprecated  */
  KRW = 'KRW',
  /** @deprecated  */
  KWD = 'KWD',
  /** @deprecated  */
  KYD = 'KYD',
  /** @deprecated  */
  KZT = 'KZT',
  /** @deprecated  */
  LAK = 'LAK',
  /** @deprecated  */
  LBP = 'LBP',
  /** @deprecated  */
  LKR = 'LKR',
  /** @deprecated  */
  LRD = 'LRD',
  /** @deprecated  */
  LSL = 'LSL',
  /** @deprecated  */
  LSM = 'LSM',
  /** @deprecated  */
  LTL = 'LTL',
  /** @deprecated  */
  LVL = 'LVL',
  /** @deprecated  */
  LYD = 'LYD',
  /** @deprecated  */
  MAD = 'MAD',
  /** @deprecated  */
  MDL = 'MDL',
  /** @deprecated  */
  MGA = 'MGA',
  /** @deprecated  */
  MKD = 'MKD',
  /** @deprecated  */
  MMK = 'MMK',
  /** @deprecated  */
  MNT = 'MNT',
  /** @deprecated  */
  MOP = 'MOP',
  /** @deprecated  */
  MRO = 'MRO',
  /** @deprecated  */
  MUR = 'MUR',
  /** @deprecated  */
  MVR = 'MVR',
  /** @deprecated  */
  MWK = 'MWK',
  /** @deprecated  */
  MXN = 'MXN',
  /** @deprecated  */
  MYR = 'MYR',
  /** @deprecated  */
  MZN = 'MZN',
  /** @deprecated  */
  NAD = 'NAD',
  /** @deprecated  */
  NGN = 'NGN',
  /** @deprecated  */
  NIC = 'NIC',
  /** @deprecated  */
  NOK = 'NOK',
  /** @deprecated  */
  NPR = 'NPR',
  /** @deprecated  */
  NZD = 'NZD',
  /** @deprecated  */
  OMR = 'OMR',
  /** @deprecated  */
  PAB = 'PAB',
  /** @deprecated  */
  PEN = 'PEN',
  /** @deprecated  */
  PGK = 'PGK',
  /** @deprecated  */
  PHP = 'PHP',
  /** @deprecated  */
  PKR = 'PKR',
  /** @deprecated  */
  PLN = 'PLN',
  /** @deprecated  */
  PYG = 'PYG',
  /** @deprecated  */
  QAR = 'QAR',
  /** @deprecated  */
  RHD = 'RHD',
  /** @deprecated  */
  ROL = 'ROL',
  /** @deprecated  */
  RON = 'RON',
  /** @deprecated  */
  RSD = 'RSD',
  /** @deprecated  */
  RUB = 'RUB',
  /** @deprecated  */
  RWF = 'RWF',
  /** @deprecated  */
  SAR = 'SAR',
  /** @deprecated  */
  SBD = 'SBD',
  /** @deprecated  */
  SCR = 'SCR',
  /** @deprecated  */
  SDG = 'SDG',
  /** @deprecated  */
  SEK = 'SEK',
  /** @deprecated  */
  SGD = 'SGD',
  /** @deprecated  */
  SHP = 'SHP',
  /** @deprecated  */
  SKK = 'SKK',
  /** @deprecated  */
  SLL = 'SLL',
  /** @deprecated  */
  SOS = 'SOS',
  /** @deprecated  */
  SRD = 'SRD',
  /** @deprecated  */
  STD = 'STD',
  /** @deprecated  */
  SVC = 'SVC',
  /** @deprecated  */
  SYP = 'SYP',
  /** @deprecated  */
  SZL = 'SZL',
  /** @deprecated  */
  THB = 'THB',
  /** @deprecated  */
  TJS = 'TJS',
  /** @deprecated  */
  TMM = 'TMM',
  /** @deprecated  */
  TND = 'TND',
  /** @deprecated  */
  TOP = 'TOP',
  /** @deprecated  */
  TRL = 'TRL',
  /** @deprecated  */
  TRY = 'TRY',
  /** @deprecated  */
  TTD = 'TTD',
  /** @deprecated  */
  TWD = 'TWD',
  /** @deprecated  */
  TZS = 'TZS',
  /** @deprecated  */
  UAH = 'UAH',
  /** @deprecated  */
  UGX = 'UGX',
  /** @deprecated  */
  USD = 'USD',
  /** @deprecated  */
  UYU = 'UYU',
  /** @deprecated  */
  UZS = 'UZS',
  /** @deprecated  */
  VEB = 'VEB',
  /** @deprecated  */
  VEF = 'VEF',
  /** @deprecated  */
  VND = 'VND',
  /** @deprecated  */
  VUV = 'VUV',
  /** @deprecated  */
  WST = 'WST',
  /** @deprecated  */
  XCD = 'XCD',
  /** @deprecated  */
  XOF = 'XOF',
  /** @deprecated  */
  XPF = 'XPF',
  /** @deprecated  */
  YER = 'YER',
  /** @deprecated  */
  YTL = 'YTL',
  /** @deprecated  */
  ZAR = 'ZAR',
  /** @deprecated  */
  ZMK = 'ZMK',
  /** @deprecated  */
  ZWD = 'ZWD',
}

/** Defines an array of custom attributes. */
export type CustomAttributeMetadata = {
  __typename?: 'CustomAttributeMetadata'
  /** An array of attributes. */
  items?: Maybe<Array<Maybe<Attribute>>>
}

/** Defines the customer name, addresses, and other details. */
export type Customer = {
  __typename?: 'Customer'
  /** An array containing the customer's shipping and billing addresses. */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>
  /** The contents of the customer's compare list. */
  compareList?: Maybe<CompareList>
  /** Timestamp indicating when the account was created. */
  createdAt?: Maybe<Scalars['String']['output']>
  /** The customer's date of birth. */
  dateOfBirth?: Maybe<Scalars['String']['output']>
  /** The ID assigned to the billing address. */
  defaultBilling?: Maybe<Scalars['String']['output']>
  /** The ID assigned to the shipping address. */
  defaultShipping?: Maybe<Scalars['String']['output']>
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob?: Maybe<Scalars['String']['output']>
  /** The customer's email address. Required. */
  email?: Maybe<Scalars['String']['output']>
  /** The customer's first name. */
  firstname?: Maybe<Scalars['String']['output']>
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: Maybe<Scalars['Int']['output']>
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  groupId?: Maybe<Scalars['Int']['output']>
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  isSubscribed?: Maybe<Scalars['Boolean']['output']>
  /** The customer's family name. */
  lastname?: Maybe<Scalars['String']['output']>
  /** The customer's middle name. */
  middlename?: Maybe<Scalars['String']['output']>
  orders?: Maybe<CustomerOrders>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>
  /** Contains the customer's product reviews. */
  reviews: ProductReviews
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat?: Maybe<Scalars['String']['output']>
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: Wishlist
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlistV2?: Maybe<Wishlist>
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<Wishlist>>
}

/** Defines the customer name, addresses, and other details. */
export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<CustomerOrdersFilterInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Defines the customer name, addresses, and other details. */
export type CustomerReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Defines the customer name, addresses, and other details. */
export type CustomerWishlistV2Args = {
  id: Scalars['ID']['input']
}

/** Defines the customer name, addresses, and other details. */
export type CustomerWishlistsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Contains detailed information about a customer's billing or shipping address. */
export type CustomerAddress = {
  __typename?: 'CustomerAddress'
  /** The customer's city or town. */
  city?: Maybe<Scalars['String']['output']>
  /** The customer's company. */
  company?: Maybe<Scalars['String']['output']>
  /** The customer's country. */
  countryCode?: Maybe<CountryCodeEnum>
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  countryId?: Maybe<Scalars['String']['output']>
  /** @deprecated Custom attributes should not be put into a container. */
  customAttributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customerId?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the address is the customer's default billing address. */
  defaultBilling?: Maybe<Scalars['Boolean']['output']>
  /** Indicates whether the address is the customer's default shipping address. */
  defaultShipping?: Maybe<Scalars['Boolean']['output']>
  /** Contains any extension attributes for the address. */
  extensionAttributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']['output']>
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars['String']['output']>
  /** The ID of a `CustomerAddress` object. */
  id?: Maybe<Scalars['Int']['output']>
  /** The family name of the person associated with the shipping/billing address. */
  lastname?: Maybe<Scalars['String']['output']>
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']['output']>
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']['output']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<CustomerAddressRegion>
  /** The unique ID for a pre-defined region. */
  regionId?: Maybe<Scalars['Int']['output']>
  /** An array of strings that define the street number and name. */
  street?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']['output']>
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vatId?: Maybe<Scalars['String']['output']>
}

/** Specifies the attribute code and value of a customer address attribute. */
export type CustomerAddressAttribute = {
  __typename?: 'CustomerAddressAttribute'
  /** The name assigned to the customer address attribute. */
  attributeCode?: Maybe<Scalars['String']['output']>
  /** The valuue assigned to the customer address attribute. */
  value?: Maybe<Scalars['String']['output']>
}

/** Specifies the attribute code and value of a customer attribute. */
export type CustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars['String']['input']
  /** The value assigned to the attribute. */
  value: Scalars['String']['input']
}

/** Contains details about a billing or shipping address. */
export type CustomerAddressInput = {
  /** The customer's city or town. */
  city?: InputMaybe<Scalars['String']['input']>
  /** The customer's company. */
  company?: InputMaybe<Scalars['String']['input']>
  /** The two-letter code representing the customer's country. */
  country_code?: InputMaybe<CountryCodeEnum>
  /** Deprecated: use `country_code` instead. */
  country_id?: InputMaybe<CountryCodeEnum>
  /** Deprecated: Custom attributes should not be put into container. */
  custom_attributes?: InputMaybe<
    Array<InputMaybe<CustomerAddressAttributeInput>>
  >
  /** Indicates whether the address is the default billing address. */
  default_billing?: InputMaybe<Scalars['Boolean']['input']>
  /** Indicates whether the address is the default shipping address. */
  default_shipping?: InputMaybe<Scalars['Boolean']['input']>
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']['input']>
  /** The first name of the person associated with the billing/shipping address. */
  firstname?: InputMaybe<Scalars['String']['input']>
  /** The family name of the person associated with the billing/shipping address. */
  lastname?: InputMaybe<Scalars['String']['input']>
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']['input']>
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']['input']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>
  /** An array of strings that define the street number and name. */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>
  /** The customer's telephone number. */
  telephone?: InputMaybe<Scalars['String']['input']>
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id?: InputMaybe<Scalars['String']['input']>
}

/** Defines the customer's state or province. */
export type CustomerAddressRegion = {
  __typename?: 'CustomerAddressRegion'
  /** The state or province name. */
  region?: Maybe<Scalars['String']['output']>
  /** The address region code. */
  regionCode?: Maybe<Scalars['String']['output']>
  /** The unique ID for a pre-defined region. */
  regionId?: Maybe<Scalars['Int']['output']>
}

/** Defines the customer's state or province. */
export type CustomerAddressRegionInput = {
  /** The state or province name. */
  region?: InputMaybe<Scalars['String']['input']>
  /** The address region code. */
  region_code?: InputMaybe<Scalars['String']['input']>
  /** The unique ID for a pre-defined region. */
  region_id?: InputMaybe<Scalars['Int']['input']>
}

/** An input object for creating a customer. */
export type CustomerCreateInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']['input']>
  /** The customer's email address. */
  email: Scalars['String']['input']
  /** The customer's first name. */
  firstname: Scalars['String']['input']
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>
  /** The customer's family name. */
  lastname: Scalars['String']['input']
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']['input']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>
}

/** Contains details about a single downloadable product. */
export type CustomerDownloadableProduct = {
  __typename?: 'CustomerDownloadableProduct'
  /** The date and time the purchase was made. */
  date?: Maybe<Scalars['String']['output']>
  /** The fully qualified URL to the download file. */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** The unique ID assigned to the item. */
  orderIncrementId?: Maybe<Scalars['String']['output']>
  /** The remaining number of times the customer can download the product. */
  remainingDownloads?: Maybe<Scalars['String']['output']>
  /** Indicates when the product becomes available for download. Options are `Pending` and `Invoiced`. */
  status?: Maybe<Scalars['String']['output']>
}

/** Contains a list of downloadable products. */
export type CustomerDownloadableProducts = {
  __typename?: 'CustomerDownloadableProducts'
  /** An array of purchased downloadable items. */
  items?: Maybe<Array<Maybe<CustomerDownloadableProduct>>>
}

/** An input object that assigns or updates customer attributes. */
export type CustomerInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']['input']>
  /** The customer's email address. Required when creating a customer. */
  email?: InputMaybe<Scalars['String']['input']>
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']['input']>
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']['input']>
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']['input']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>
}

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  __typename?: 'CustomerOrder'
  /** The billing address for the order. */
  billingAddress?: Maybe<OrderAddress>
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']['output']>
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>
  /** The coupon code that is used */
  couponCode?: Maybe<Scalars['String']['output']>
  /** @deprecated Use the `order_date` field instead. */
  createdAt?: Maybe<Scalars['String']['output']>
  /** A list of credit memos. */
  creditMemos?: Maybe<Array<Maybe<CreditMemo>>>
  /** The entered gift message for the order */
  giftMessage?: Maybe<GiftMessage>
  /** @deprecated Use the `totals.grand_total` field instead. */
  grandTotal?: Maybe<Scalars['Float']['output']>
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID']['output']
  /** @deprecated Use the `id` field instead. */
  incrementId?: Maybe<Scalars['String']['output']>
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>
  /** Indicates whether the order can be returned */
  isReturnable: Scalars['Boolean']['output']
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>
  /** The order number. */
  number: Scalars['String']['output']
  /** The date the order was placed. */
  orderDate: Scalars['String']['output']
  /** @deprecated Use the `number` field instead. */
  orderNumber: Scalars['String']['output']
  /** Payment details for the order. */
  paymentMethods?: Maybe<Array<Maybe<OrderPaymentMethod>>>
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>
  /** The shipping address for the order. */
  shippingAddress?: Maybe<OrderAddress>
  /** The delivery method for the order. */
  shippingMethod?: Maybe<Scalars['String']['output']>
  /** The current status of the order. */
  status: Scalars['String']['output']
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>
}

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  __typename?: 'CustomerOrders'
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>
  /** Contains pagination metadata. */
  pageInfo?: Maybe<SearchResultPageInfo>
  /** The total count of customer orders. */
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>
}

/** Contains details about a newly-created or updated customer. */
export type CustomerOutput = {
  __typename?: 'CustomerOutput'
  /** Customer details after creating or updating a customer. */
  customer: Customer
}

/** Contains payment tokens stored in the customer's vault. */
export type CustomerPaymentTokens = {
  __typename?: 'CustomerPaymentTokens'
  /** An array of payment tokens. */
  items: Array<Maybe<PaymentToken>>
}

/** Contains a customer authorization token. */
export type CustomerToken = {
  __typename?: 'CustomerToken'
  /** Refresh token to generate a new token for the customer before it expires. */
  refreshToken?: Maybe<Scalars['String']['output']>
  /** The customer authorization token. */
  token?: Maybe<Scalars['String']['output']>
}

/** An input object for updating a customer. */
export type CustomerUpdateInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']['input']>
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']['input']>
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']['input']>
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>
}

/** Contains information about a text area that is defined as part of a customizable option. */
export type CustomizableAreaOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableAreaOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** The Stock Keeping Unit of the base product. */
  productSku?: Maybe<Scalars['String']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
  /** An object that defines a text area. */
  value?: Maybe<CustomizableAreaValue>
}

/** Defines the price and sku of a product whose page contains a customized text area. */
export type CustomizableAreaValue = {
  __typename?: 'CustomizableAreaValue'
  /** The maximum number of characters that can be entered for this customizable option. */
  maxCharacters?: Maybe<Scalars['Int']['output']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars['ID']['output']
}

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type CustomizableCheckboxOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableCheckboxOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
  /** An array that defines a set of checkbox values. */
  value?: Maybe<Array<Maybe<CustomizableCheckboxValue>>>
}

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type CustomizableCheckboxValue = {
  __typename?: 'CustomizableCheckboxValue'
  /** The ID assigned to the value. */
  optionTypeId?: Maybe<Scalars['Int']['output']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>
  /** The order in which the checkbox value is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars['ID']['output']
}

/** Contains information about a date picker that is defined as part of a customizable option. */
export type CustomizableDateOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDateOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** The Stock Keeping Unit of the base product. */
  productSku?: Maybe<Scalars['String']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
  /** An object that defines a date field in a customizable option. */
  value?: Maybe<CustomizableDateValue>
}

/** Defines the customizable date type. */
export enum CustomizableDateTypeEnum {
  /** @deprecated  */
  DATE = 'DATE',
  /** @deprecated  */
  DATE_TIME = 'DATE_TIME',
  /** @deprecated  */
  TIME = 'TIME',
}

/** Defines the price and sku of a product whose page contains a customized date picker. */
export type CustomizableDateValue = {
  __typename?: 'CustomizableDateValue'
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>
  /** DATE, DATE_TIME or TIME */
  type?: Maybe<CustomizableDateTypeEnum>
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars['ID']['output']
}

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type CustomizableDropDownOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDropDownOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
  /** An array that defines the set of options for a drop down menu. */
  value?: Maybe<Array<Maybe<CustomizableDropDownValue>>>
}

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type CustomizableDropDownValue = {
  __typename?: 'CustomizableDropDownValue'
  /** The ID assigned to the value. */
  optionTypeId?: Maybe<Scalars['Int']['output']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars['ID']['output']
}

/** Contains information about a text field that is defined as part of a customizable option. */
export type CustomizableFieldOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFieldOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** The Stock Keeping Unit of the base product. */
  productSku?: Maybe<Scalars['String']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
  /** An object that defines a text field. */
  value?: Maybe<CustomizableFieldValue>
}

/** Defines the price and sku of a product whose page contains a customized text field. */
export type CustomizableFieldValue = {
  __typename?: 'CustomizableFieldValue'
  /** The maximum number of characters that can be entered for this customizable option. */
  maxCharacters?: Maybe<Scalars['Int']['output']>
  /** The price of the custom value. */
  price?: Maybe<Scalars['Float']['output']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars['ID']['output']
}

/** Contains information about a file picker that is defined as part of a customizable option. */
export type CustomizableFileOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFileOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** The Stock Keeping Unit of the base product. */
  productSku?: Maybe<Scalars['String']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
  /** An object that defines a file value. */
  value?: Maybe<CustomizableFileValue>
}

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type CustomizableFileValue = {
  __typename?: 'CustomizableFileValue'
  /** The file extension to accept. */
  fileExtension?: Maybe<Scalars['String']['output']>
  /** The maximum width of an image. */
  imageSizeX?: Maybe<Scalars['Int']['output']>
  /** The maximum height of an image. */
  imageSizeY?: Maybe<Scalars['Int']['output']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars['ID']['output']
}

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type CustomizableMultipleOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableMultipleOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
  /** An array that defines the set of options for a multiselect. */
  value?: Maybe<Array<Maybe<CustomizableMultipleValue>>>
}

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type CustomizableMultipleValue = {
  __typename?: 'CustomizableMultipleValue'
  /** The ID assigned to the value. */
  optionTypeId?: Maybe<Scalars['Int']['output']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars['ID']['output']
}

/** Defines a customizable option. */
export type CustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id?: InputMaybe<Scalars['Int']['input']>
  /** The string value of the option. */
  value_string: Scalars['String']['input']
}

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
}

/** Contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
}

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type CustomizableRadioOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableRadioOption'
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  optionId?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>
  /** The order in which the option is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output']
  /** An array that defines a set of radio buttons. */
  value?: Maybe<Array<Maybe<CustomizableRadioValue>>>
}

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type CustomizableRadioValue = {
  __typename?: 'CustomizableRadioValue'
  /** The ID assigned to the value. */
  optionTypeId?: Maybe<Scalars['Int']['output']>
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType?: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>
  /** The order in which the radio button is displayed. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars['ID']['output']
}

/** Contains the results of the request to delete a compare list. */
export type DeleteCompareListOutput = {
  __typename?: 'DeleteCompareListOutput'
  /** Indicates whether the compare list was successfully deleted. */
  result: Scalars['Boolean']['output']
}

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type DeletePaymentTokenOutput = {
  __typename?: 'DeletePaymentTokenOutput'
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>
  /** Indicates whether the request succeeded. */
  result: Scalars['Boolean']['output']
}

export type DetailedSummary = {
  __typename?: 'DetailedSummary'
  /** Five stars. */
  five?: Maybe<Scalars['Int']['output']>
  /** Four stars. */
  four?: Maybe<Scalars['Int']['output']>
  /** One star. */
  one?: Maybe<Scalars['Int']['output']>
  /** Three stars. */
  three?: Maybe<Scalars['Int']['output']>
  /** Two stars. */
  two?: Maybe<Scalars['Int']['output']>
}

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item. */
export type Discount = {
  __typename?: 'Discount'
  /** The amount of the discount. */
  amount: Money
  /** A description of the discount. */
  label: Scalars['String']['output']
}

/** An implementation for downloadable product cart items. */
export type DownloadableCartItem = CartItemInterface & {
  __typename?: 'DownloadableCartItem'
  /** An array containing the customizable options the shopper selected. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output']
  /** An array containing information about the links for the downloadable product added to the cart. */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>
  /** PreOrder info */
  preorder?: Maybe<PreOrder>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output']
  /** An array containing information about samples of the selected downloadable product. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output']
}

/** Defines downloadable product options for `CreditMemoItemInterface`. */
export type DownloadableCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'DownloadableCreditMemoItem'
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** A list of downloadable links that are refunded from the downloadable product. */
  downloadableLinks?: Maybe<Array<Maybe<DownloadableItemsLinks>>>
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output']
  /** The order item the credit memo is applied to. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product, including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of refunded items. */
  quantityRefunded?: Maybe<Scalars['Float']['output']>
}

export enum DownloadableFileTypeEnum {
  /** @deprecated `sample_url` serves to get the downloadable sample */
  FILE = 'FILE',
  /** @deprecated `sample_url` serves to get the downloadable sample */
  URL = 'URL',
}

/** Defines downloadable product options for `InvoiceItemInterface`. */
export type DownloadableInvoiceItem = InvoiceItemInterface & {
  __typename?: 'DownloadableInvoiceItem'
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** A list of downloadable links that are invoiced from the downloadable product. */
  downloadableLinks?: Maybe<Array<Maybe<DownloadableItemsLinks>>>
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output']
  /** Details about an individual order item. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of invoiced items. */
  quantityInvoiced?: Maybe<Scalars['Float']['output']>
}

/** Defines characteristics of the links for downloadable product. */
export type DownloadableItemsLinks = {
  __typename?: 'DownloadableItemsLinks'
  /** A number indicating the sort order. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name of the link. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `DownloadableItemsLinks` object. */
  uid: Scalars['ID']['output']
}

/** Defines downloadable product options for `OrderItemInterface`. */
export type DownloadableOrderItem = OrderItemInterface & {
  __typename?: 'DownloadableOrderItem'
  /** The total refunded amount */
  amountRefunded: Money
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** A list of downloadable links that are ordered from the downloadable product. */
  downloadableLinks?: Maybe<Array<Maybe<DownloadableItemsLinks>>>
  /** The entered option for the base product, such as a logo or image. */
  enteredOptions?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output']
  product?: Maybe<ProductInterface>
  /** Product image */
  productImage?: Maybe<ProductImage>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price of the base product, including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The type of product, such as simple, configurable, etc. */
  productType?: Maybe<Scalars['String']['output']>
  /** URL key of the base product. */
  productUrlKey?: Maybe<Scalars['String']['output']>
  /** The number of canceled items. */
  quantityCanceled?: Maybe<Scalars['Float']['output']>
  /** The number of invoiced items. */
  quantityInvoiced?: Maybe<Scalars['Float']['output']>
  /** The number of units ordered for this item. */
  quantityOrdered?: Maybe<Scalars['Float']['output']>
  /** The number of refunded items. */
  quantityRefunded?: Maybe<Scalars['Float']['output']>
  /** The number of returned items. */
  quantityReturned?: Maybe<Scalars['Float']['output']>
  /** The number of shipped items. */
  quantityShipped?: Maybe<Scalars['Float']['output']>
  /** The total row amount */
  rowTotalIncludingTax: Money
  /** The selected options for the base product, such as color or size. */
  selectedOptions?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>
}

/** Defines a product that the shopper downloads. */
export type DownloadableProduct = CustomizableProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'DownloadableProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    addOn?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    aerowall?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    ageRecommended?: Maybe<Scalars['Int']['output']>
    /** Ambiance Product Images */
    ambianceGallery?: Maybe<Array<Maybe<AmbianceGallery>>>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attributeSetId?: Maybe<Scalars['Int']['output']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonicalUrl?: Maybe<Scalars['String']['output']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    collaborationLicense?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    colorVariant?: Maybe<Scalars['String']['output']>
    /** Color Variants */
    colorVariants?: Maybe<Array<Maybe<ColorVariant>>>
    /** The product's country of origin. */
    countryOfManufacture?: Maybe<Scalars['String']['output']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    createdAt?: Maybe<Scalars['String']['output']>
    /** Crosssell Products */
    crosssellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** An array containing information about the links for this downloadable product. */
    downloadableProductLinks?: Maybe<Array<Maybe<DownloadableProductLinks>>>
    /** An array containing information about samples of this downloadable product. */
    downloadableProductSamples?: Maybe<Array<Maybe<DownloadableProductSamples>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    drive?: Maybe<Scalars['Int']['output']>
    /** Filterable attribute with Text */
    dynamicAttributes?: Maybe<Array<Maybe<DynamicAttribute>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    electricalSupport?: Maybe<Scalars['Int']['output']>
    /** Craft entry type */
    entryType?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    framePlaybase?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    frameXlGokart?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gears?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['Int']['output']>
    /** Indicates whether a gift message is available. */
    giftMessageAvailable?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gokartType?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    handbrake?: Maybe<Scalars['Int']['output']>
    /** Highlight attributes */
    highlightedAttributes?: Maybe<Array<Maybe<HighlightAttribute>>>
    /** Highlight attributes PLP */
    highlightedAttributesPlp?: Maybe<Array<Maybe<HighlightAttribute>>>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Scalars['Int']['output']
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** @deprecated Use the `custom_attributes` field instead. */
    inclSafetynet?: Maybe<Scalars['Int']['output']>
    /** Whether the product is a main product or not. */
    isMainProduct: Scalars['Boolean']['output']
    /** @deprecated Use the `custom_attributes` field instead. */
    jumpMat?: Maybe<Scalars['Int']['output']>
    /** A value of 1 indicates that each link in the array must be purchased separately. */
    linksPurchasedSeparately?: Maybe<Scalars['Int']['output']>
    /** The heading above the list of downloadable products. */
    linksTitle?: Maybe<Scalars['String']['output']>
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxUserWeight?: Maybe<Scalars['Int']['output']>
    /** An array of media gallery objects. */
    mediaGallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    mediaGalleryEntries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    metaDescription?: Maybe<Scalars['String']['output']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    metaKeyword?: Maybe<Scalars['String']['output']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    metaTitle?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    minLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    model?: Maybe<Scalars['Int']['output']>
    /** The product name. Customers use this name to identify the product. */
    name: Scalars['String']['output']
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    newFromDate?: Maybe<Scalars['String']['output']>
    /** The end date for new product listings. */
    newToDate?: Maybe<Scalars['String']['output']>
    /** Product stock only x left count */
    onlyXLeftInStock?: Maybe<Scalars['Float']['output']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    optionsContainer?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pedals?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    playbaseSet?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    possibilityFor2ndSeat?: Maybe<Scalars['Int']['output']>
    /** PreOrder info */
    preorder?: Maybe<PreOrder>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    priceRange: PriceRange
    /** An array of `TierPrice` objects. */
    priceTiers?: Maybe<Array<Maybe<TierPrice>>>
    /** Product downloads */
    productDownloads?: Maybe<ProductDownload>
    /** An array of `ProductLinks` objects. */
    productLinks?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    productStatus?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pushRod?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityLine?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityStars?: Maybe<Scalars['Int']['output']>
    /** Review rating summary value. */
    ratingSummary?: Maybe<Scalars['Float']['output']>
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirectCode: Scalars['Int']['output']
    /** An array of products to be displayed in a Related Products block. */
    relatedProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relativeUrl?: Maybe<Scalars['String']['output']>
    /** Review amount of records. */
    reviewCount?: Maybe<Scalars['Int']['output']>
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    safetynetType?: Maybe<Scalars['Int']['output']>
    /** A short description of the product. Its use depends on the theme. */
    shortDescription?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeAirtrack?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeBeachwagon?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeClothing?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeJumpMat?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeStep?: Maybe<Scalars['Int']['output']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Scalars['String']['output']
    /** The relative path to the small image, which is used on catalog pages. */
    smallImage?: Maybe<ProductImage>
    /** Get list of spareparts per product(group), per year */
    sparepartLinks?: Maybe<Array<Maybe<BergProduct>>>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    specialFromDate?: Maybe<Scalars['String']['output']>
    /** The discounted price of the product. */
    specialPrice?: Maybe<Scalars['Float']['output']>
    /** The end date for a product with a special price. */
    specialToDate?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    springType?: Maybe<Scalars['Int']['output']>
    /** Stock status of the product */
    stockStatus?: Maybe<ProductStockStatus>
    /** The file name of a swatch image. */
    swatchImage?: Maybe<Scalars['String']['output']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrice?: Maybe<Scalars['Float']['output']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineShape?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineType?: Maybe<Scalars['Int']['output']>
    /** Tweakwise ID */
    tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
    /** PreOrder info */
    tweakwiseTemplates?: Maybe<TweakwiseTemplates>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    typeId?: Maybe<Scalars['String']['output']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']['output']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updatedAt?: Maybe<Scalars['String']['output']>
    /** Upsell Products */
    upsellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    urlKey: Scalars['String']['output']
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    urlPath?: Maybe<Scalars['String']['output']>
    /** URL rewrites list */
    urlRewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    urlSuffix?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    uvProtection?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    warranty?: Maybe<Scalars['Int']['output']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    wheelLights?: Maybe<Scalars['Int']['output']>
  }

/** Defines a product that the shopper downloads. */
export type DownloadableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Defines a single downloadable product. */
export type DownloadableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** The quantity and SKU of the downloadable product. */
  data: CartItemInput
  /** An array of objects containing the link_id of the downloadable product link. */
  downloadable_product_links?: InputMaybe<
    Array<InputMaybe<DownloadableProductLinksInput>>
  >
}

/** Defines characteristics of a downloadable product. */
export type DownloadableProductLinks = {
  __typename?: 'DownloadableProductLinks'
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']['output']>
  /** @deprecated This information should not be exposed on frontend. */
  isShareable?: Maybe<Scalars['Boolean']['output']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  linkType?: Maybe<DownloadableFileTypeEnum>
  /** @deprecated This information should not be exposed on frontend. */
  numberOfDownloads?: Maybe<Scalars['Int']['output']>
  /** The price of the downloadable product. */
  price?: Maybe<Scalars['Float']['output']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sampleFile?: Maybe<Scalars['String']['output']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sampleType?: Maybe<DownloadableFileTypeEnum>
  /** The full URL to the downloadable sample. */
  sampleUrl?: Maybe<Scalars['String']['output']>
  /** A number indicating the sort order. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name of the link. */
  title?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `DownloadableProductLinks` object. */
  uid: Scalars['ID']['output']
}

/** Contains the link ID for the downloadable product. */
export type DownloadableProductLinksInput = {
  /** The unique ID of the downloadable product link. */
  link_id: Scalars['Int']['input']
}

/** Defines characteristics of a downloadable product. */
export type DownloadableProductSamples = {
  __typename?: 'DownloadableProductSamples'
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']['output']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sampleFile?: Maybe<Scalars['String']['output']>
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sampleType?: Maybe<DownloadableFileTypeEnum>
  /** The full URL to the downloadable sample. */
  sampleUrl?: Maybe<Scalars['String']['output']>
  /** A number indicating the sort order. */
  sortOrder?: Maybe<Scalars['Int']['output']>
  /** The display name of the sample. */
  title?: Maybe<Scalars['String']['output']>
}

/** A downloadable product wish list item. */
export type DownloadableWishlistItem = WishlistItemInterface & {
  __typename?: 'DownloadableWishlistItem'
  /** The date and time the item was added to the wish list. */
  addedAt: Scalars['String']['output']
  /** Custom options selected for the wish list item. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output']
  /** An array containing information about the selected links. */
  linksV2?: Maybe<Array<Maybe<DownloadableProductLinks>>>
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output']
  /** An array containing information about the selected samples. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>
}

export type Downloads = {
  __typename?: 'Downloads'
  /** The download link value */
  buttonText?: Maybe<Scalars['String']['output']>
  /** The product filename */
  filename?: Maybe<Scalars['String']['output']>
  /** The file url */
  url?: Maybe<Scalars['String']['output']>
}

export type DynamicAttribute = {
  __typename?: 'DynamicAttribute'
  /** The attribute label */
  attributeLabel?: Maybe<Scalars['String']['output']>
  /** The attribute value */
  attributeValue?: Maybe<Scalars['String']['output']>
}

/** Defines a customer-entered option. */
export type EnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars['ID']['input']
  /** Text the customer entered. */
  value: Scalars['String']['input']
}

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type EntityUrl = {
  __typename?: 'EntityUrl'
  /** @deprecated Use `relative_url` instead. */
  canonicalUrl?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entityUid?: Maybe<Scalars['ID']['output']>
  /** Craft entry type */
  entryType?: Maybe<Scalars['String']['output']>
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode?: Maybe<Scalars['Int']['output']>
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relativeUrl?: Maybe<Scalars['String']['output']>
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>
}

export type ErrorInterface = {
  /** The returned error message. */
  message: Scalars['String']['output']
}

/** Lists the exchange rate. */
export type ExchangeRate = {
  __typename?: 'ExchangeRate'
  /** Specifies the store’s default currency to exchange to. */
  currencyTo?: Maybe<Scalars['String']['output']>
  /** The exchange rate for the store’s default currency. */
  rate?: Maybe<Scalars['Float']['output']>
}

export type FacetInput = {
  key?: InputMaybe<Scalars['String']['input']>
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type FacetSettings = {
  __typename?: 'FacetSettings'
  attributeName: Scalars['ID']['output']
  collapseText: Scalars['String']['output']
  containsBuckets: Scalars['Boolean']['output']
  containsClickPoints: Scalars['Boolean']['output']
  cssClass?: Maybe<Scalars['String']['output']>
  expandText: Scalars['String']['output']
  facetId: Scalars['Int']['output']
  infoText?: Maybe<Scalars['String']['output']>
  isCollapsed: Scalars['Boolean']['output']
  isCollapsible: Scalars['Boolean']['output']
  isInfoVisible: Scalars['Boolean']['output']
  isMultiSelect: Scalars['Boolean']['output']
  isNrOfResultsVisible: Scalars['Boolean']['output']
  isVisible: Scalars['Boolean']['output']
  multiSelectLogic?: Maybe<Scalars['TODO']['output']>
  nrOfColumns: Scalars['Int']['output']
  nrOfShownAttributes: Scalars['Int']['output']
  postfix?: Maybe<Scalars['String']['output']>
  prefix?: Maybe<Scalars['String']['output']>
  selectionType: Scalars['String']['output']
  source: Scalars['String']['output']
  title: Scalars['String']['output']
  urlKey: Scalars['String']['output']
}

export type FilterAttribute = {
  __typename?: 'FilterAttribute'
  attribute: Scalars['String']['output']
  value: Scalars['String']['output']
}

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match?: InputMaybe<Scalars['String']['input']>
}

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from?: InputMaybe<Scalars['String']['input']>
  /** Use this attribute to specify the highest possible value in the range. */
  to?: InputMaybe<Scalars['String']['input']>
}

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']['input']>
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']['input']>
}

/** Defines the comparison operators that can be used in a filter. */
export type FilterTypeInput = {
  /** Equals. */
  eq?: InputMaybe<Scalars['String']['input']>
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** From. Must be used with the `to` field. */
  from?: InputMaybe<Scalars['String']['input']>
  /** Greater than. */
  gt?: InputMaybe<Scalars['String']['input']>
  /** Greater than or equal to. */
  gteq?: InputMaybe<Scalars['String']['input']>
  /** In. The value can contain a set of comma-separated values. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like?: InputMaybe<Scalars['String']['input']>
  /** Less than. */
  lt?: InputMaybe<Scalars['String']['input']>
  /** Less than or equal to. */
  lteq?: InputMaybe<Scalars['String']['input']>
  /** More than or equal to. */
  moreq?: InputMaybe<Scalars['String']['input']>
  /** Not equal to. */
  neq?: InputMaybe<Scalars['String']['input']>
  /** Not in. The value can contain a set of comma-separated values. */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Not null. */
  notnull?: InputMaybe<Scalars['String']['input']>
  /** Is null. */
  null?: InputMaybe<Scalars['String']['input']>
  /** To. Must be used with the `from` field. */
  to?: InputMaybe<Scalars['String']['input']>
}

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  __typename?: 'FixedProductTax'
  /** The amount of the Fixed Product Tax. */
  amount?: Maybe<Money>
  /** The display label assigned to the Fixed Product Tax. */
  label?: Maybe<Scalars['String']['output']>
}

/** Lists display settings for the Fixed Product Tax. */
export enum FixedProductTaxDisplaySettings {
  /**
   * The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.'
   * @deprecated
   */
  EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'.
   * @deprecated
   */
  EXCLUDE_FPT_WITHOUT_DETAILS = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query.
   * @deprecated
   */
  FPT_DISABLED = 'FPT_DISABLED',
  /**
   * The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'.
   * @deprecated
   */
  INCLUDE_FPT_WITHOUT_DETAILS = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'.
   * @deprecated
   */
  INCLUDE_FPT_WITH_DETAILS = 'INCLUDE_FPT_WITH_DETAILS',
}

export type GatewayOrderResultFormField = {
  __typename?: 'GatewayOrderResultFormField'
  field: Scalars['String']['output']
  value: Scalars['String']['output']
}

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessage = {
  __typename?: 'GiftMessage'
  /** Sender name */
  from: Scalars['String']['output']
  /** Gift message text */
  message: Scalars['String']['output']
  /** Recipient name */
  to: Scalars['String']['output']
}

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessageInput = {
  /** Sender name */
  from: Scalars['String']['input']
  /** Gift message text */
  message: Scalars['String']['input']
  /** Recipient name */
  to: Scalars['String']['input']
}

export type GoogleMapsDistanceDestination = {
  __typename?: 'GoogleMapsDistanceDestination'
  destination?: Maybe<Scalars['String']['output']>
  distances?: Maybe<Array<Maybe<GoogleMapsTravelDistanceElements>>>
}

export type GoogleMapsDistanceDestinationInput = {
  destination: Scalars['String']['input']
  lat: Scalars['Float']['input']
  lng: Scalars['Float']['input']
}

export type GoogleMapsDistanceDestinationsInput = {
  destinations: Array<GoogleMapsDistanceDestinationInput>
  origin: GoogleMapsGeocodeLocationInput
}

export type GoogleMapsGeocodeGeometry = {
  __typename?: 'GoogleMapsGeocodeGeometry'
  location?: Maybe<GoogleMapsGeocodeLocation>
}

export type GoogleMapsGeocodeLocation = {
  __typename?: 'GoogleMapsGeocodeLocation'
  lat?: Maybe<Scalars['Float']['output']>
  lng?: Maybe<Scalars['Float']['output']>
}

export type GoogleMapsGeocodeLocationInput = {
  lat?: InputMaybe<Scalars['Float']['input']>
  lng?: InputMaybe<Scalars['Float']['input']>
}

export type GoogleMapsGeocodeResult = {
  __typename?: 'GoogleMapsGeocodeResult'
  formattedAddress?: Maybe<Scalars['String']['output']>
  geometry?: Maybe<GoogleMapsGeocodeGeometry>
  placeId?: Maybe<Scalars['String']['output']>
}

export type GoogleMapsTravelDistance = {
  __typename?: 'GoogleMapsTravelDistance'
  elements?: Maybe<Array<Maybe<GoogleMapsTravelDistanceElements>>>
}

export type GoogleMapsTravelDistanceDuration = {
  __typename?: 'GoogleMapsTravelDistanceDuration'
  text?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['Int']['output']>
}

export type GoogleMapsTravelDistanceElements = {
  __typename?: 'GoogleMapsTravelDistanceElements'
  distance?: Maybe<GoogleMapsTravelDistanceLength>
  duration?: Maybe<GoogleMapsTravelDistanceDuration>
  status?: Maybe<Scalars['String']['output']>
}

export type GoogleMapsTravelDistanceLength = {
  __typename?: 'GoogleMapsTravelDistanceLength'
  text?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['Int']['output']>
}

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProduct = PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'GroupedProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    addOn?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    aerowall?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    ageRecommended?: Maybe<Scalars['Int']['output']>
    /** Ambiance Product Images */
    ambianceGallery?: Maybe<Array<Maybe<AmbianceGallery>>>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attributeSetId?: Maybe<Scalars['Int']['output']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonicalUrl?: Maybe<Scalars['String']['output']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    collaborationLicense?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    colorVariant?: Maybe<Scalars['String']['output']>
    /** Color Variants */
    colorVariants?: Maybe<Array<Maybe<ColorVariant>>>
    /** The product's country of origin. */
    countryOfManufacture?: Maybe<Scalars['String']['output']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    createdAt?: Maybe<Scalars['String']['output']>
    /** Crosssell Products */
    crosssellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    drive?: Maybe<Scalars['Int']['output']>
    /** Filterable attribute with Text */
    dynamicAttributes?: Maybe<Array<Maybe<DynamicAttribute>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    electricalSupport?: Maybe<Scalars['Int']['output']>
    /** Craft entry type */
    entryType?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    framePlaybase?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    frameXlGokart?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gears?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['Int']['output']>
    /** Indicates whether a gift message is available. */
    giftMessageAvailable?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gokartType?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    handbrake?: Maybe<Scalars['Int']['output']>
    /** Highlight attributes */
    highlightedAttributes?: Maybe<Array<Maybe<HighlightAttribute>>>
    /** Highlight attributes PLP */
    highlightedAttributesPlp?: Maybe<Array<Maybe<HighlightAttribute>>>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Scalars['Int']['output']
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** @deprecated Use the `custom_attributes` field instead. */
    inclSafetynet?: Maybe<Scalars['Int']['output']>
    /** Whether the product is a main product or not. */
    isMainProduct: Scalars['Boolean']['output']
    /** An array containing grouped product items. */
    items?: Maybe<Array<Maybe<GroupedProductItem>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    jumpMat?: Maybe<Scalars['Int']['output']>
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxUserWeight?: Maybe<Scalars['Int']['output']>
    /** An array of media gallery objects. */
    mediaGallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    mediaGalleryEntries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    metaDescription?: Maybe<Scalars['String']['output']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    metaKeyword?: Maybe<Scalars['String']['output']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    metaTitle?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    minLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    model?: Maybe<Scalars['Int']['output']>
    /** The product name. Customers use this name to identify the product. */
    name: Scalars['String']['output']
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    newFromDate?: Maybe<Scalars['String']['output']>
    /** The end date for new product listings. */
    newToDate?: Maybe<Scalars['String']['output']>
    /** Product stock only x left count */
    onlyXLeftInStock?: Maybe<Scalars['Float']['output']>
    /** If the product has multiple options, determines where they appear on the product page. */
    optionsContainer?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pedals?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    playbaseSet?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    possibilityFor2ndSeat?: Maybe<Scalars['Int']['output']>
    /** PreOrder info */
    preorder?: Maybe<PreOrder>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    priceRange: PriceRange
    /** An array of `TierPrice` objects. */
    priceTiers?: Maybe<Array<Maybe<TierPrice>>>
    /** Product downloads */
    productDownloads?: Maybe<ProductDownload>
    /** An array of `ProductLinks` objects. */
    productLinks?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    productStatus?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pushRod?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityLine?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityStars?: Maybe<Scalars['Int']['output']>
    /** Review rating summary value. */
    ratingSummary?: Maybe<Scalars['Float']['output']>
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirectCode: Scalars['Int']['output']
    /** An array of products to be displayed in a Related Products block. */
    relatedProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relativeUrl?: Maybe<Scalars['String']['output']>
    /** Review amount of records. */
    reviewCount?: Maybe<Scalars['Int']['output']>
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    safetynetType?: Maybe<Scalars['Int']['output']>
    /** A short description of the product. Its use depends on the theme. */
    shortDescription?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeAirtrack?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeBeachwagon?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeClothing?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeJumpMat?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeStep?: Maybe<Scalars['Int']['output']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Scalars['String']['output']
    /** The relative path to the small image, which is used on catalog pages. */
    smallImage?: Maybe<ProductImage>
    /** Get list of spareparts per product(group), per year */
    sparepartLinks?: Maybe<Array<Maybe<BergProduct>>>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    specialFromDate?: Maybe<Scalars['String']['output']>
    /** The discounted price of the product. */
    specialPrice?: Maybe<Scalars['Float']['output']>
    /** The end date for a product with a special price. */
    specialToDate?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    springType?: Maybe<Scalars['Int']['output']>
    /** Stock status of the product */
    stockStatus?: Maybe<ProductStockStatus>
    /** The file name of a swatch image. */
    swatchImage?: Maybe<Scalars['String']['output']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrice?: Maybe<Scalars['Float']['output']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineShape?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineType?: Maybe<Scalars['Int']['output']>
    /** Tweakwise ID */
    tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
    /** PreOrder info */
    tweakwiseTemplates?: Maybe<TweakwiseTemplates>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    typeId?: Maybe<Scalars['String']['output']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']['output']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updatedAt?: Maybe<Scalars['String']['output']>
    /** Upsell Products */
    upsellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    urlKey: Scalars['String']['output']
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    urlPath?: Maybe<Scalars['String']['output']>
    /** URL rewrites list */
    urlRewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    urlSuffix?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    uvProtection?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    warranty?: Maybe<Scalars['Int']['output']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    wheelLights?: Maybe<Scalars['Int']['output']>
  }

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Contains information about an individual grouped product item. */
export type GroupedProductItem = {
  __typename?: 'GroupedProductItem'
  /** The relative position of this item compared to the other group items. */
  position?: Maybe<Scalars['Int']['output']>
  /** Details about this product option. */
  product?: Maybe<ProductInterface>
  /** The quantity of this grouped product item. */
  qty?: Maybe<Scalars['Float']['output']>
}

/** A grouped product wish list item. */
export type GroupedProductWishlistItem = WishlistItemInterface & {
  __typename?: 'GroupedProductWishlistItem'
  /** The date and time the item was added to the wish list. */
  addedAt: Scalars['String']['output']
  /** Custom options selected for the wish list item. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output']
}

export type HighlightAttribute = {
  __typename?: 'HighlightAttribute'
  /** The attribute code */
  attributeCode?: Maybe<Scalars['String']['output']>
  /** The attribute label */
  attributeLabel?: Maybe<Scalars['String']['output']>
  /** The attribute sort order */
  attributePosition?: Maybe<Scalars['Int']['output']>
  /** The attribute value */
  attributeValue?: Maybe<Scalars['String']['output']>
}

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payments Pro Hosted Solution payment method. */
export type HostedProInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. For example, if the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input']
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. For example, if the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input']
}

/** Contains the secure URL used for the Payments Pro Hosted Solution payment method. */
export type HostedProUrl = {
  __typename?: 'HostedProUrl'
  /** The secure URL generated by PayPal. */
  secureFormUrl?: Maybe<Scalars['String']['output']>
}

/** Contains the required input to request the secure URL for Payments Pro Hosted Solution payment. */
export type HostedProUrlInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input']
}

/** Contains target path parameters. */
export type HttpQueryParameter = {
  __typename?: 'HttpQueryParameter'
  /** A parameter name. */
  name?: Maybe<Scalars['String']['output']>
  /** A parameter value. */
  value?: Maybe<Scalars['String']['output']>
}

export type ImageSwatchData = SwatchDataInterface & {
  __typename?: 'ImageSwatchData'
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail?: Maybe<Scalars['String']['output']>
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>
}

export type Images = {
  __typename?: 'Images'
  /** Image full path. */
  fullPath?: Maybe<Scalars['String']['output']>
  /** Resized image path. */
  resizedPath?: Maybe<Scalars['String']['output']>
}

/** Contains an error message when an internal error occurred. */
export type InternalError = ErrorInterface & {
  __typename?: 'InternalError'
  /** The returned error message. */
  message: Scalars['String']['output']
}

/** Contains invoice details. */
export type Invoice = {
  __typename?: 'Invoice'
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID']['output']
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>
  /** Sequential invoice number. */
  number: Scalars['String']['output']
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>
}

export type InvoiceItem = InvoiceItemInterface & {
  __typename?: 'InvoiceItem'
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output']
  /** Details about an individual order item. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of invoiced items. */
  quantityInvoiced?: Maybe<Scalars['Float']['output']>
}

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output']
  /** Details about an individual order item. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of invoiced items. */
  quantityInvoiced?: Maybe<Scalars['Float']['output']>
}

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  __typename?: 'InvoiceTotal'
  /** The final base grand total amount in the base currency. */
  baseGrandTotal: Money
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The final total amount, including shipping, discounts, and taxes. */
  grandTotal: Money
  /** Details about the shipping and handling costs for the invoice. */
  shippingHandling?: Maybe<ShippingHandling>
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>
  /** The shipping amount for the invoice. */
  totalShipping: Money
  /** The amount of tax applied to the invoice. */
  totalTax: Money
}

/** Contains the result of the `isEmailAvailable` query. */
export type IsEmailAvailableOutput = {
  __typename?: 'IsEmailAvailableOutput'
  /** Indicates whether the specified email address can be used to create a customer. */
  isEmailAvailable?: Maybe<Scalars['Boolean']['output']>
}

export type Issuer = {
  __typename?: 'Issuer'
  code?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
}

/** A list of options of the selected bundle product. */
export type ItemSelectedBundleOption = {
  __typename?: 'ItemSelectedBundleOption'
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID']['output']
  /** The label of the option. */
  label: Scalars['String']['output']
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars['ID']['output']
  /** A list of products that represent the values of the parent option. */
  values?: Maybe<Array<Maybe<ItemSelectedBundleOptionValue>>>
}

/** A list of values for the selected bundle product. */
export type ItemSelectedBundleOptionValue = {
  __typename?: 'ItemSelectedBundleOptionValue'
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID']['output']
  /** The price of the child bundle product. */
  price: Money
  /** The name of the child bundle product. */
  productName: Scalars['String']['output']
  /** The SKU of the child bundle product. */
  productSku: Scalars['String']['output']
  /** The number of this bundle product that were ordered. */
  quantity: Scalars['Float']['output']
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars['ID']['output']
}

/** Contains a key-value pair. */
export type KeyValue = {
  __typename?: 'KeyValue'
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']['output']>
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']['output']>
}

/** Contains details about a Landing page. */
export type LandingPage = RoutableInterface & {
  __typename?: 'LandingPage'
  canonicalUrl?: Maybe<Scalars['String']['output']>
  categoryId: Scalars['ID']['output']
  contentFirst?: Maybe<Scalars['String']['output']>
  contentLast?: Maybe<Scalars['String']['output']>
  entryType?: Maybe<Scalars['String']['output']>
  filterAttributes?: Maybe<Array<Maybe<FilterAttribute>>>
  heading?: Maybe<Scalars['String']['output']>
  hideSelectedFilters: Scalars['Boolean']['output']
  isActive: Scalars['Boolean']['output']
  isFilterLinkAllowed: Scalars['Boolean']['output']
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  metaTitle?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  overviewPageId?: Maybe<Scalars['ID']['output']>
  overviewPageImage?: Maybe<Scalars['String']['output']>
  pageId: Scalars['ID']['output']
  redirectCode: Scalars['Int']['output']
  relativeUrl?: Maybe<Scalars['String']['output']>
  storeIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  tweakwiseFilterTemplate: Scalars['Int']['output']
  tweakwiseSortTemplate: Scalars['Int']['output']
  type?: Maybe<UrlRewriteEntityTypeEnum>
  urlPath: Scalars['String']['output']
}

export type LandingPageUrl = {
  __typename?: 'LandingPageUrl'
  currentLandingPage?: Maybe<Scalars['String']['output']>
  defaultFallbackPage?: Maybe<Scalars['String']['output']>
  hashKey: Scalars['String']['output']
  key: Scalars['String']['output']
  landingPageUrl?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
  value: Scalars['String']['output']
}

/** Contains information for rendering layered navigation. */
export type LayerFilter = {
  __typename?: 'LayerFilter'
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filterItems?: Maybe<Array<Maybe<LayerFilterItemInterface>>>
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filterItemsCount?: Maybe<Scalars['Int']['output']>
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name?: Maybe<Scalars['String']['output']>
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  requestVar?: Maybe<Scalars['String']['output']>
}

export type LayerFilterItem = LayerFilterItemInterface & {
  __typename?: 'LayerFilterItem'
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  itemsCount?: Maybe<Scalars['Int']['output']>
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']['output']>
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  valueString?: Maybe<Scalars['String']['output']>
}

export type LayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  itemsCount?: Maybe<Scalars['Int']['output']>
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']['output']>
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  valueString?: Maybe<Scalars['String']['output']>
}

/** Defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  __typename?: 'MediaGalleryEntry'
  /** Details about the content of the media gallery item. */
  content?: Maybe<ProductMediaGalleryEntriesContent>
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']['output']>
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>
  /** The alt text displayed on the storefront when the user points to the image. */
  label?: Maybe<Scalars['String']['output']>
  /** Either `image` or `video`. */
  mediaType?: Maybe<Scalars['String']['output']>
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars['ID']['output']
  /** Details about the content of a video item. */
  videoContent?: Maybe<ProductMediaGalleryEntriesVideoContent>
}

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>
}

/** Defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money'
  /** A three-letter currency code, such as USD or EUR. */
  currency: CurrencyEnum
  /** A number expressing a monetary value. */
  value: Scalars['Float']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Add comment */
  addAdvComment?: Maybe<AddAdvCommentOutput>
  /** Add review */
  addAdvReview?: Maybe<AddAdvReviewOutput>
  /** Add vote */
  addAdvVote?: Maybe<AddAdvVoteOutput>
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>
  /** Add one or more downloadable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addDownloadableProductsToCart?: Maybe<AddDownloadableProductsToCartOutput>
  /** Add any type of product to the cart. */
  addProductsToCart?: Maybe<AddProductsToCartOutput>
  /** Add products to the specified compare list. */
  addProductsToCompareList?: Maybe<CompareList>
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist?: Maybe<AddProductsToWishlistOutput>
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart?: Maybe<AddWishlistItemsToCartOutput>
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>
  /** Assign the specified compare list to the logged in customer. */
  assignCompareListToCustomer?: Maybe<AssignCompareListToCustomerOutput>
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: Cart
  /** Change the password for the logged-in customer. */
  changeCustomerPassword?: Maybe<Customer>
  /** Create a new compare list. The compare list is saved for logged in customers. */
  createCompareList?: Maybe<CompareList>
  /** Use `createCustomerV2` instead. */
  createCustomer?: Maybe<CustomerOutput>
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress?: Maybe<CustomerAddress>
  /** Create a customer account. */
  createCustomerV2?: Maybe<CustomerOutput>
  /** Create an empty shopping cart for a guest or logged in user */
  createEmptyCart?: Maybe<Scalars['String']['output']>
  /** Initiate a transaction and receive a token. Use this mutation for Payflow Pro and Payments Pro payment methods */
  createPayflowProToken?: Maybe<CreatePayflowProTokenOutput>
  /** Initiate an Express Checkout transaction and receive a token. Use this mutation for Express Checkout and Payments Standard payment methods. */
  createPaypalExpressToken?: Maybe<PaypalExpressTokenOutput>
  /** Create Plate */
  createPlate?: Maybe<Plate>
  /** Create a product review for the specified product. */
  createProductReview: CreateProductReviewOutput
  /** Delete the specified compare list. */
  deleteCompareList?: Maybe<DeleteCompareListOutput>
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']['output']>
  /** Delete a customer's payment token. */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>
  /** Generate a token for specified customer. */
  generateCustomerToken?: Maybe<CustomerToken>
  /** Handle a payment response and save the payment in Quote. Use this mutation for Payflow Pro and Payments Pro payment methods. */
  handlePayflowProResponse?: Maybe<PayflowProResponseOutput>
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: Cart
  ping?: Maybe<Scalars['String']['output']>
  /** Convert the quote into an order. */
  placeOrder?: Maybe<PlaceOrderOutput>
  placeOrderAndGetPaymentInformation?: Maybe<PlaceOrderAndGetPaymentInformationOutput>
  /** Refresh Token of the authorized customer. */
  refreshCustomerToken: RefreshCustomerTokenOutput
  /** Register Product */
  registerProduct?: Maybe<RegistrationData>
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>
  /** Remove products from the specified compare list. */
  removeProductsFromCompareList?: Maybe<CompareList>
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist?: Maybe<RemoveProductsFromWishlistOutput>
  /** Add all products from a customer's previous order to the cart. */
  reorderItems?: Maybe<ReorderItemsOutput>
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars['Boolean']['output']>
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword?: Maybe<Scalars['Boolean']['output']>
  /** Revoke the customer token. */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter?: Maybe<SubscribeEmailToNewsletterOutput>
  /** Modify items in the cart. */
  updateCartItems?: Maybe<UpdateCartItemsOutput>
  /** Use `updateCustomerV2` instead. */
  updateCustomer?: Maybe<CustomerOutput>
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress?: Maybe<CustomerAddress>
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail?: Maybe<CustomerOutput>
  /** Update the customer's personal information. */
  updateCustomerV2?: Maybe<CustomerOutput>
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist?: Maybe<UpdateProductsInWishlistOutput>
}

export type MutationAddAdvCommentArgs = {
  input?: InputMaybe<AddAdvCommentInput>
}

export type MutationAddAdvReviewArgs = {
  input?: InputMaybe<AddAdvReviewInput>
}

export type MutationAddAdvVoteArgs = {
  input?: InputMaybe<AddAdvVoteInput>
}

export type MutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>
}

export type MutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>
}

export type MutationAddDownloadableProductsToCartArgs = {
  input?: InputMaybe<AddDownloadableProductsToCartInput>
}

export type MutationAddProductsToCartArgs = {
  cartId: Scalars['String']['input']
  cartItems: Array<CartItemInput>
}

export type MutationAddProductsToCompareListArgs = {
  input?: InputMaybe<AddProductsToCompareListInput>
}

export type MutationAddProductsToWishlistArgs = {
  wishlistId: Scalars['ID']['input']
  wishlistItems: Array<WishlistItemInput>
}

export type MutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>
}

export type MutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>
}

export type MutationAddWishlistItemsToCartArgs = {
  wishlistId: Scalars['ID']['input']
  wishlistItemIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationApplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>
}

export type MutationAssignCompareListToCustomerArgs = {
  uid: Scalars['ID']['input']
}

export type MutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars['String']['input']
}

export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String']['input']
  newPassword: Scalars['String']['input']
}

export type MutationCreateCompareListArgs = {
  input?: InputMaybe<CreateCompareListInput>
}

export type MutationCreateCustomerArgs = {
  input: CustomerInput
}

export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput
}

export type MutationCreateCustomerV2Args = {
  input: CustomerCreateInput
}

export type MutationCreateEmptyCartArgs = {
  input?: InputMaybe<CreateEmptyCartInput>
}

export type MutationCreatePayflowProTokenArgs = {
  input: PayflowProTokenInput
}

export type MutationCreatePaypalExpressTokenArgs = {
  input: PaypalExpressTokenInput
}

export type MutationCreatePlateArgs = {
  plate: PlateInput
}

export type MutationCreateProductReviewArgs = {
  input: CreateProductReviewInput
}

export type MutationDeleteCompareListArgs = {
  uid: Scalars['ID']['input']
}

export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeletePaymentTokenArgs = {
  public_hash: Scalars['String']['input']
}

export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationHandlePayflowProResponseArgs = {
  input: PayflowProResponseInput
}

export type MutationMergeCartsArgs = {
  destination_cart_id?: InputMaybe<Scalars['String']['input']>
  source_cart_id: Scalars['String']['input']
}

export type MutationPlaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>
}

export type MutationPlaceOrderAndGetPaymentInformationArgs = {
  input?: InputMaybe<PlaceOrderAndGetPaymentInformationInput>
}

export type MutationRefreshCustomerTokenArgs = {
  input: RefreshCustomerTokenInput
}

export type MutationRegisterProductArgs = {
  registration: RegistrationInput
}

export type MutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>
}

export type MutationRemoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>
}

export type MutationRemoveProductsFromCompareListArgs = {
  input?: InputMaybe<RemoveProductsFromCompareListInput>
}

export type MutationRemoveProductsFromWishlistArgs = {
  wishlistId: Scalars['ID']['input']
  wishlistItemsIds: Array<Scalars['ID']['input']>
}

export type MutationReorderItemsArgs = {
  orderNumber: Scalars['String']['input']
}

export type MutationRequestPasswordResetEmailArgs = {
  email: Scalars['String']['input']
}

export type MutationResetPasswordArgs = {
  email: Scalars['String']['input']
  newPassword: Scalars['String']['input']
  resetPasswordToken: Scalars['String']['input']
}

export type MutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>
}

export type MutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>
}

export type MutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>
}

export type MutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>
}

export type MutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>
}

export type MutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>
}

export type MutationSubscribeEmailToNewsletterArgs = {
  email: Scalars['String']['input']
}

export type MutationUpdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>
}

export type MutationUpdateCustomerArgs = {
  input: CustomerInput
}

export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['Int']['input']
  input?: InputMaybe<CustomerAddressInput>
}

export type MutationUpdateCustomerEmailArgs = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationUpdateCustomerV2Args = {
  input: CustomerUpdateInput
}

export type MutationUpdateProductsInWishlistArgs = {
  wishlistId: Scalars['ID']['input']
  wishlistItems: Array<WishlistItemUpdateInput>
}

/** Contains an error message when an invalid UID was specified. */
export type NoSuchEntityUidError = ErrorInterface & {
  __typename?: 'NoSuchEntityUidError'
  /** The returned error message. */
  message: Scalars['String']['output']
  /** The specified invalid unique ID of an object. */
  uid: Scalars['ID']['output']
}

/** Contains the order ID. */
export type Order = {
  __typename?: 'Order'
  maskedOrderId?: Maybe<Scalars['String']['output']>
  /** @deprecated Use `order_number` instead. */
  orderId?: Maybe<Scalars['String']['output']>
  /** The unique ID for an `Order` object. */
  orderNumber: Scalars['String']['output']
}

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  __typename?: 'OrderAddress'
  /** The city or town. */
  city: Scalars['String']['output']
  /** The customer's company. */
  company?: Maybe<Scalars['String']['output']>
  /** The customer's country. */
  countryCode?: Maybe<CountryCodeEnum>
  /** The fax number. */
  fax?: Maybe<Scalars['String']['output']>
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String']['output']
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String']['output']
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']['output']>
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']['output']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>
  /** The state or province name. */
  region?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `Region` object of a pre-defined region. */
  regionId?: Maybe<Scalars['ID']['output']>
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']['output']>>
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']['output']>
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vatId?: Maybe<Scalars['String']['output']>
}

export type OrderItem = OrderItemInterface & {
  __typename?: 'OrderItem'
  /** The total refunded amount */
  amountRefunded: Money
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The entered option for the base product, such as a logo or image. */
  enteredOptions?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output']
  product?: Maybe<ProductInterface>
  /** Product image */
  productImage?: Maybe<ProductImage>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price of the base product, including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The type of product, such as simple, configurable, etc. */
  productType?: Maybe<Scalars['String']['output']>
  /** URL key of the base product. */
  productUrlKey?: Maybe<Scalars['String']['output']>
  /** The number of canceled items. */
  quantityCanceled?: Maybe<Scalars['Float']['output']>
  /** The number of invoiced items. */
  quantityInvoiced?: Maybe<Scalars['Float']['output']>
  /** The number of units ordered for this item. */
  quantityOrdered?: Maybe<Scalars['Float']['output']>
  /** The number of refunded items. */
  quantityRefunded?: Maybe<Scalars['Float']['output']>
  /** The number of returned items. */
  quantityReturned?: Maybe<Scalars['Float']['output']>
  /** The number of shipped items. */
  quantityShipped?: Maybe<Scalars['Float']['output']>
  /** The total row amount */
  rowTotalIncludingTax: Money
  /** The selected options for the base product, such as color or size. */
  selectedOptions?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>
}

/** Order item details. */
export type OrderItemInterface = {
  /** The total refunded amount */
  amountRefunded: Money
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The entered option for the base product, such as a logo or image. */
  enteredOptions?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output']
  product?: Maybe<ProductInterface>
  /** Product image */
  productImage?: Maybe<ProductImage>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price of the base product, including selected options. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The type of product, such as simple, configurable, etc. */
  productType?: Maybe<Scalars['String']['output']>
  /** URL key of the base product. */
  productUrlKey?: Maybe<Scalars['String']['output']>
  /** The number of canceled items. */
  quantityCanceled?: Maybe<Scalars['Float']['output']>
  /** The number of invoiced items. */
  quantityInvoiced?: Maybe<Scalars['Float']['output']>
  /** The number of units ordered for this item. */
  quantityOrdered?: Maybe<Scalars['Float']['output']>
  /** The number of refunded items. */
  quantityRefunded?: Maybe<Scalars['Float']['output']>
  /** The number of returned items. */
  quantityReturned?: Maybe<Scalars['Float']['output']>
  /** The number of shipped items. */
  quantityShipped?: Maybe<Scalars['Float']['output']>
  /** The total row amount */
  rowTotalIncludingTax: Money
  /** The selected options for the base product, such as color or size. */
  selectedOptions?: Maybe<Array<Maybe<OrderItemOption>>>
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>
}

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  __typename?: 'OrderItemOption'
  /** The name of the option. */
  label: Scalars['String']['output']
  /** The value of the option. */
  value: Scalars['String']['output']
}

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod'
  /** Additional data per payment method type. */
  additionalData?: Maybe<Array<Maybe<KeyValue>>>
  /** The label that describes the payment method. */
  name: Scalars['String']['output']
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String']['output']
}

/** Contains order shipment details. */
export type OrderShipment = {
  __typename?: 'OrderShipment'
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID']['output']
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>
  /** The sequential credit shipment number. */
  number: Scalars['String']['output']
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>
}

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  __typename?: 'OrderTotal'
  /** The final base grand total amount in the base currency. */
  baseGrandTotal: Money
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>
  /** The final total amount, including shipping, discounts, and taxes. */
  grandTotal: Money
  /** Details about the shipping and handling costs for the order. */
  shippingHandling?: Maybe<ShippingHandling>
  /** The subtotal of the order, excluding shipping, discounts, and taxes. */
  subtotal: Money
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>
  /** The shipping amount for the order. */
  totalShipping: Money
  /** The amount of tax applied to the order. */
  totalTax: Money
}

export type ParentData = {
  __typename?: 'ParentData'
  mainSlug?: Maybe<Scalars['String']['output']>
  preselectOptions?: Maybe<Array<Maybe<PreSelectedOption>>>
  product?: Maybe<ProductInterface>
}

/** Contains required input for Payflow Express Checkout payments. */
export type PayflowExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String']['input']
  /** The token returned by the createPaypalExpressToken mutation. */
  token: Scalars['String']['input']
}

/** A set of relative URLs that PayPal uses in response to various actions during the authorization process. Adobe Commerce prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input']
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String']['input']
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input']
}

/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export enum PayflowLinkMode {
  /** @deprecated  */
  LIVE = 'LIVE',
  /** @deprecated  */
  TEST = 'TEST',
}

/** Contains information used to generate PayPal iframe for transaction. Applies to Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkToken = {
  __typename?: 'PayflowLinkToken'
  /** The mode for the Payflow transaction. */
  mode?: Maybe<PayflowLinkMode>
  /** The PayPal URL used for requesting a Payflow form. */
  paypalUrl?: Maybe<Scalars['String']['output']>
  /** The secure token generated by PayPal. */
  secureToken?: Maybe<Scalars['String']['output']>
  /** The secure token ID generated by PayPal. */
  secureTokenId?: Maybe<Scalars['String']['output']>
}

/** Contains information required to fetch payment token information for the Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String']['input']
}

/** Contains input for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProInput = {
  /** Required input for credit card related information. */
  cc_details: CreditCardDetailsInput
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the PayPal Payflow Pro payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input required to complete payment. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProResponseInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input']
  /** The payload returned from PayPal. */
  paypal_payload: Scalars['String']['input']
}

export type PayflowProResponseOutput = {
  __typename?: 'PayflowProResponseOutput'
  /** The cart with the updated selected payment method. */
  cart: Cart
}

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProToken = {
  __typename?: 'PayflowProToken'
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  responseMessage: Scalars['String']['output']
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int']['output']
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  resultCode: Scalars['Int']['output']
  /** A secure token generated by PayPal. */
  secureToken: Scalars['String']['output']
  /** A secure token ID generated by PayPal. */
  secureTokenId: Scalars['String']['output']
}

/** Contains input required to fetch payment token information for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProTokenInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input']
  /** A set of relative URLs that PayPal uses for callback. */
  urls: PayflowProUrlInput
}

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for the Payflow Pro and Payment Pro payment methods. */
export type PayflowProUrlInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input']
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String']['input']
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input']
}

export type PaymentInformation = {
  __typename?: 'PaymentInformation'
  gatewayRedirectFormAction?: Maybe<Scalars['String']['output']>
  gatewayRedirectFormFields?: Maybe<Array<Maybe<GatewayOrderResultFormField>>>
  gatewayRedirectUrl?: Maybe<Scalars['String']['output']>
}

/** Defines the payment method. */
export type PaymentMethodInput = {
  additional_data?: InputMaybe<Array<InputMaybe<AdditionalDataField>>>
  /** The internal name for the payment method. */
  code: Scalars['String']['input']
  /** Required input for PayPal Hosted pro payments. */
  hosted_pro?: InputMaybe<HostedProInput>
  /** Required input for Payflow Express Checkout payments. */
  payflow_express?: InputMaybe<PayflowExpressInput>
  /** Required input for PayPal Payflow Link and Payments Advanced payments. */
  payflow_link?: InputMaybe<PayflowLinkInput>
  /** Required input for PayPal Payflow Pro and Payment Pro payments. */
  payflowpro?: InputMaybe<PayflowProInput>
  /** Required input for PayPal Payflow Pro vault payments. */
  payflowpro_cc_vault?: InputMaybe<VaultTokenInput>
  /** Required input for Express Checkout and Payments Standard payments. */
  paypal_express?: InputMaybe<PaypalExpressInput>
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars['String']['input']>
}

/** The stored payment method available to the customer. */
export type PaymentToken = {
  __typename?: 'PaymentToken'
  /** A description of the stored account details. */
  details?: Maybe<Scalars['String']['output']>
  /** The payment method code associated with the token. */
  paymentMethodCode: Scalars['String']['output']
  /** The public hash of the token. */
  publicHash: Scalars['String']['output']
  /** Specifies the payment token type. */
  type: PaymentTokenTypeEnum
}

/** The list of available payment token types. */
export enum PaymentTokenTypeEnum {
  /**
   * phpcs:ignore Magento2.GraphQL.ValidArgumentName
   * @deprecated
   */
  ACCOUNT = 'account',
  /**
   * phpcs:ignore Magento2.GraphQL.ValidArgumentName
   * @deprecated
   */
  CARD = 'card',
}

/** Contains required input for Express Checkout and Payments Standard payments. */
export type PaypalExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String']['input']
  /** The token returned by the `createPaypalExpressToken` mutation. */
  token: Scalars['String']['input']
}

/** Deprecated. Use `PaypalExpressTokenOutput` instead. */
export type PaypalExpressToken = {
  __typename?: 'PaypalExpressToken'
  /**
   * A set of URLs that allow the buyer to authorize payment and adjust checkout details.
   * @deprecated Use `PaypalExpressTokenOutput.paypal_urls` instead.
   */
  paypalUrls?: Maybe<PaypalExpressUrlList>
  /**
   * The token returned by PayPal.
   * @deprecated Use `PaypalExpressTokenOutput.token` instead.
   */
  token?: Maybe<Scalars['String']['output']>
}

/** Defines the attributes required to receive a payment token for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String']['input']
  /** The payment method code. */
  code: Scalars['String']['input']
  /** Indicates whether the buyer selected the quick checkout button. The default value is false. */
  express_button?: InputMaybe<Scalars['Boolean']['input']>
  /** A set of relative URLs that PayPal uses in response to various actions during the authorization process. */
  urls: PaypalExpressUrlsInput
  /** Indicates whether the buyer clicked the PayPal credit button. The default value is false. */
  use_paypal_credit?: InputMaybe<Scalars['Boolean']['input']>
}

/** Contains the token returned by PayPal and a set of URLs that allow the buyer to authorize payment and adjust checkout details. Applies to Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenOutput = {
  __typename?: 'PaypalExpressTokenOutput'
  /** A set of URLs that allow the buyer to authorize payment and adjust checkout details. */
  paypalUrls?: Maybe<PaypalExpressUrlList>
  /** The token returned by PayPal. */
  token?: Maybe<Scalars['String']['output']>
}

/** Contains a set of URLs that allow the buyer to authorize payment and adjust checkout details for Express Checkout and Payments Standard transactions. */
export type PaypalExpressUrlList = {
  __typename?: 'PaypalExpressUrlList'
  /** The PayPal URL that allows the buyer to edit their checkout details. */
  edit?: Maybe<Scalars['String']['output']>
  /** The URL to the PayPal login page. */
  start?: Maybe<Scalars['String']['output']>
}

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressUrlsInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input']
  /** The relative URL of the page that PayPal redirects to when the payment has been put on hold for additional review. This condition mostly applies to ACH transactions, and is not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success_pending.html, the relative URL is paypal/action/success_pending.html. */
  pending_url?: InputMaybe<Scalars['String']['input']>
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input']
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. Not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success.html, the relative URL is paypal/action/success.html. */
  success_url?: InputMaybe<Scalars['String']['input']>
}

/** Contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>
}

export type PlaceOrderAndGetPaymentInformationInput = {
  cart_id: Scalars['String']['input']
}

export type PlaceOrderAndGetPaymentInformationOutput = {
  __typename?: 'PlaceOrderAndGetPaymentInformationOutput'
  order: Order
  paymentInformation: PaymentInformation
}

/** Specifies the quote to be converted to an order. */
export type PlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
}

/** Contains the results of the request to place an order. */
export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput'
  /** The ID of the order. */
  order: Order
}

/** Plate */
export type Plate = {
  __typename?: 'Plate'
  /** Address line 1 */
  address1?: Maybe<Scalars['String']['output']>
  /** Address line 2 */
  address2?: Maybe<Scalars['String']['output']>
  /** Address line 3 */
  address3?: Maybe<Scalars['String']['output']>
  /** City */
  city?: Maybe<Scalars['String']['output']>
  /** Country */
  country?: Maybe<Scalars['String']['output']>
  /** Timestamp indicating when the plate was created. */
  createdAt?: Maybe<Scalars['String']['output']>
  /** Email Address */
  email?: Maybe<Scalars['String']['output']>
  /** Is email sent */
  emailSent?: Maybe<Scalars['Boolean']['output']>
  /** Customer name */
  name?: Maybe<Scalars['String']['output']>
  /** The ID number assigned to the plate */
  plateId: Scalars['ID']['output']
  /** The plate text */
  plateText?: Maybe<Scalars['String']['output']>
  /** The plate type */
  plateType?: Maybe<PlateType>
  /** Postal Code */
  postalCode?: Maybe<Scalars['String']['output']>
  /** Region */
  region?: Maybe<Scalars['String']['output']>
  /** Unique Code */
  uniqueCode?: Maybe<Scalars['String']['output']>
  /** Timestamp indicating when the plate was updated. */
  updatedAt?: Maybe<Scalars['String']['output']>
}

/** Plate */
export type PlateInput = {
  /** Address line 1 */
  address_1: Scalars['String']['input']
  /** Address line 2 */
  address_2?: InputMaybe<Scalars['String']['input']>
  /** Address line 3 */
  address_3?: InputMaybe<Scalars['String']['input']>
  /** City */
  city?: InputMaybe<Scalars['String']['input']>
  /** Country */
  country: Scalars['String']['input']
  /** Email Address */
  email: Scalars['String']['input']
  /** Customer firstname */
  firstname: Scalars['String']['input']
  /** Customer lastname */
  lastname: Scalars['String']['input']
  /** The plate text */
  plate_text: Scalars['String']['input']
  /** The plate type */
  plate_type: Scalars['String']['input']
  /** Postal Code */
  postal_code: Scalars['String']['input']
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>
  /** Unique Code */
  unique_code: Scalars['String']['input']
}

/** The different plate types */
export enum PlateType {
  /** @deprecated  */
  AUSTRIA = 'AUSTRIA',
  /** @deprecated  */
  BELGIE = 'BELGIE',
  /** @deprecated  */
  FRANCE = 'FRANCE',
  /** @deprecated  */
  GB = 'GB',
  /** @deprecated  */
  GERMAN = 'GERMAN',
  /** @deprecated  */
  IRLAND = 'IRLAND',
  /** @deprecated  */
  NL = 'NL',
  /** @deprecated  */
  NONE = 'NONE',
  /** @deprecated  */
  WHITE = 'WHITE',
  /** @deprecated  */
  YELLOW = 'YELLOW',
}

/** Reponse for postcode lookup */
export type PostcodeNlAddress = {
  __typename?: 'PostcodeNLAddress'
  /** Type of this address. */
  addressType: Scalars['String']['output']
  /** Dutch term used in BAG: "adresseerbaar object id". Unique identification for objects which have 'building', 'house boat site', or 'mobile home site' as addressType. */
  bagAddressableObjectId?: Maybe<Scalars['String']['output']>
  /** Dutch term used in BAG: "nummeraanduiding id". */
  bagNumberDesignationId?: Maybe<Scalars['String']['output']>
  /**
   * Official city name in accordance with "BAG (Basisregistraties adressen en
   * gebouwen)". In capital and lowercase letters, including punctuation marks
   * and accents. This field is at most 80 characters in length.
   */
  city: Scalars['String']['output']
  /**
   * City name, shortened to fit a lower maximum length. In capital and lowercase
   * letters, including punctuation marks and accents. This field is at most 24
   * characters in length.
   */
  cityShort: Scalars['String']['output']
  /**
   * House number of a perceel. In case of a Postbus match the house number will
   * always be 0. Range: 0-99999
   */
  houseNumber: Scalars['Int']['output']
  /**
   * Addition of the house number to uniquely define a location. These additions
   * are officially recognized by the municipality. This field is at most
   * 6 characters in length and null if addition not found (see
   * houseNumberAdditions result field).
   */
  houseNumberAddition?: Maybe<Scalars['String']['output']>
  /**
   * List of all house number additions having the postcode and houseNumber
   * which was input.
   */
  houseNumberAdditions: Array<Maybe<Scalars['String']['output']>>
  /** Latitude of address. Null for PO Boxes. */
  latitude?: Maybe<Scalars['Float']['output']>
  /** Longitude of address. Null for PO Boxes. */
  longitude?: Maybe<Scalars['Float']['output']>
  /**
   * Municipality name in accordance with "BAG (Basisregistraties adressen en
   * gebouwen)". In capital and lowercase letters, including punctuation marks
   * and accents. This field is at most 80 characters in length. Examples:
   * "Baarle-Nassau", "'s-Gravenhage", "Haarlemmerliede en Spaarnwoude".
   */
  municipality: Scalars['String']['output']
  /**
   * Municipality name, shortened to fit a lower maximum length. In capital and
   * lowercase letters, including punctuation marks and accents. This field is at
   * most 24 characters in length. Examples: "Baarle-Nassau", "'s-Gravenhage",
   * "Haarlemmerliede c.a.".
   */
  municipalityShort: Scalars['String']['output']
  /**
   * Four digit neighborhood code (first part of a postcode). Range: 1000-9999
   * plus two character letter combination (second part of a postcode).
   * Range: "AA"-"ZZ"
   */
  postcode: Scalars['String']['output']
  /** Official name of the province, correctly cased and with dashes where applicable. */
  province: Scalars['String']['output']
  /**
   * List of all purposes (Dutch: "gebruiksdoelen"). Null or an array of
   * text values.
   */
  purposes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /**
   * X coordinate according to Dutch Rijksdriehoeksmeting "(EPSG)
   * 28992 Amersfoort / RD New". Values range from 0 to 300000 meters.
   * Null for PO Boxes.
   */
  rdX?: Maybe<Scalars['Int']['output']>
  /**
   * Y coordinate according to Dutch Rijksdriehoeksmeting "(EPSG)
   * 28992 Amersfoort / RD New". Values range from 300000 to 620000 meters.
   * Null for PO Boxes.
   */
  rdY?: Maybe<Scalars['Int']['output']>
  /**
   * Street name in accordance with "BAG (Basisregistraties adressen en
   * gebouwen)". In capital and lowercase letters, including punctuation marks
   * and accents. This field is at most 80 characters in length. Filled with
   * "Postbus" in case it is a range of PO boxes.
   */
  street: Scalars['String']['output']
  /**
   * Street name in NEN-5825 notation, which has a lower maximum length. In
   * capital and lowercase letters, including punctuation marks and accents.
   * This field is at most 24 characters in length. Filled with "Postbus" in case
   * it is a range of PO boxes.
   */
  streetNen: Scalars['String']['output']
  /** Surface in square meters. Null for PO Boxes. */
  surfaceArea?: Maybe<Scalars['Float']['output']>
}

export type PreOrder = {
  __typename?: 'PreOrder'
  /** Indicates the expected availability date */
  atpDate?: Maybe<Scalars['String']['output']>
  /** Shows locale formatted availability date */
  atpDateFormatted?: Maybe<Scalars['String']['output']>
  /** Indicates whether this product is pre-orderable */
  isPreorder: Scalars['Boolean']['output']
}

export type PreSelectedOption = {
  __typename?: 'PreSelectedOption'
  attributeCode: Scalars['String']['output']
  label: Scalars['String']['output']
  uid: Scalars['ID']['output']
  value: Scalars['String']['output']
}

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  __typename?: 'Price'
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount?: Maybe<Money>
}

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  __typename?: 'PriceAdjustment'
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>
}

/** `PriceAdjustment.code` is deprecated. */
export enum PriceAdjustmentCodesEnum {
  /** @deprecated `PriceAdjustmentCodesEnum` is deprecated. Tax is included or excluded in the price. Tax is not shown separately in Catalog. */
  TAX = 'TAX',
  /** @deprecated WEEE code is deprecated. Use `fixed_product_taxes.label` instead. */
  WEEE = 'WEEE',
  /** @deprecated Use `fixed_product_taxes` instead.  Tax is included or excluded in price. The tax is not shown separtely in Catalog. */
  WEEE_TAX = 'WEEE_TAX',
}

/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export enum PriceAdjustmentDescriptionEnum {
  /** @deprecated  */
  EXCLUDED = 'EXCLUDED',
  /** @deprecated  */
  INCLUDED = 'INCLUDED',
}

/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  __typename?: 'PriceRange'
  /** The highest possible price for the product. */
  maximumPrice?: Maybe<ProductPrice>
  /** The lowest possible price for the product. */
  minimumPrice: ProductPrice
}

/** Defines the price type. */
export enum PriceTypeEnum {
  /** @deprecated  */
  DYNAMIC = 'DYNAMIC',
  /** @deprecated  */
  FIXED = 'FIXED',
  /** @deprecated  */
  PERCENT = 'PERCENT',
}

/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export enum PriceViewEnum {
  /** @deprecated  */
  AS_LOW_AS = 'AS_LOW_AS',
  /** @deprecated  */
  PRICE_RANGE = 'PRICE_RANGE',
}

/** Contains a product attribute code and value. */
export type ProductAttribute = {
  __typename?: 'ProductAttribute'
  /** The unique identifier for a product attribute code. */
  code: Scalars['String']['output']
  /** The display value of the attribute. */
  value: Scalars['String']['output']
}

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Attribute label: Module */
  add_on?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Age Recommended */
  age_recommended?: InputMaybe<FilterEqualTypeInput>
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id?: InputMaybe<FilterEqualTypeInput>
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Collaboration/license */
  collaboration_license?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Color */
  color?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: electrical_support */
  electrical_support?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: frame_playbase */
  frame_playbase?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Frame XL gokart */
  frame_xl_gokart?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Gears */
  gears?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Gender */
  gender?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Gokart Type */
  gokart_type?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Handbrake */
  handbrake?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Incl. Safetynet */
  incl_safetynet?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Jump_mat */
  jump_mat?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Max. length user */
  max_length_user?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Max. user weight */
  max_user_weight?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Min. length user */
  min_length_user?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Model */
  model?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>
  /** Attribute label: pedals */
  pedals?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: possibility_for_2nd_seat */
  possibility_for_2nd_seat?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>
  /** Attribute label: push_rod */
  push_rod?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Quality line */
  quality_line?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Safetynet type */
  safetynet_type?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Short Description */
  short_description?: InputMaybe<FilterMatchTypeInput>
  /** Attribute label: Size */
  size_airtrack?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: size_beachwagon */
  size_beachwagon?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: size_clothing */
  size_clothing?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Size Jump mat */
  size_jump_mat?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Spring type */
  spring_type?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Trampoline shape */
  trampoline_shape?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: Trampoline type */
  trampoline_type?: InputMaybe<FilterEqualTypeInput>
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: UV protection */
  uv_protection?: InputMaybe<FilterEqualTypeInput>
  /** Attribute label: wheel_lights */
  wheel_lights?: InputMaybe<FilterEqualTypeInput>
}

/** Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type ProductAttributeSortInput = {
  /** Attribute label: Product Name */
  name?: InputMaybe<SortEnum>
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>
  /** Attribute label: Price */
  price?: InputMaybe<SortEnum>
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>
}

/** Contains the discount applied to a product price. */
export type ProductDiscount = {
  __typename?: 'ProductDiscount'
  /** The actual value of the discount. */
  amountOff?: Maybe<Scalars['Float']['output']>
  /** The discount expressed a percentage. */
  percentOff?: Maybe<Scalars['Float']['output']>
}

export type ProductDownload = {
  __typename?: 'ProductDownload'
  /** The connected files */
  downloads?: Maybe<Array<Maybe<Downloads>>>
  /** The group title */
  title?: Maybe<Scalars['String']['output']>
}

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id?: InputMaybe<FilterTypeInput>
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<FilterTypeInput>
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<FilterTypeInput>
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<FilterTypeInput>
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<FilterTypeInput>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<FilterTypeInput>
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<FilterTypeInput>
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<FilterTypeInput>
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<FilterTypeInput>
  /** The label assigned to a product image. */
  image_label?: InputMaybe<FilterTypeInput>
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<FilterTypeInput>
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: InputMaybe<FilterTypeInput>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<FilterTypeInput>
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<FilterTypeInput>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<FilterTypeInput>
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: InputMaybe<FilterTypeInput>
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<FilterTypeInput>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<FilterTypeInput>
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<FilterTypeInput>
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<FilterTypeInput>
  /** The keyword required to perform a logical OR comparison. */
  or?: InputMaybe<ProductFilterInput>
  /** The price of an item. */
  price?: InputMaybe<FilterTypeInput>
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<FilterTypeInput>
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<FilterTypeInput>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<FilterTypeInput>
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<FilterTypeInput>
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<FilterTypeInput>
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<FilterTypeInput>
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: InputMaybe<FilterTypeInput>
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<FilterTypeInput>
  /** The file name of a swatch image. */
  swatch_image?: InputMaybe<FilterTypeInput>
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<FilterTypeInput>
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<FilterTypeInput>
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<FilterTypeInput>
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<FilterTypeInput>
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterTypeInput>
  url_path?: InputMaybe<FilterTypeInput>
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<FilterTypeInput>
}

/** Contains product image information, including the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  __typename?: 'ProductImage'
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>
}

/** Contains fields that are common to all types of products. */
export type ProductInterface = {
  /** @deprecated Use the `custom_attributes` field instead. */
  addOn?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  aerowall?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  ageRecommended?: Maybe<Scalars['Int']['output']>
  /** Ambiance Product Images */
  ambianceGallery?: Maybe<Array<Maybe<AmbianceGallery>>>
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attributeSetId?: Maybe<Scalars['Int']['output']>
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonicalUrl?: Maybe<Scalars['String']['output']>
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>
  /** @deprecated Use the `custom_attributes` field instead. */
  collaborationLicense?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  colorVariant?: Maybe<Scalars['String']['output']>
  /** Color Variants */
  colorVariants?: Maybe<Array<Maybe<ColorVariant>>>
  /** The product's country of origin. */
  countryOfManufacture?: Maybe<Scalars['String']['output']>
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  createdAt?: Maybe<Scalars['String']['output']>
  /** Crosssell Products */
  crosssellProducts?: Maybe<Array<Maybe<ProductInterface>>>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>
  /** @deprecated Use the `custom_attributes` field instead. */
  drive?: Maybe<Scalars['Int']['output']>
  /** Filterable attribute with Text */
  dynamicAttributes?: Maybe<Array<Maybe<DynamicAttribute>>>
  /** @deprecated Use the `custom_attributes` field instead. */
  electricalSupport?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  framePlaybase?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  frameXlGokart?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  gears?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  gender?: Maybe<Scalars['Int']['output']>
  /** Indicates whether a gift message is available. */
  giftMessageAvailable?: Maybe<Scalars['String']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  gokartType?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  handbrake?: Maybe<Scalars['Int']['output']>
  /** Highlight attributes */
  highlightedAttributes?: Maybe<Array<Maybe<HighlightAttribute>>>
  /** Highlight attributes PLP */
  highlightedAttributesPlp?: Maybe<Array<Maybe<HighlightAttribute>>>
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id: Scalars['Int']['output']
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>
  /** @deprecated Use the `custom_attributes` field instead. */
  inclSafetynet?: Maybe<Scalars['Int']['output']>
  /** Whether the product is a main product or not. */
  isMainProduct: Scalars['Boolean']['output']
  /** @deprecated Use the `custom_attributes` field instead. */
  jumpMat?: Maybe<Scalars['Int']['output']>
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  maxLengthUser?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  maxUserWeight?: Maybe<Scalars['Int']['output']>
  /** An array of media gallery objects. */
  mediaGallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  mediaGalleryEntries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  metaDescription?: Maybe<Scalars['String']['output']>
  /** A comma-separated list of keywords that are visible only to search engines. */
  metaKeyword?: Maybe<Scalars['String']['output']>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  metaTitle?: Maybe<Scalars['String']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  minLengthUser?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  model?: Maybe<Scalars['Int']['output']>
  /** The product name. Customers use this name to identify the product. */
  name: Scalars['String']['output']
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  newFromDate?: Maybe<Scalars['String']['output']>
  /** The end date for new product listings. */
  newToDate?: Maybe<Scalars['String']['output']>
  /** Product stock only x left count */
  onlyXLeftInStock?: Maybe<Scalars['Float']['output']>
  /** If the product has multiple options, determines where they appear on the product page. */
  optionsContainer?: Maybe<Scalars['String']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  pedals?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  playbaseSet?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  possibilityFor2ndSeat?: Maybe<Scalars['Int']['output']>
  /** PreOrder info */
  preorder?: Maybe<PreOrder>
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>
  /** The range of prices for the product */
  priceRange: PriceRange
  /** An array of `TierPrice` objects. */
  priceTiers?: Maybe<Array<Maybe<TierPrice>>>
  /** Product downloads */
  productDownloads?: Maybe<ProductDownload>
  /** An array of `ProductLinks` objects. */
  productLinks?: Maybe<Array<Maybe<ProductLinksInterface>>>
  /** @deprecated Use the `custom_attributes` field instead. */
  productStatus?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  pushRod?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  qualityLine?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  qualityStars?: Maybe<Scalars['Int']['output']>
  /** Review rating summary value. */
  ratingSummary?: Maybe<Scalars['Float']['output']>
  /** An array of products to be displayed in a Related Products block. */
  relatedProducts?: Maybe<Array<Maybe<ProductInterface>>>
  /** Review amount of records. */
  reviewCount?: Maybe<Scalars['Int']['output']>
  /** The list of products reviews. */
  reviews: ProductReviews
  /** @deprecated Use the `custom_attributes` field instead. */
  safetynetType?: Maybe<Scalars['Int']['output']>
  /** A short description of the product. Its use depends on the theme. */
  shortDescription?: Maybe<ComplexTextValue>
  /** @deprecated Use the `custom_attributes` field instead. */
  sizeAirtrack?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  sizeBeachwagon?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  sizeClothing?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  sizeJumpMat?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  sizeStep?: Maybe<Scalars['Int']['output']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: Scalars['String']['output']
  /** The relative path to the small image, which is used on catalog pages. */
  smallImage?: Maybe<ProductImage>
  /** Get list of spareparts per product(group), per year */
  sparepartLinks?: Maybe<Array<Maybe<BergProduct>>>
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  specialFromDate?: Maybe<Scalars['String']['output']>
  /** The discounted price of the product. */
  specialPrice?: Maybe<Scalars['Float']['output']>
  /** The end date for a product with a special price. */
  specialToDate?: Maybe<Scalars['String']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  springType?: Maybe<Scalars['Int']['output']>
  /** Stock status of the product */
  stockStatus?: Maybe<ProductStockStatus>
  /** The file name of a swatch image. */
  swatchImage?: Maybe<Scalars['String']['output']>
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tierPrice?: Maybe<Scalars['Float']['output']>
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tierPrices?: Maybe<Array<Maybe<ProductTierPrices>>>
  /** @deprecated Use the `custom_attributes` field instead. */
  trampolineShape?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  trampolineType?: Maybe<Scalars['Int']['output']>
  /** Tweakwise ID */
  tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
  /** PreOrder info */
  tweakwiseTemplates?: Maybe<TweakwiseTemplates>
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  typeId?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output']
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updatedAt?: Maybe<Scalars['String']['output']>
  /** Upsell Products */
  upsellProducts?: Maybe<Array<Maybe<ProductInterface>>>
  /** The part of the URL that identifies the product */
  urlKey: Scalars['String']['output']
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  urlPath?: Maybe<Scalars['String']['output']>
  /** URL rewrites list */
  urlRewrites?: Maybe<Array<Maybe<UrlRewrite>>>
  /** The part of the product URL that is appended after the url key */
  urlSuffix?: Maybe<Scalars['String']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  uvProtection?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use the `custom_attributes` field instead. */
  warranty?: Maybe<Scalars['Int']['output']>
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>
  /** @deprecated Use the `custom_attributes` field instead. */
  wheelLights?: Maybe<Scalars['Int']['output']>
}

/** Contains fields that are common to all types of products. */
export type ProductInterfaceReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** An implementation of `ProductLinksInterface`. */
export type ProductLinks = ProductLinksInterface & {
  __typename?: 'ProductLinks'
  /** One of related, associated, upsell, or crosssell. */
  linkType?: Maybe<Scalars['String']['output']>
  /** The SKU of the linked product. */
  linkedProductSku?: Maybe<Scalars['String']['output']>
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linkedProductType?: Maybe<Scalars['String']['output']>
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']['output']>
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']['output']>
}

/** Contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  linkType?: Maybe<Scalars['String']['output']>
  /** The SKU of the linked product. */
  linkedProductSku?: Maybe<Scalars['String']['output']>
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linkedProductType?: Maybe<Scalars['String']['output']>
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']['output']>
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']['output']>
}

/** Contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  __typename?: 'ProductMediaGalleryEntriesContent'
  /** The image in base64 format. */
  base64EncodedData?: Maybe<Scalars['String']['output']>
  /** The file name of the image. */
  name?: Maybe<Scalars['String']['output']>
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']['output']>
}

/** Contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  __typename?: 'ProductMediaGalleryEntriesVideoContent'
  /** Must be external-video. */
  mediaType?: Maybe<Scalars['String']['output']>
  /** A description of the video. */
  videoDescription?: Maybe<Scalars['String']['output']>
  /** Optional data about the video. */
  videoMetadata?: Maybe<Scalars['String']['output']>
  /** Describes the video source. */
  videoProvider?: Maybe<Scalars['String']['output']>
  /** The title of the video. */
  videoTitle?: Maybe<Scalars['String']['output']>
  /** The URL to the video. */
  videoUrl?: Maybe<Scalars['String']['output']>
}

/** Represents a product price. */
export type ProductPrice = {
  __typename?: 'ProductPrice'
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>
  /** The final price of the product after applying discounts. */
  finalPrice: Money
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixedProductTaxes?: Maybe<Array<Maybe<FixedProductTax>>>
  /** The regular price of the product. */
  regularPrice: Money
}

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  __typename?: 'ProductPrices'
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice?: Maybe<Price>
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice?: Maybe<Price>
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice?: Maybe<Price>
}

/** The current selected attribute with option data */
export type ProductRegistrationOption = {
  __typename?: 'ProductRegistrationOption'
  /** The id of the attribute */
  attributeCode?: Maybe<Scalars['String']['output']>
  /** The label of the attribute */
  attributeLabel?: Maybe<Scalars['String']['output']>
  /** An array of selectable options */
  options?: Maybe<Array<Maybe<ProductRegistrationOptionValue>>>
}

/** The current selected option */
export type ProductRegistrationOptionInput = {
  /** The attribute */
  attribute_code?: InputMaybe<Scalars['String']['input']>
  /** The selected option value */
  selected_option?: InputMaybe<Scalars['ID']['input']>
}

/** A pair of label and value */
export type ProductRegistrationOptionValue = {
  __typename?: 'ProductRegistrationOptionValue'
  /** The label of the option */
  label?: Maybe<Scalars['String']['output']>
  /** Whether the option is selected or not */
  selected?: Maybe<Scalars['Boolean']['output']>
  /** The value of the option */
  value?: Maybe<Scalars['ID']['output']>
}

/** Contains metadata corresponding to the selected options. */
export type ProductRegistrationOptionsSelection = {
  __typename?: 'ProductRegistrationOptionsSelection'
  /** Contains the current selected options. */
  currentSelection?: Maybe<Array<Maybe<ProductRegistrationOption>>>
  /** The options available for further selection based on the current selection. */
  optionsAvailableForSelection: ProductRegistrationOption
  /** Products matching the current filters */
  products?: Maybe<Array<Maybe<ProductInterface>>>
}

/** Contains details of a product review. */
export type ProductReview = {
  __typename?: 'ProductReview'
  /** The average of all ratings for this product. */
  averageRating: Scalars['Float']['output']
  /** The date the review was created. */
  createdAt: Scalars['String']['output']
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String']['output']
  /** The reviewed product. */
  product: ProductInterface
  /** An array of ratings by rating category, such as quality, price, and value. */
  ratingsBreakdown: Array<Maybe<ProductReviewRating>>
  /** The summary (title) of the review. */
  summary: Scalars['String']['output']
  /** The review text. */
  text: Scalars['String']['output']
}

/** Contains data about a single aspect of a product review. */
export type ProductReviewRating = {
  __typename?: 'ProductReviewRating'
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String']['output']
  /** The rating value given by customer. By default, possible values range from 1 to 5. */
  value: Scalars['String']['output']
}

/** Contains the reviewer's rating for a single aspect of a review. */
export type ProductReviewRatingInput = {
  /** An encoded rating ID. */
  id: Scalars['String']['input']
  /** Rating value id. */
  option_id: Scalars['String']['input']
  /** Rating id. */
  rating_id: Scalars['String']['input']
  /** An encoded rating value ID. */
  value_id: Scalars['String']['input']
}

/** Contains details about a single aspect of a product review. */
export type ProductReviewRatingMetadata = {
  __typename?: 'ProductReviewRatingMetadata'
  /** An encoded rating ID. */
  id: Scalars['String']['output']
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String']['output']
  /** List of product review ratings sorted by position. */
  values: Array<Maybe<ProductReviewRatingValueMetadata>>
}

/** Contains details about a single value in a product review. */
export type ProductReviewRatingValueMetadata = {
  __typename?: 'ProductReviewRatingValueMetadata'
  /** A ratings scale, such as the number of stars awarded. */
  value: Scalars['String']['output']
  /** An encoded rating value ID. */
  valueId: Scalars['String']['output']
}

/** Contains an array of metadata about each aspect of a product review. */
export type ProductReviewRatingsMetadata = {
  __typename?: 'ProductReviewRatingsMetadata'
  /** An array of product reviews sorted by position. */
  items: Array<Maybe<ProductReviewRatingMetadata>>
}

/** Contains an array of product reviews. */
export type ProductReviews = {
  __typename?: 'ProductReviews'
  /** An array of product reviews. */
  items: Array<Maybe<ProductReview>>
  /** Metadata for pagination rendering. */
  pageInfo: SearchResultPageInfo
}

/** Deprecated. Use `ProductAttributeSortInput` instead. Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type ProductSortInput = {
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<SortEnum>
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<SortEnum>
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<SortEnum>
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<SortEnum>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<SortEnum>
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<SortEnum>
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<SortEnum>
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<SortEnum>
  /** The label assigned to a product image. */
  image_label?: InputMaybe<SortEnum>
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<SortEnum>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<SortEnum>
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<SortEnum>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<SortEnum>
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<SortEnum>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<SortEnum>
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<SortEnum>
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<SortEnum>
  /** The price of the item. */
  price?: InputMaybe<SortEnum>
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<SortEnum>
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<SortEnum>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<SortEnum>
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<SortEnum>
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<SortEnum>
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<SortEnum>
  /** The discounted price of the product. */
  special_price?: InputMaybe<SortEnum>
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<SortEnum>
  /** Indicates the criteria to sort swatches. */
  swatch_image?: InputMaybe<SortEnum>
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<SortEnum>
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<SortEnum>
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<SortEnum>
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<SortEnum>
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<SortEnum>
  url_path?: InputMaybe<SortEnum>
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<SortEnum>
}

/** This enumeration states whether a product stock status is in stock or out of stock */
export enum ProductStockStatus {
  /** @deprecated  */
  IN_STOCK = 'IN_STOCK',
  /** @deprecated  */
  OUT_OF_STOCK = 'OUT_OF_STOCK',
}

/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  __typename?: 'ProductTierPrices'
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customerGroupId?: Maybe<Scalars['String']['output']>
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentageValue?: Maybe<Scalars['Float']['output']>
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty?: Maybe<Scalars['Float']['output']>
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value?: Maybe<Scalars['Float']['output']>
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  websiteId?: Maybe<Scalars['Float']['output']>
}

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  __typename?: 'ProductVideo'
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  videoContent?: Maybe<ProductMediaGalleryEntriesVideoContent>
}

/** Contains the results of a `products` query. */
export type Products = {
  __typename?: 'Products'
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>
  /** An object that includes the page_info and currentPage values specified in the query. */
  pageInfo?: Maybe<SearchResultPageInfo>
  /** An object that includes the default sort field and all available sort fields. */
  sortFields?: Maybe<SortFields>
  /** An array of search suggestions for case when search query have no results. */
  suggestions?: Maybe<Array<Maybe<SearchSuggestion>>>
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  totalCount?: Maybe<Scalars['Int']['output']>
}

/** Contains the results of a `products` query. */
export type ProductsAggregationsArgs = {
  filter?: InputMaybe<AggregationsFilterInput>
}

export type Query = {
  __typename?: 'Query'
  /** Entries within the account section. */
  accountEntries?: Maybe<Array<Maybe<CraftAccountSectionEntryUnion>>>
  /**
   * Get an address based on its unique combination of postcode, house number and
   * house number addition.
   *
   * Coordinate and surfaceArea values are null values if no location is known,
   * i.e. if the address is a PO Box.
   *
   * You must always check the houseNumberAddition result field, as a successful
   * response is also returned if only the input addition isn't found.
   */
  address?: Maybe<PostcodeNlAddress>
  advreview?: Maybe<ReviewsData>
  amReviewSetting?: Maybe<AmReviewSetting>
  amReviewWidget?: Maybe<AmReviewWidget>
  /** This query is used to query for a single asset. */
  asset?: Maybe<CraftAssetInterface>
  /** This query is used to return the number of assets. */
  assetCount: Scalars['Int']['output']
  /** This query is used to query for assets. */
  assets?: Maybe<Array<Maybe<CraftAssetInterface>>>
  /** The Payment method interface */
  availablePaymentMethods?: Maybe<AvailablePaymentMethods>
  /** Get a list of available store views and their config information. */
  availableStores?: Maybe<Array<Maybe<StoreConfig>>>
  /** Return information about the specified shopping cart. */
  cart?: Maybe<Cart>
  /** Return a list of categories that match the specified filter. */
  categories?: Maybe<CategoryResult>
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categoryList` instead.
   */
  category?: Maybe<CategoryTree>
  /** Retrieve a category by UID */
  categoryByUid?: Maybe<CategoryInterface>
  /** Entries within the category section. */
  categoryEntries?: Maybe<Array<Maybe<CraftCategorySectionEntryUnion>>>
  /** Return an array of categories based on the specified filters. */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>
  /** Entries within the categoryPageContent section. */
  categoryPageContentEntries?: Maybe<
    Array<Maybe<CraftCategoryPageContentSectionEntryUnion>>
  >
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>
  /** Return information about CMS blocks. */
  cmsBlocks?: Maybe<CmsBlocks>
  /** Return details about a CMS page. */
  cmsPage?: Maybe<CmsPage>
  /** Return products that have been added to the specified compare list. */
  compareList?: Maybe<CompareList>
  /** Entries within the contact section. */
  contactEntries?: Maybe<Array<Maybe<CraftContactSectionEntryUnion>>>
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>
  /** Return information about the store's currency. */
  currency?: Maybe<Currency>
  /** Return the attribute type, given an attribute code and entity type. */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>
  /** Return detailed information about a customer account. */
  customer?: Maybe<Customer>
  /** Return information about the customer's shopping cart. */
  customerCart: Cart
  /** Return a list of downloadable products the customer has purchased. */
  customerDownloadableProducts?: Maybe<CustomerDownloadableProducts>
  /** @deprecated Use the `customer` query instead. */
  customerOrders?: Maybe<CustomerOrders>
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>
  /** Entries within the customerService section. */
  customerServiceEntries?: Maybe<
    Array<Maybe<CraftCustomerServiceSectionEntryUnion>>
  >
  /** Entries within the customerServiceOverview section. */
  customerServiceOverviewEntries?: Maybe<
    Array<Maybe<CraftCustomerServiceOverviewSectionEntryUnion>>
  >
  /** This query is used to query for entries. */
  entries?: Maybe<Array<Maybe<CraftEntryInterface>>>
  /** This query is used to query for a single entry. */
  entry?: Maybe<CraftEntryInterface>
  /** This query is used to return the number of entries. */
  entryCount: Scalars['Int']['output']
  /** Entries within the forgotPassword section. */
  forgotPasswordEntries?: Maybe<
    Array<Maybe<CraftForgotPasswordSectionEntryUnion>>
  >
  /** Entries within the genericBlockLinks section. */
  genericBlockLinksEntries?: Maybe<
    Array<Maybe<CraftGenericBlockLinksSectionEntryUnion>>
  >
  /** Get Code info */
  getCode?: Maybe<UniqueCode>
  /** Retrieve the secure PayPal URL for a Payments Pro Hosted Solution transaction. */
  getHostedProUrl?: Maybe<HostedProUrl>
  /** Get active banklist */
  getMultisafepayIssuers?: Maybe<Array<Maybe<Issuer>>>
  /** Retrieve payment credentials for a transaction. Use this query for Payflow Link and Payments Advanced payment methods. */
  getPayflowLinkToken?: Maybe<PayflowLinkToken>
  /** An array of options to render for selection of product */
  getProductRegistrationOptions?: Maybe<ProductRegistrationOptionsSelection>
  /** Get product registration */
  getRegistration?: Maybe<RegistrationData>
  /** This query is used to query for a single global set. */
  globalSet?: Maybe<CraftGlobalSetInterface>
  /** This query is used to query for global sets. */
  globalSets?: Maybe<Array<Maybe<CraftGlobalSetInterface>>>
  googleMapsGeocode?: Maybe<Array<Maybe<GoogleMapsGeocodeResult>>>
  googleMapsReverseGeocode?: Maybe<Array<Maybe<GoogleMapsGeocodeResult>>>
  googleTravelDistance?: Maybe<Array<Maybe<GoogleMapsTravelDistance>>>
  googleTravelDistances?: Maybe<Array<Maybe<GoogleMapsDistanceDestination>>>
  /** Entries within the homepage section. */
  homepageEntries?: Maybe<Array<Maybe<CraftHomepageSectionEntryUnion>>>
  /** Entries within the informationBalanceBikes section. */
  informationBalanceBikesEntries?: Maybe<
    Array<Maybe<CraftInformationBalanceBikesSectionEntryUnion>>
  >
  /** Entries within the informationGoCarts section. */
  informationGoCartsEntries?: Maybe<
    Array<Maybe<CraftInformationGoCartsSectionEntryUnion>>
  >
  /** Entries within the informationItemSubjects section. */
  informationItemSubjectsEntries?: Maybe<
    Array<Maybe<CraftInformationItemSubjectsSectionEntryUnion>>
  >
  /** Entries within the informationOverview section. */
  informationOverviewEntries?: Maybe<
    Array<Maybe<CraftInformationOverviewSectionEntryUnion>>
  >
  /** Entries within the informationPlaygroundEquipment section. */
  informationPlaygroundEquipmentEntries?: Maybe<
    Array<Maybe<CraftInformationPlaygroundEquipmentSectionEntryUnion>>
  >
  /** Entries within the informationRideOnCars section. */
  informationRideOnCarsEntries?: Maybe<
    Array<Maybe<CraftInformationRideOnCarsSectionEntryUnion>>
  >
  /** Entries within the informationScooters section. */
  informationScootersEntries?: Maybe<
    Array<Maybe<CraftInformationScootersSectionEntryUnion>>
  >
  /** Entries within the informationSubjectBalanceBikes section. */
  informationSubjectBalanceBikesEntries?: Maybe<
    Array<Maybe<CraftInformationSubjectBalanceBikesSectionEntryUnion>>
  >
  /** Entries within the informationSubjectGoCarts section. */
  informationSubjectGoCartsEntries?: Maybe<
    Array<Maybe<CraftInformationSubjectGoCartsSectionEntryUnion>>
  >
  /** Entries within the informationSubjectPlaygroundEquipment section. */
  informationSubjectPlaygroundEquipmentEntries?: Maybe<
    Array<Maybe<CraftInformationSubjectPlaygroundEquipmentSectionEntryUnion>>
  >
  /** Entries within the informationSubjectRideOnCars section. */
  informationSubjectRideOnCarsEntries?: Maybe<
    Array<Maybe<CraftInformationSubjectRideOnCarsSectionEntryUnion>>
  >
  /** Entries within the informationSubjectScooters section. */
  informationSubjectScootersEntries?: Maybe<
    Array<Maybe<CraftInformationSubjectScootersSectionEntryUnion>>
  >
  /** Entries within the informationSubjectTrampolines section. */
  informationSubjectTrampolinesEntries?: Maybe<
    Array<Maybe<CraftInformationSubjectTrampolinesSectionEntryUnion>>
  >
  /** Entries within the informationTrampolines section. */
  informationTrampolinesEntries?: Maybe<
    Array<Maybe<CraftInformationTrampolinesSectionEntryUnion>>
  >
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>
  /** Landing page */
  landingPage?: Maybe<LandingPage>
  /** The landingpage URL */
  landingPageUrls?: Maybe<Array<Maybe<LandingPageUrl>>>
  /** Entries within the login section. */
  loginEntries?: Maybe<Array<Maybe<CraftLoginSectionEntryUnion>>>
  /** Entries within the menuItems section. */
  menuItemsEntries?: Maybe<Array<Maybe<CraftMenuItemsSectionEntryUnion>>>
  order?: Maybe<CustomerOrder>
  /** Entries within the page section. */
  pageEntries?: Maybe<Array<Maybe<CraftPageSectionEntryUnion>>>
  ping?: Maybe<Scalars['String']['output']>
  /** Get Plate By Code */
  plateByCode?: Maybe<Plate>
  /** Query MyGoKart Plates. */
  plates?: Maybe<Array<Maybe<Plate>>>
  /** @deprecated id is deprecated, use productByUid */
  product?: Maybe<ProductInterface>
  /** Retrieve a product by UID */
  productByUid?: Maybe<ProductInterface>
  /** Entries within the productPageContent section. */
  productPageContentEntries?: Maybe<
    Array<Maybe<CraftProductPageContentSectionEntryUnion>>
  >
  /** Entries within the productPageGenericItems section. */
  productPageGenericItemsEntries?: Maybe<
    Array<Maybe<CraftProductPageGenericItemsSectionEntryUnion>>
  >
  /** Entries within the productRegistration section. */
  productRegistrationEntries?: Maybe<
    Array<Maybe<CraftProductRegistrationSectionEntryUnion>>
  >
  /** Return the active ratings attributes and the values each rating can have. */
  productReviewRatingsMetadata: ProductReviewRatingsMetadata
  /** Entries within the productTypes section. */
  productTypesEntries?: Maybe<Array<Maybe<CraftProductTypesSectionEntryUnion>>>
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products?: Maybe<Products>
  /** Get List of all products by year */
  productsByGroupAndYear?: Maybe<Array<Maybe<ProductInterface>>>
  /** Get list of spareparts per product(group), per year */
  productsBySkuOrName?: Maybe<Array<Maybe<BergProduct>>>
  /** Entries within the products section. */
  productsEntries?: Maybe<Array<Maybe<CraftProductsSectionEntryUnion>>>
  /** Entries within the requestLicensePlate section. */
  requestLicensePlateEntries?: Maybe<
    Array<Maybe<CraftRequestLicensePlateSectionEntryUnion>>
  >
  /** Entries within the review section. */
  reviewEntries?: Maybe<Array<Maybe<CraftReviewSectionEntryUnion>>>
  /** Return the full details for a specified product, category, or CMS page. */
  route?: Maybe<RoutableInterface>
  /** Entries within the search section. */
  searchEntries?: Maybe<Array<Maybe<CraftSearchSectionEntryUnion>>>
  /** Get list of group names */
  sparepartGroups?: Maybe<Array<Maybe<SparepartGroup>>>
  /** Get Valid list of years */
  sparepartYearList?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** Entries within the spareparts section. */
  sparepartsEntries?: Maybe<Array<Maybe<CraftSparepartsSectionEntryUnion>>>
  /** Return details about the store's configuration. */
  storeConfig?: Maybe<StoreConfig>
  /** Entries within the storeLocator section. */
  storeLocatorEntries?: Maybe<Array<Maybe<CraftStoreLocatorSectionEntryUnion>>>
  storesByDistance?: Maybe<Array<Maybe<CraftStoresStoreEntry>>>
  /** Entries within the stores section. */
  storesEntries?: Maybe<Array<Maybe<CraftStoresSectionEntryUnion>>>
  tweakwiseAdvisor?: Maybe<TweakwiseAdvisor>
  /** Service that returns product results and search suggestions based on a search term. This service can be called as soon as the user begins to type a search term. */
  tweakwiseAutocomplete: TweakwiseAutocompleteResult
  tweakwiseFunnel?: Maybe<TweakwiseFunnel>
  tweakwiseNavigation: TweakwiseNavigationResult
  /**
   * Returns featured recommended products, to use for example on a homepage.
   *
   * Will return `null` when the template could not be found.
   */
  tweakwiseRecommendationsFeatured?: Maybe<Array<TweakwiseNavigationItem>>
  /**
   * Returns recommended products for a product, such as for cross sell or up sell.
   *
   * Will return `null` when the template could not be found.
   */
  tweakwiseRecommendationsProduct?: Maybe<Array<TweakwiseNavigationItem>>
  /**
   * Returns recommended products for a product, such as for cross sell or up sell.
   *
   * Will use a group Key from tweakwise
   */
  tweakwiseRecommendationsProductGroup?: Maybe<Array<TweakwiseRecommendation>>
  /**
   * Service that returns all available templates for a product. Each template will contain all items matching the template.
   *
   * If a lot of rules have been set up, it is not efficient to request all rules for all products. With these web services, all products of a product can be retrieved in one go for all rules.
   *
   * Will return `null` when the product could not be found in the Tweakwise store.
   */
  tweakwiseRecommendationsProductTemplates?: Maybe<
    Array<TweakwiseProductRecommendationsTemplate>
  >
  /** Temporary for development. Remove before GO-LIVE */
  unused?: Maybe<Array<Maybe<UniqueCode>>>
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver?: Maybe<EntityUrl>
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist?: Maybe<WishlistOutput>
}

export type QueryAccountEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryAddressArgs = {
  houseNumber: Scalars['Int']['input']
  houseNumberAddition?: InputMaybe<Scalars['String']['input']>
  postcode: Scalars['String']['input']
}

export type QueryAdvreviewArgs = {
  amreviewDir?: InputMaybe<Scalars['String']['input']>
  amreviewSort?: InputMaybe<Scalars['String']['input']>
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>
  page: Scalars['Int']['input']
  productId?: InputMaybe<Scalars['Int']['input']>
  productUid: Scalars['ID']['input']
  stars?: InputMaybe<Scalars['Int']['input']>
  verifiedBuyer?: InputMaybe<Scalars['Boolean']['input']>
  withImages?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryAmReviewSettingArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAmReviewWidgetArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>
  productId?: InputMaybe<Scalars['Int']['input']>
  widgetId: Scalars['Int']['input']
}

export type QueryAssetArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryAssetCountArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryAssetsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateModified?: InputMaybe<Scalars['String']['input']>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  folderId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uploader?: InputMaybe<Scalars['CraftQueryArgument']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  volumeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryAvailablePaymentMethodsArgs = {
  language?: InputMaybe<Scalars['String']['input']>
  storeId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAvailableStoresArgs = {
  useCurrentGroup?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCartArgs = {
  cart_id: Scalars['String']['input']
}

export type QueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CategoryFilterInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCategoryByUidArgs = {
  uid: Scalars['ID']['input']
}

export type QueryCategoryEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryCategoryListArgs = {
  filters?: InputMaybe<CategoryFilterInput>
}

export type QueryCategoryPageContentEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
}

export type QueryCompareListArgs = {
  uid: Scalars['ID']['input']
}

export type QueryContactEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['String']['input']>
}

export type QueryCustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>
}

export type QueryCustomerServiceEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryCustomerServiceOverviewEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryEntryArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryEntryCountArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  sectionId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryForgotPasswordEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryGenericBlockLinksEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryGetCodeArgs = {
  uniqueCode?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetHostedProUrlArgs = {
  input: HostedProUrlInput
}

export type QueryGetPayflowLinkTokenArgs = {
  input: PayflowLinkTokenInput
}

export type QueryGetProductRegistrationOptionsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  selectedOptions?: InputMaybe<
    Array<InputMaybe<ProductRegistrationOptionInput>>
  >
}

export type QueryGetRegistrationArgs = {
  warranty_code: Scalars['String']['input']
}

export type QueryGlobalSetArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaKeywords?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryGlobalSetsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaKeywords?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryGoogleMapsGeocodeArgs = {
  search: Scalars['String']['input']
}

export type QueryGoogleMapsReverseGeocodeArgs = {
  coordinates: GoogleMapsGeocodeLocationInput
}

export type QueryGoogleTravelDistanceArgs = {
  from: GoogleMapsGeocodeLocationInput
  to: GoogleMapsGeocodeLocationInput
}

export type QueryGoogleTravelDistancesArgs = {
  input: GoogleMapsDistanceDestinationsInput
}

export type QueryHomepageEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationBalanceBikesEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationGoCartsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationItemSubjectsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationOverviewEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationPlaygroundEquipmentEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationRideOnCarsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationScootersEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationSubjectBalanceBikesEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationSubjectGoCartsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationSubjectPlaygroundEquipmentEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationSubjectRideOnCarsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationSubjectScootersEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationSubjectTrampolinesEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryInformationTrampolinesEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryIsEmailAvailableArgs = {
  email: Scalars['String']['input']
}

export type QueryLandingPageArgs = {
  url_path: Scalars['String']['input']
}

export type QueryLandingPageUrlsArgs = {
  current_uri?: InputMaybe<Scalars['String']['input']>
  facets: Array<InputMaybe<FacetInput>>
  selected_facets?: InputMaybe<Array<InputMaybe<FacetInput>>>
  tweakwise_item_number: Array<InputMaybe<Scalars['Int']['input']>>
  uid: Scalars['ID']['input']
}

export type QueryLoginEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryMenuItemsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryOrderArgs = {
  orderMaskId: Scalars['String']['input']
}

export type QueryPageEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryPlateByCodeArgs = {
  uniqueCode?: InputMaybe<Scalars['String']['input']>
}

export type QueryPlatesArgs = {
  plate_id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryProductArgs = {
  id: Scalars['Int']['input']
}

export type QueryProductByUidArgs = {
  uid: Scalars['ID']['input']
}

export type QueryProductPageContentEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryProductPageGenericItemsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryProductRegistrationEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryProductTypesEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<ProductAttributeFilterInput>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<ProductAttributeSortInput>
}

export type QueryProductsByGroupAndYearArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  productGroup: Scalars['Int']['input']
  year: Scalars['Int']['input']
}

export type QueryProductsBySkuOrNameArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  search: Scalars['String']['input']
  searchtype?: InputMaybe<Scalars['String']['input']>
}

export type QueryProductsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryRequestLicensePlateEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryReviewEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryRouteArgs = {
  url: Scalars['String']['input']
}

export type QuerySearchEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QuerySparepartsEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryStoreLocatorEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryStoresByDistanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  referenceLatitude?: InputMaybe<Scalars['Float']['input']>
  referenceLongitude?: InputMaybe<Scalars['Float']['input']>
  site?: InputMaybe<Scalars['String']['input']>
}

export type QueryStoresEntriesArgs = {
  address1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  address2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  after?: InputMaybe<Scalars['String']['input']>
  ancestorDist?: InputMaybe<Scalars['Int']['input']>
  ancestorOf?: InputMaybe<Scalars['Int']['input']>
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  authorGroupId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  authorId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  before?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  country?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  descendantDist?: InputMaybe<Scalars['Int']['input']>
  descendantOf?: InputMaybe<Scalars['Int']['input']>
  disclaimer?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  editable?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>
  genericBlockLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  image2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  inReverse?: InputMaybe<Scalars['Boolean']['input']>
  latitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  leaves?: InputMaybe<Scalars['Boolean']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  lightswitchChecked?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchChecked2?: InputMaybe<Scalars['Boolean']['input']>
  lightswitchUnchecked?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  linkField?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  longitude?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaDescription?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  metaTitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>
  number?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  phoneNumberLink?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  positionedAfter?: InputMaybe<Scalars['Int']['input']>
  positionedBefore?: InputMaybe<Scalars['Int']['input']>
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  preferSites?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  relatedTo?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAll?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  relatedToAssets?: InputMaybe<Array<InputMaybe<CraftAssetCriteriaInput>>>
  relatedToCategories?: InputMaybe<
    Array<InputMaybe<CraftCategoryCriteriaInput>>
  >
  relatedToEntries?: InputMaybe<Array<InputMaybe<CraftEntryCriteriaInput>>>
  relatedToTags?: InputMaybe<Array<InputMaybe<CraftTagCriteriaInput>>>
  relatedToUsers?: InputMaybe<Array<InputMaybe<CraftUserCriteriaInput>>>
  richText1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richText2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple1?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple3?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  richTextSimple4?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  search?: InputMaybe<Scalars['String']['input']>
  show?: InputMaybe<Scalars['Boolean']['input']>
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  siteId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  siteSettingsId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  storeId?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  structureId?: InputMaybe<Scalars['Int']['input']>
  subtitle?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  subtitle2?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  text1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  text2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time1?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  time2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title2?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  title3?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  typeId?: InputMaybe<Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>>
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  unique?: InputMaybe<Scalars['Boolean']['input']>
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  website?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  weekDays?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
  withStructure?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<
    Array<InputMaybe<Scalars['CraftQueryArgument']['input']>>
  >
}

export type QueryTweakwiseAdvisorArgs = {
  params: TweakwiseAdvisorParams
}

export type QueryTweakwiseAutocompleteArgs = {
  params?: InputMaybe<TweakwiseAutocompleteParams>
  query: Scalars['String']['input']
}

export type QueryTweakwiseFunnelArgs = {
  params?: InputMaybe<TweakwiseFunnelParams>
}

export type QueryTweakwiseNavigationArgs = {
  params?: InputMaybe<TweakwiseNavigationParams>
}

export type QueryTweakwiseRecommendationsFeaturedArgs = {
  params?: InputMaybe<TweakwiseRecommendationsFeaturedParams>
  templateId: Scalars['ID']['input']
}

export type QueryTweakwiseRecommendationsProductArgs = {
  itemNo: Scalars['ID']['input']
  params?: InputMaybe<TweakwiseRecommendationsFeaturedParams>
  templateId: Scalars['ID']['input']
}

export type QueryTweakwiseRecommendationsProductGroupArgs = {
  groupKey: Scalars['ID']['input']
  itemNo: Scalars['ID']['input']
  params?: InputMaybe<TweakwiseRecommendationsFeaturedParams>
}

export type QueryTweakwiseRecommendationsProductTemplatesArgs = {
  itemNo: Scalars['ID']['input']
  params?: InputMaybe<TweakwiseRecommendationsFeaturedParams>
}

export type QueryUrlResolverArgs = {
  url: Scalars['String']['input']
}

export type Rating = {
  __typename?: 'Rating'
  ratingCode: Scalars['String']['output']
  ratingId: Scalars['Int']['output']
  ratingOptions?: Maybe<Array<Maybe<RatingOption>>>
}

export type RatingOption = {
  __typename?: 'RatingOption'
  optionId: Scalars['Int']['output']
  /** Votes. */
  options?: Maybe<Array<Maybe<RatingOptionValues>>>
  /** Option name. */
  ratingCode?: Maybe<Scalars['String']['output']>
  /** Option id. */
  ratingId?: Maybe<Scalars['Int']['output']>
  value: Scalars['Int']['output']
}

export type RatingOptionValues = {
  __typename?: 'RatingOptionValues'
  /** Rating option code. */
  code?: Maybe<Scalars['String']['output']>
  /** Rating option id. */
  optionId?: Maybe<Scalars['Int']['output']>
  /** Rating option position. */
  position?: Maybe<Scalars['Int']['output']>
  /** Rating option value. */
  value?: Maybe<Scalars['Int']['output']>
}

export type RatingVote = {
  __typename?: 'RatingVote'
  /** Customer id. */
  customerId?: Maybe<Scalars['Int']['output']>
  /** Product id. */
  entityPkValue?: Maybe<Scalars['Int']['output']>
  /** Option id. */
  optionId?: Maybe<Scalars['Int']['output']>
  /** Percent. */
  percent?: Maybe<Scalars['Int']['output']>
  /** Rating code. */
  ratingCode?: Maybe<Scalars['String']['output']>
  /** Rating id. */
  ratingId?: Maybe<Scalars['Int']['output']>
  /** Review id. */
  reviewId?: Maybe<Scalars['Int']['output']>
  /** Store id. */
  storeId?: Maybe<Scalars['Int']['output']>
  /** Value. */
  value?: Maybe<Scalars['Int']['output']>
  /** Vote id. */
  voteId?: Maybe<Scalars['Int']['output']>
}

export type RefreshCustomerTokenInput = {
  /** The customer's refresh token */
  refresh_token: Scalars['String']['input']
}

export type RefreshCustomerTokenOutput = {
  __typename?: 'RefreshCustomerTokenOutput'
  accessToken: Scalars['String']['output']
  refreshToken: Scalars['String']['output']
}

export type Region = {
  __typename?: 'Region'
  /** The two-letter code for the region, such as TX for Texas. */
  code?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `Region` object. */
  id?: Maybe<Scalars['Int']['output']>
  /** The name of the region, such as Texas. */
  name?: Maybe<Scalars['String']['output']>
}

/** The data for registration */
export type RegistrationData = {
  __typename?: 'RegistrationData'
  /** The batch number */
  batchNumber: Scalars['String']['output']
  /** The url to the certificate */
  certificateFile?: Maybe<Scalars['String']['output']>
  /** Customer city */
  city: Scalars['String']['output']
  /** Customer country */
  countryId: Scalars['String']['output']
  /** The date created */
  createdAt: Scalars['String']['output']
  /** Customer email */
  email: Scalars['String']['output']
  /** The entry ID */
  entityId: Scalars['ID']['output']
  /** The expiry date */
  expiryDate: Scalars['String']['output']
  /** Customer firstname */
  firstname: Scalars['String']['output']
  /** Customer lastname */
  lastname: Scalars['String']['output']
  /** Customer middlename */
  middlename?: Maybe<Scalars['String']['output']>
  /** The order number */
  orderNumber?: Maybe<Scalars['String']['output']>
  /** Postcode */
  postcode: Scalars['String']['output']
  /** The product SKU */
  productSku: Scalars['String']['output']
  /** The purchase date */
  purchaseDate: Scalars['String']['output']
  /** Receipt file */
  receiptFile: Scalars['String']['output']
  /** Region */
  region?: Maybe<Scalars['String']['output']>
  /** Region id */
  regionId?: Maybe<Scalars['String']['output']>
  /** Customer Street */
  street1: Scalars['String']['output']
  /** Customer Street 2 (e.g. house number */
  street2: Scalars['String']['output']
  /** Customer Street 3 */
  street3?: Maybe<Scalars['String']['output']>
  /** Telephone number */
  telephone: Scalars['String']['output']
  /** The generated warranty code */
  warrantyCode: Scalars['String']['output']
}

/** The data for registration */
export type RegistrationInput = {
  /** The batch number */
  batch_number: Scalars['String']['input']
  /** Customer city */
  city: Scalars['String']['input']
  /** Customer country */
  country_id: Scalars['String']['input']
  /** Customer email */
  email: Scalars['String']['input']
  /** Customer firstname */
  firstname: Scalars['String']['input']
  /** Customer lastname */
  lastname: Scalars['String']['input']
  /** Customer middlename */
  middlename?: InputMaybe<Scalars['String']['input']>
  /** The order number */
  order_number?: InputMaybe<Scalars['String']['input']>
  /** Postcode */
  postcode: Scalars['String']['input']
  /** The product SKU */
  product_sku: Scalars['String']['input']
  /** The purchase date */
  purchase_date: Scalars['String']['input']
  /** Receipt file */
  receipt_file?: InputMaybe<Scalars['String']['input']>
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>
  /** Region id */
  region_id?: InputMaybe<Scalars['String']['input']>
  /** Customer Street */
  street_1: Scalars['String']['input']
  /** Customer Street 2 (e.g. house number */
  street_2: Scalars['String']['input']
  /** Customer Street 3 */
  street_3?: InputMaybe<Scalars['String']['input']>
  /** Telephone number */
  telephone: Scalars['String']['input']
}

/** Specifies the cart from which to remove a coupon. */
export type RemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
}

/** Contains details about the cart after removing a coupon. */
export type RemoveCouponFromCartOutput = {
  __typename?: 'RemoveCouponFromCartOutput'
  /** The cart after removing a coupon. */
  cart?: Maybe<Cart>
}

/** Specifies which items to remove from the cart. */
export type RemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']['input']>
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']['input']>
}

/** Contains details about the cart after removing an item. */
export type RemoveItemFromCartOutput = {
  __typename?: 'RemoveItemFromCartOutput'
  /** The cart after removing an item. */
  cart: Cart
}

/** Defines which products to remove from a compare list. */
export type RemoveProductsFromCompareListInput = {
  /** An array of product IDs to remove from the compare list. */
  products: Array<InputMaybe<Scalars['ID']['input']>>
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID']['input']
}

/** Contains the customer's wish list and any errors encountered. */
export type RemoveProductsFromWishlistOutput = {
  __typename?: 'RemoveProductsFromWishlistOutput'
  /** An array of errors encountered while deleting products from a wish list. */
  userErrors: Array<Maybe<WishListUserInputError>>
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: Wishlist
}

/** Contains the cart and any errors after adding products. */
export type ReorderItemsOutput = {
  __typename?: 'ReorderItemsOutput'
  /** Detailed information about the customer's cart. */
  cart: Cart
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<CheckoutUserInputError>>
}

export type Review = {
  __typename?: 'Review'
  /** Answer. */
  answer?: Maybe<Scalars['String']['output']>
  /** Comments. */
  comments?: Maybe<Array<Maybe<Comment>>>
  /** Created at. */
  createdAt?: Maybe<Scalars['String']['output']>
  /** Reviewer id. */
  customerId?: Maybe<Scalars['Int']['output']>
  /** Review detail. */
  detail?: Maybe<Scalars['String']['output']>
  /** Detail id. */
  detailId?: Maybe<Scalars['Int']['output']>
  /** Entity code. */
  entityCode?: Maybe<Scalars['String']['output']>
  /** Entity id. */
  entityId?: Maybe<Scalars['Int']['output']>
  /** Product id. */
  entityPkValue?: Maybe<Scalars['Int']['output']>
  /** Guest email. */
  guestEmail?: Maybe<Scalars['String']['output']>
  /** Images. */
  images?: Maybe<Array<Maybe<Images>>>
  /** Reomended. */
  isRecommended?: Maybe<Scalars['Boolean']['output']>
  /** Advantages. */
  likeAbout?: Maybe<Scalars['String']['output']>
  /** Minus review. */
  minusReview?: Maybe<Scalars['String']['output']>
  /** Reviewer name. */
  nickname?: Maybe<Scalars['String']['output']>
  /** Disadvantages. */
  notLikeAbout?: Maybe<Scalars['String']['output']>
  /** Plus review. */
  plusReview?: Maybe<Scalars['String']['output']>
  /** Rating votes. */
  ratingVotes?: Maybe<Array<Maybe<RatingVote>>>
  /** Review id. */
  reviewId?: Maybe<Scalars['Int']['output']>
  /** Status id. */
  statusId?: Maybe<Scalars['Int']['output']>
  /** Review title. */
  title?: Maybe<Scalars['String']['output']>
  /** Verified buyer. */
  verifiedBuyer?: Maybe<Scalars['Int']['output']>
}

export type ReviewFilter = {
  __typename?: 'ReviewFilter'
  code: Scalars['String']['output']
  label: Scalars['String']['output']
}

export type ReviewOrder = {
  __typename?: 'ReviewOrder'
  code: Scalars['String']['output']
  label: Scalars['String']['output']
}

export type ReviewsData = {
  __typename?: 'ReviewsData'
  /** Detailed summary. */
  detailedSummary?: Maybe<DetailedSummary>
  /** Reviews. */
  items?: Maybe<Array<Maybe<Review>>>
  /** The product UID */
  productUid: Scalars['ID']['output']
  /** Votes. */
  ratingOptions?: Maybe<Array<Maybe<RatingOption>>>
  /** Rating summary. */
  ratingSummary?: Maybe<Scalars['Int']['output']>
  /** Rating summary value. */
  ratingSummaryValue?: Maybe<Scalars['Float']['output']>
  /** Recomended percent. */
  recomendedPercent?: Maybe<Scalars['Int']['output']>
  /** Total records. */
  totalRecords?: Maybe<Scalars['Int']['output']>
  /** Total records with applied filters. */
  totalRecordsFiltered?: Maybe<Scalars['Int']['output']>
}

/** Contains the result of a request to revoke a customer token. */
export type RevokeCustomerTokenOutput = {
  __typename?: 'RevokeCustomerTokenOutput'
  /** The result of a request to revoke a customer token. */
  result: Scalars['Boolean']['output']
}

/** Routable entities serve as the model for a rendered page. */
export type RoutableInterface = {
  /** Craft entry type */
  entryType?: Maybe<Scalars['String']['output']>
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode: Scalars['Int']['output']
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relativeUrl?: Maybe<Scalars['String']['output']>
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>
}

/** Contains details about a comment. */
export type SalesCommentItem = {
  __typename?: 'SalesCommentItem'
  /** The text of the message. */
  message: Scalars['String']['output']
  /** The timestamp of the comment. */
  timestamp: Scalars['String']['output']
}

export type SalesItemInterface = {
  __typename?: 'SalesItemInterface'
  /** The entered gift message for the order item */
  giftMessage?: Maybe<GiftMessage>
}

/** Provides navigation for the query response. */
export type SearchResultPageInfo = {
  __typename?: 'SearchResultPageInfo'
  /** The specific page to return. */
  currentPage?: Maybe<Scalars['Int']['output']>
  /** The maximum number of items to return per page of results. */
  pageSize?: Maybe<Scalars['Int']['output']>
  /** The total number of pages in the response. */
  totalPages?: Maybe<Scalars['Int']['output']>
}

/** A string that contains search suggestion */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion'
  /** The search suggestion of existing product. */
  search: Scalars['String']['output']
}

/** Contains details about a selected bundle option. */
export type SelectedBundleOption = {
  __typename?: 'SelectedBundleOption'
  /** @deprecated Use `uid` instead */
  id: Scalars['Int']['output']
  /** The display name of the selected bundle product option. */
  label: Scalars['String']['output']
  /** The type of selected bundle product option. */
  type: Scalars['String']['output']
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars['ID']['output']
  /** An array of selected bundle option values. */
  values: Array<Maybe<SelectedBundleOptionValue>>
}

/** Contains details about a value for a selected bundle option. */
export type SelectedBundleOptionValue = {
  __typename?: 'SelectedBundleOptionValue'
  /** Use `uid` instead */
  id: Scalars['Int']['output']
  /** The display name of the value for the selected bundle product option. */
  label: Scalars['String']['output']
  /** The price of the value for the selected bundle product option. */
  price: Scalars['Float']['output']
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars['Float']['output']
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars['ID']['output']
}

/** Contains details about a selected configurable option. */
export type SelectedConfigurableOption = {
  __typename?: 'SelectedConfigurableOption'
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurableProductOptionUid: Scalars['ID']['output']
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurableProductOptionValueUid: Scalars['ID']['output']
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars['Int']['output']
  /** The display text for the option. */
  optionLabel: Scalars['String']['output']
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  valueId: Scalars['Int']['output']
  /** The display name of the selected configurable option. */
  valueLabel: Scalars['String']['output']
}

/** Identifies a customized product that has been placed in a cart. */
export type SelectedCustomizableOption = {
  __typename?: 'SelectedCustomizableOption'
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizableOptionUid: Scalars['ID']['output']
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars['Int']['output']
  /** Indicates whether the customizable option is required. */
  isRequired: Scalars['Boolean']['output']
  /** The display name of the selected customizable option. */
  label: Scalars['String']['output']
  /** A value indicating the order to display this option. */
  sortOrder: Scalars['Int']['output']
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars['String']['output']
  /** An array of selectable values. */
  values: Array<Maybe<SelectedCustomizableOptionValue>>
}

/** Identifies the value of the selected customized option. */
export type SelectedCustomizableOptionValue = {
  __typename?: 'SelectedCustomizableOptionValue'
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizableOptionValueUid: Scalars['ID']['output']
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars['Int']['output']
  /** The display name of the selected value. */
  label: Scalars['String']['output']
  /** The price of the selected customizable value. */
  price: CartItemSelectedOptionValuePrice
  /** The text identifying the selected value. */
  value: Scalars['String']['output']
}

/** Describes the payment method the shopper selected. */
export type SelectedPaymentMethod = {
  __typename?: 'SelectedPaymentMethod'
  /** The payment method code. */
  code: Scalars['String']['output']
  /** The purchase order number. */
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>
  /** The payment method title. */
  title: Scalars['String']['output']
}

/** Contains details about the selected shipping method and carrier. */
export type SelectedShippingMethod = {
  __typename?: 'SelectedShippingMethod'
  /** The cost of shipping using this shipping method. */
  amount: Money
  /** @deprecated The field should not be used on the storefront. */
  baseAmount?: Maybe<Money>
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrierCode: Scalars['String']['output']
  /** The label for the carrier code. */
  carrierTitle: Scalars['String']['output']
  /** A shipping method code associated with a carrier. */
  methodCode: Scalars['String']['output']
  /** The label for the method code. */
  methodTitle: Scalars['String']['output']
}

/** Sets the billing address. */
export type SetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: BillingAddressInput
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
}

/** Contains details about the cart after setting the billing address. */
export type SetBillingAddressOnCartOutput = {
  __typename?: 'SetBillingAddressOnCartOutput'
  /** The cart after setting the billing address. */
  cart: Cart
}

/** Defines the guest email and cart. */
export type SetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** The email address of the guest. */
  email: Scalars['String']['input']
}

/** Contains details about the cart after setting the email of a guest. */
export type SetGuestEmailOnCartOutput = {
  __typename?: 'SetGuestEmailOnCartOutput'
  /** The cart after setting the guest email. */
  cart: Cart
}

/** Applies a payment method to the quote. */
export type SetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput
}

/** Applies a payment method to the cart. */
export type SetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput
}

/** Contains details about the cart after setting the payment method. */
export type SetPaymentMethodOnCartOutput = {
  __typename?: 'SetPaymentMethodOnCartOutput'
  /** The cart after setting the payment method. */
  cart: Cart
}

/** Specifies an array of addresses to use for shipping. */
export type SetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>
}

/** Contains details about the cart after setting the shipping addresses. */
export type SetShippingAddressesOnCartOutput = {
  __typename?: 'SetShippingAddressesOnCartOutput'
  /** The cart after setting the shipping addresses. */
  cart: Cart
}

/** Applies one or shipping methods to the cart. */
export type SetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>
}

/** Contains details about the cart after setting the shipping methods. */
export type SetShippingMethodsOnCartOutput = {
  __typename?: 'SetShippingMethodsOnCartOutput'
  /** The cart after setting the shipping methods. */
  cart: Cart
}

/** Defines whether bundle items must be shipped together. */
export enum ShipBundleItemsEnum {
  /** @deprecated  */
  SEPARATELY = 'SEPARATELY',
  /** @deprecated  */
  TOGETHER = 'TOGETHER',
}

export type ShipmentItem = ShipmentItemInterface & {
  __typename?: 'ShipmentItem'
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output']
  /** The order item associated with the shipment item. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of shipped items. */
  quantityShipped: Scalars['Float']['output']
}

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output']
  /** The order item associated with the shipment item. */
  orderItem?: Maybe<OrderItemInterface>
  /** The name of the base product. */
  productName?: Maybe<Scalars['String']['output']>
  /** The sale price for the base product. */
  productSalePrice: Money
  /** The SKU of the base product. */
  productSku: Scalars['String']['output']
  /** The number of shipped items. */
  quantityShipped: Scalars['Float']['output']
}

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  __typename?: 'ShipmentTracking'
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String']['output']
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']['output']>
  /** The shipment tracking title. */
  title: Scalars['String']['output']
}

/** Defines a single shipping address. */
export type ShippingAddressInput = {
  /** Defines a shipping address. */
  address?: InputMaybe<CartAddressInput>
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id?: InputMaybe<Scalars['Int']['input']>
  /** Text provided by the shopper. */
  customer_notes?: InputMaybe<Scalars['String']['input']>
  /** The code of Pickup Location which will be used for In-Store Pickup. */
  pickup_location_code?: InputMaybe<Scalars['String']['input']>
}

/** Contains shipping addresses and methods. */
export type ShippingCartAddress = CartAddressInterface & {
  __typename?: 'ShippingCartAddress'
  /** An array that lists the shipping methods that can be applied to the cart. */
  availableShippingMethods?: Maybe<Array<Maybe<AvailableShippingMethod>>>
  /** @deprecated Use `cart_items_v2` instead. */
  cartItems?: Maybe<Array<Maybe<CartItemQuantity>>>
  /** An array that lists the items in the cart. */
  cartItemsV2?: Maybe<Array<Maybe<CartItemInterface>>>
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output']
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>
  /** An object containing the country label and code. */
  country: CartAddressCountry
  /** Text provided by the shopper. */
  customerNotes?: Maybe<Scalars['String']['output']>
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output']
  /** @deprecated This information should not be exposed on the frontend. */
  itemsWeight?: Maybe<Scalars['Float']['output']>
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output']
  pickupLocationCode?: Maybe<Scalars['String']['output']>
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>
  /** An object that describes the selected shipping method. */
  selectedShippingMethod?: Maybe<SelectedShippingMethod>
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>
}

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  __typename?: 'ShippingDiscount'
  /** The amount of the discount. */
  amount: Money
}

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  __typename?: 'ShippingHandling'
  /** The shipping amount, excluding tax. */
  amountExcludingTax?: Maybe<Money>
  /** The shipping amount, including tax. */
  amountIncludingTax?: Maybe<Money>
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>
  /** The total amount for shipping. */
  totalAmount: Money
}

/** Defines the shipping carrier and method. */
export type ShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars['String']['input']
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars['String']['input']
}

/** An implementation for simple product cart items. */
export type SimpleCartItem = CartItemInterface & {
  __typename?: 'SimpleCartItem'
  /** An array containing the customizable options the shopper selected. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** The entered gift message for the cart item */
  giftMessage?: Maybe<GiftMessage>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output']
  /** PreOrder info */
  preorder?: Maybe<PreOrder>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output']
}

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'SimpleProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    addOn?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    aerowall?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    ageRecommended?: Maybe<Scalars['Int']['output']>
    /** Ambiance Product Images */
    ambianceGallery?: Maybe<Array<Maybe<AmbianceGallery>>>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attributeSetId?: Maybe<Scalars['Int']['output']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonicalUrl?: Maybe<Scalars['String']['output']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    collaborationLicense?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    colorVariant?: Maybe<Scalars['String']['output']>
    /** Color Variants */
    colorVariants?: Maybe<Array<Maybe<ColorVariant>>>
    /** Configurable Link */
    configurableLink?: Maybe<Array<Maybe<Scalars['String']['output']>>>
    /** The product's country of origin. */
    countryOfManufacture?: Maybe<Scalars['String']['output']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    createdAt?: Maybe<Scalars['String']['output']>
    /** Crosssell Products */
    crosssellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    drive?: Maybe<Scalars['Int']['output']>
    /** Filterable attribute with Text */
    dynamicAttributes?: Maybe<Array<Maybe<DynamicAttribute>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    electricalSupport?: Maybe<Scalars['Int']['output']>
    /** Craft entry type */
    entryType?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    framePlaybase?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    frameXlGokart?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gears?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['Int']['output']>
    /** Indicates whether a gift message is available. */
    giftMessageAvailable?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gokartType?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    handbrake?: Maybe<Scalars['Int']['output']>
    /** Highlight attributes */
    highlightedAttributes?: Maybe<Array<Maybe<HighlightAttribute>>>
    /** Highlight attributes PLP */
    highlightedAttributesPlp?: Maybe<Array<Maybe<HighlightAttribute>>>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Scalars['Int']['output']
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** @deprecated Use the `custom_attributes` field instead. */
    inclSafetynet?: Maybe<Scalars['Int']['output']>
    /** Whether the product is a main product or not. */
    isMainProduct: Scalars['Boolean']['output']
    /** @deprecated Use the `custom_attributes` field instead. */
    jumpMat?: Maybe<Scalars['Int']['output']>
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxUserWeight?: Maybe<Scalars['Int']['output']>
    /** An array of media gallery objects. */
    mediaGallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    mediaGalleryEntries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    metaDescription?: Maybe<Scalars['String']['output']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    metaKeyword?: Maybe<Scalars['String']['output']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    metaTitle?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    minLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    model?: Maybe<Scalars['Int']['output']>
    /** The product name. Customers use this name to identify the product. */
    name: Scalars['String']['output']
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    newFromDate?: Maybe<Scalars['String']['output']>
    /** The end date for new product listings. */
    newToDate?: Maybe<Scalars['String']['output']>
    /** Product stock only x left count */
    onlyXLeftInStock?: Maybe<Scalars['Float']['output']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    optionsContainer?: Maybe<Scalars['String']['output']>
    /** Configurable Link */
    parentData?: Maybe<ParentData>
    /** @deprecated Use the `custom_attributes` field instead. */
    pedals?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    playbaseSet?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    possibilityFor2ndSeat?: Maybe<Scalars['Int']['output']>
    /** PreOrder info */
    preorder?: Maybe<PreOrder>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    priceRange: PriceRange
    /** An array of `TierPrice` objects. */
    priceTiers?: Maybe<Array<Maybe<TierPrice>>>
    /** Product downloads */
    productDownloads?: Maybe<ProductDownload>
    /** An array of `ProductLinks` objects. */
    productLinks?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    productStatus?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pushRod?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityLine?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityStars?: Maybe<Scalars['Int']['output']>
    /** Review rating summary value. */
    ratingSummary?: Maybe<Scalars['Float']['output']>
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirectCode: Scalars['Int']['output']
    /** An array of products to be displayed in a Related Products block. */
    relatedProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relativeUrl?: Maybe<Scalars['String']['output']>
    /** Review amount of records. */
    reviewCount?: Maybe<Scalars['Int']['output']>
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    safetynetType?: Maybe<Scalars['Int']['output']>
    /** A short description of the product. Its use depends on the theme. */
    shortDescription?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeAirtrack?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeBeachwagon?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeClothing?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeJumpMat?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeStep?: Maybe<Scalars['Int']['output']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Scalars['String']['output']
    /** The relative path to the small image, which is used on catalog pages. */
    smallImage?: Maybe<ProductImage>
    /** Get list of spareparts per product(group), per year */
    sparepartLinks?: Maybe<Array<Maybe<BergProduct>>>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    specialFromDate?: Maybe<Scalars['String']['output']>
    /** The discounted price of the product. */
    specialPrice?: Maybe<Scalars['Float']['output']>
    /** The end date for a product with a special price. */
    specialToDate?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    springType?: Maybe<Scalars['Int']['output']>
    /** Stock status of the product */
    stockStatus?: Maybe<ProductStockStatus>
    /** The file name of a swatch image. */
    swatchImage?: Maybe<Scalars['String']['output']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrice?: Maybe<Scalars['Float']['output']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineShape?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineType?: Maybe<Scalars['Int']['output']>
    /** Tweakwise ID */
    tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
    /** PreOrder info */
    tweakwiseTemplates?: Maybe<TweakwiseTemplates>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    typeId?: Maybe<Scalars['String']['output']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']['output']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updatedAt?: Maybe<Scalars['String']['output']>
    /** Upsell Products */
    upsellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    urlKey: Scalars['String']['output']
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    urlPath?: Maybe<Scalars['String']['output']>
    /** URL rewrites list */
    urlRewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    urlSuffix?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    uvProtection?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    warranty?: Maybe<Scalars['Int']['output']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    wheelLights?: Maybe<Scalars['Int']['output']>
  }

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Defines a single product to add to the cart. */
export type SimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput
}

/** Contains a simple product wish list item. */
export type SimpleWishlistItem = WishlistItemInterface & {
  __typename?: 'SimpleWishlistItem'
  /** The date and time the item was added to the wish list. */
  addedAt: Scalars['String']['output']
  /** Custom options selected for the wish list item. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output']
}

/** Indicates whether to return results in ascending or descending order. */
export enum SortEnum {
  /** @deprecated  */
  ASC = 'ASC',
  /** @deprecated  */
  DESC = 'DESC',
}

/** Defines a possible sort field. */
export type SortField = {
  __typename?: 'SortField'
  /** The label of the sort field. */
  label?: Maybe<Scalars['String']['output']>
  /** The attribute code of the sort field. */
  value?: Maybe<Scalars['String']['output']>
}

/** Contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields'
  /** The default sort field value. */
  default?: Maybe<Scalars['String']['output']>
  /** An array of possible sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>
}

export type SparepartGroup = {
  __typename?: 'SparepartGroup'
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
}

/** Contains information about a store's configuration. */
export type StoreConfig = {
  __typename?: 'StoreConfig'
  /** Indicates whether guest users can write product reviews. Possible values: 1 (Yes) and 0 (No). */
  allowGuestsToWriteProductReviews?: Maybe<Scalars['String']['output']>
  /** The value of the Allow Gift Messages for Order Items option */
  allowItems?: Maybe<Scalars['String']['output']>
  /** The value of the Allow Gift Messages on Order Level option */
  allowOrder?: Maybe<Scalars['String']['output']>
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocompleteOnStorefront?: Maybe<Scalars['Boolean']['output']>
  /** The base currency code. */
  baseCurrencyCode?: Maybe<Scalars['String']['output']>
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  baseLinkUrl?: Maybe<Scalars['String']['output']>
  /** The fully-qualified URL that specifies the location of media files. */
  baseMediaUrl?: Maybe<Scalars['String']['output']>
  /** The fully-qualified URL that specifies the location of static view files. */
  baseStaticUrl?: Maybe<Scalars['String']['output']>
  /** The store’s fully-qualified base URL. */
  baseUrl?: Maybe<Scalars['String']['output']>
  /** The default sort order of the search results list. */
  catalogDefaultSortBy?: Maybe<Scalars['String']['output']>
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  categoryFixedProductTaxDisplaySetting?: Maybe<FixedProductTaxDisplaySettings>
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  categoryUrlSuffix?: Maybe<Scalars['String']['output']>
  /** Indicates whether only specific countries can use this payment method. */
  checkMoneyOrderEnableForSpecificCountries?: Maybe<
    Scalars['Boolean']['output']
  >
  /** Indicates whether the Check/Money Order payment method is enabled. */
  checkMoneyOrderEnabled?: Maybe<Scalars['Boolean']['output']>
  /** The name of the party to whom the check must be payable. */
  checkMoneyOrderMakeCheckPayableTo?: Maybe<Scalars['String']['output']>
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  checkMoneyOrderMaxOrderTotal?: Maybe<Scalars['String']['output']>
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  checkMoneyOrderMinOrderTotal?: Maybe<Scalars['String']['output']>
  /** The status of new orders placed using the Check/Money Order payment method. */
  checkMoneyOrderNewOrderStatus?: Maybe<Scalars['String']['output']>
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  checkMoneyOrderPaymentFromSpecificCountries?: Maybe<
    Scalars['String']['output']
  >
  /** The full street address or PO Box where the checks are mailed. */
  checkMoneyOrderSendCheckTo?: Maybe<Scalars['String']['output']>
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  checkMoneyOrderSortOrder?: Maybe<Scalars['Int']['output']>
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  checkMoneyOrderTitle?: Maybe<Scalars['String']['output']>
  /** The name of the CMS page that identifies the home page for the store. */
  cmsHomePage?: Maybe<Scalars['String']['output']>
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cmsNoCookies?: Maybe<Scalars['String']['output']>
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cmsNoRoute?: Maybe<Scalars['String']['output']>
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code?: Maybe<Scalars['String']['output']>
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurableThumbnailSource?: Maybe<Scalars['String']['output']>
  defaultCountryId?: Maybe<Scalars['String']['output']>
  /** The default display currency code. */
  defaultDisplayCurrencyCode?: Maybe<Scalars['String']['output']>
  disableEcommerce?: Maybe<Scalars['Boolean']['output']>
  /** The landing page that is associated with the base URL. */
  front?: Maybe<Scalars['String']['output']>
  /** The default number of products per page in Grid View. */
  gridPerPage?: Maybe<Scalars['Int']['output']>
  /** A list of numbers that define how many products can be displayed in Grid View. */
  gridPerPageValues?: Maybe<Scalars['String']['output']>
  /** GTM Container IDs, optional a comma separated list of Container IDs */
  gtmContainerIds?: Maybe<Scalars['String']['output']>
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the store view has been designated as the default within the store group. */
  isDefaultStore?: Maybe<Scalars['Boolean']['output']>
  /** Indicates whether the store group has been designated as the default within the website. */
  isDefaultStoreGroup?: Maybe<Scalars['Boolean']['output']>
  /** The format of the search results list. */
  listMode?: Maybe<Scalars['String']['output']>
  /** The default number of products per page in List View. */
  listPerPage?: Maybe<Scalars['Int']['output']>
  /** A list of numbers that define how many products can be displayed in List View. */
  listPerPageValues?: Maybe<Scalars['String']['output']>
  /** The store locale. */
  locale?: Maybe<Scalars['String']['output']>
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magentoWishlistGeneralIsEnabled?: Maybe<Scalars['String']['output']>
  /** The minimum number of characters required for a valid password. */
  minimumPasswordLength?: Maybe<Scalars['String']['output']>
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  noRoute?: Maybe<Scalars['String']['output']>
  /** Payflow Pro vault status. */
  paymentPayflowproCcVaultActive?: Maybe<Scalars['String']['output']>
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  productFixedProductTaxDisplaySetting?: Maybe<FixedProductTaxDisplaySettings>
  /** Indicates whether product reviews are enabled. Possible values: 1 (Yes) and 0 (No). */
  productReviewsEnabled?: Maybe<Scalars['String']['output']>
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  productUrlSuffix?: Maybe<Scalars['String']['output']>
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  requiredCharacterClassesNumber?: Maybe<Scalars['String']['output']>
  /** Magento 2 Theme Robots.txt value */
  robotsTxt?: Maybe<Scalars['String']['output']>
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  rootCategoryId?: Maybe<Scalars['Int']['output']>
  /** The unique ID for a `CategoryInterface` object. */
  rootCategoryUid?: Maybe<Scalars['ID']['output']>
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  salesFixedProductTaxDisplaySetting?: Maybe<FixedProductTaxDisplaySettings>
  /** Search engine robot values. 'INDEX, FOLLOW', 'NOINDEX, FOLLOW' etc. */
  searchEngineRobots?: Maybe<Scalars['String']['output']>
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secureBaseLinkUrl?: Maybe<Scalars['String']['output']>
  /** The secure fully-qualified URL that specifies the location of media files. */
  secureBaseMediaUrl?: Maybe<Scalars['String']['output']>
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secureBaseStaticUrl?: Maybe<Scalars['String']['output']>
  /** The store’s fully-qualified secure base URL. */
  secureBaseUrl?: Maybe<Scalars['String']['output']>
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  showCmsBreadcrumbs?: Maybe<Scalars['Int']['output']>
  socialTrustpilotBusinessUnitId?: Maybe<Scalars['String']['output']>
  storeCity?: Maybe<Scalars['String']['output']>
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  storeCode?: Maybe<Scalars['ID']['output']>
  storeCountryId?: Maybe<Scalars['String']['output']>
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  storeGroupCode?: Maybe<Scalars['ID']['output']>
  /** The label assigned to the store group. */
  storeGroupName?: Maybe<Scalars['String']['output']>
  storeHours?: Maybe<Scalars['String']['output']>
  storeMerchantVatNumber?: Maybe<Scalars['String']['output']>
  /** The label assigned to the store view. */
  storeName?: Maybe<Scalars['String']['output']>
  storePhone?: Maybe<Scalars['String']['output']>
  storePostcode?: Maybe<Scalars['String']['output']>
  storeRegionId?: Maybe<Scalars['String']['output']>
  /** The store view sort order. */
  storeSortOrder?: Maybe<Scalars['Int']['output']>
  storeStreetLine1?: Maybe<Scalars['String']['output']>
  storeStreetLine2?: Maybe<Scalars['String']['output']>
  /** The time zone of the store. */
  timezone?: Maybe<Scalars['String']['output']>
  /** The character that separates the category name and subcategory in the browser title bar. */
  titleSeparator?: Maybe<Scalars['String']['output']>
  /** Indicates whether the store code should be used in the URL. */
  useStoreInUrl?: Maybe<Scalars['Boolean']['output']>
  /** The unique ID for the website. */
  websiteCode?: Maybe<Scalars['ID']['output']>
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  websiteId?: Maybe<Scalars['Int']['output']>
  /** The label assigned to the website. */
  websiteName?: Maybe<Scalars['String']['output']>
  /** The unit of weight. */
  weightUnit?: Maybe<Scalars['String']['output']>
  /** Indicates whether only specific countries can use this payment method. */
  zeroSubtotalEnableForSpecificCountries?: Maybe<Scalars['Boolean']['output']>
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zeroSubtotalEnabled?: Maybe<Scalars['Boolean']['output']>
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zeroSubtotalNewOrderStatus?: Maybe<Scalars['String']['output']>
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zeroSubtotalPaymentAction?: Maybe<Scalars['String']['output']>
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zeroSubtotalPaymentFromSpecificCountries?: Maybe<Scalars['String']['output']>
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zeroSubtotalSortOrder?: Maybe<Scalars['Int']['output']>
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zeroSubtotalTitle?: Maybe<Scalars['String']['output']>
}

/** Indicates where an attribute can be displayed. */
export type StorefrontProperties = {
  __typename?: 'StorefrontProperties'
  /** The relative position of the attribute in the layered navigation block. */
  position?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  useInLayeredNavigation?: Maybe<UseInLayeredNavigationOptions>
  /** Indicates whether the attribute is displayed in product listings. */
  useInProductListing?: Maybe<Scalars['Boolean']['output']>
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  useInSearchResultsLayeredNavigation?: Maybe<Scalars['Boolean']['output']>
  /** Indicates whether the attribute is displayed on product pages. */
  visibleOnCatalogPages?: Maybe<Scalars['Boolean']['output']>
}

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type SubscribeEmailToNewsletterOutput = {
  __typename?: 'SubscribeEmailToNewsletterOutput'
  /** The status of the subscription request. */
  status?: Maybe<SubscriptionStatusesEnum>
}

/** Indicates the status of the request. */
export enum SubscriptionStatusesEnum {
  /** @deprecated  */
  NOT_ACTIVE = 'NOT_ACTIVE',
  /** @deprecated  */
  SUBSCRIBED = 'SUBSCRIBED',
  /** @deprecated  */
  UNCONFIRMED = 'UNCONFIRMED',
  /** @deprecated  */
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

/** Describes the swatch type and a value. */
export type SwatchData = {
  __typename?: 'SwatchData'
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type?: Maybe<Scalars['String']['output']>
  /** The value for the swatch item. It could be text or an image link. */
  value?: Maybe<Scalars['String']['output']>
}

export type SwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>
}

export type SwatchLayerFilterItem = LayerFilterItemInterface &
  SwatchLayerFilterItemInterface & {
    __typename?: 'SwatchLayerFilterItem'
    /**
     * The count of items per filter.
     * @deprecated Use `AggregationOption.count` instead.
     */
    itemsCount?: Maybe<Scalars['Int']['output']>
    /**
     * The label for a filter.
     * @deprecated Use `AggregationOption.label` instead.
     */
    label?: Maybe<Scalars['String']['output']>
    /** Data required to render a swatch filter item. */
    swatchData?: Maybe<SwatchData>
    /**
     * The value of a filter request variable to be used in query.
     * @deprecated Use `AggregationOption.value` instead.
     */
    valueString?: Maybe<Scalars['String']['output']>
  }

export type SwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatchData?: Maybe<SwatchData>
}

export type TaggedTweakwiseItemData = {
  __typename?: 'TaggedTweakwiseItemData'
  id: Scalars['ID']['output']
  store?: Maybe<Scalars['Int']['output']>
  type: Scalars['String']['output']
}

/** Contains tax item details. */
export type TaxItem = {
  __typename?: 'TaxItem'
  /** The amount of tax applied to the item. */
  amount: Money
  /** The rate used to calculate the tax. */
  rate: Scalars['Float']['output']
  /** A title that describes the tax. */
  title: Scalars['String']['output']
}

export type TextSwatchData = SwatchDataInterface & {
  __typename?: 'TextSwatchData'
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>
}

/** Defines a price based on the quantity purchased. */
export type TierPrice = {
  __typename?: 'TierPrice'
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>
  /** The price of the product at this tier. */
  finalPrice?: Maybe<Money>
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']['output']>
}

export type TweakwiseAdvisor = {
  __typename?: 'TweakwiseAdvisor'
  code?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  items?: Maybe<Array<Maybe<TweakwiseAdvisorItem>>>
  questions?: Maybe<Array<Maybe<TweakwiseAdvisorQuestion>>>
  title?: Maybe<Scalars['String']['output']>
}

export type TweakwiseAdvisorAnswer = {
  __typename?: 'TweakwiseAdvisorAnswer'
  answer?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  image?: Maybe<Scalars['String']['output']>
  isSelected?: Maybe<Scalars['Boolean']['output']>
  nextQuestionId?: Maybe<Scalars['ID']['output']>
  subtext?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
}

export type TweakwiseAdvisorAnswerInput = {
  answerIds: Array<InputMaybe<Scalars['Int']['input']>>
  questionId: Scalars['Int']['input']
}

export type TweakwiseAdvisorItem = {
  __typename?: 'TweakwiseAdvisorItem'
  brand?: Maybe<Scalars['String']['output']>
  itemNo?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Float']['output']>
  properties?: Maybe<Array<Maybe<TweakwiseAdvisorItemProperties>>>
  title?: Maybe<Scalars['String']['output']>
}

export type TweakwiseAdvisorItemProperties = {
  __typename?: 'TweakwiseAdvisorItemProperties'
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  isFiltered?: Maybe<Scalars['Boolean']['output']>
  isMatch?: Maybe<Scalars['Boolean']['output']>
  propertyId?: Maybe<Scalars['Int']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type TweakwiseAdvisorParams = {
  answers?: InputMaybe<Array<InputMaybe<TweakwiseAdvisorAnswerInput>>>
  code: Scalars['String']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  skippedQuestions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type TweakwiseAdvisorQuestion = {
  __typename?: 'TweakwiseAdvisorQuestion'
  answers?: Maybe<Array<Maybe<TweakwiseAdvisorAnswer>>>
  attributeId?: Maybe<Scalars['Int']['output']>
  current?: Maybe<Scalars['Boolean']['output']>
  explanation?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  image?: Maybe<Scalars['String']['output']>
  isMultiSelect?: Maybe<Scalars['Boolean']['output']>
  question?: Maybe<Scalars['String']['output']>
  skiplabel?: Maybe<Scalars['String']['output']>
  skippable?: Maybe<Scalars['Boolean']['output']>
}

export type TweakwiseAutocompleteParams = {
  /** The category that should contain the filtered results. If you want to provide the entire path, you can provide multiple ids. */
  categoryId?: InputMaybe<Array<Scalars['ID']['input']>>
  /** Use instant search. Defaults to false. */
  instant?: InputMaybe<Scalars['Boolean']['input']>
  /** Specify the keyboard to use for the search algorithms. */
  keyboard?: InputMaybe<TweakwiseKeyboardLayout>
  /** Specify the language to use for the search algorithms. */
  language?: InputMaybe<Scalars['String']['input']>
  /** The number of results that will be returned per component. Defaults to 6. Max 20. */
  maxResults?: InputMaybe<Scalars['Int']['input']>
  /**
   * Hidden parameters can be added to the URL by using the parameter 'tn_parameters'.
   *
   * When filtering by property 'brand' with value 'Coca Cola' or with value 'Pepsi' the value of tn_parameters should be: brand=Coca Cola&brand=Pepsi
   *
   * This value should then be URL encoded.
   */
  parameters?: InputMaybe<Array<TweakwiseNavigationParameter>>
}

export type TweakwiseAutocompleteResult = {
  __typename?: 'TweakwiseAutocompleteResult'
  instantSearchTerm?: Maybe<Scalars['String']['output']>
  isInstantSearchActive?: Maybe<Scalars['Boolean']['output']>
  items: Array<TweakwiseNavigationItem>
  keywords: Array<Scalars['String']['output']>
}

export type TweakwiseFunnel = {
  __typename?: 'TweakwiseFunnel'
  code?: Maybe<Scalars['String']['output']>
  count?: Maybe<Scalars['Int']['output']>
  filterTemplateId?: Maybe<Scalars['Int']['output']>
  items?: Maybe<Array<Maybe<TweakwiseFunnelItem>>>
  name?: Maybe<Scalars['String']['output']>
  navigationUrl?: Maybe<Scalars['String']['output']>
  questions?: Maybe<Array<Maybe<TweakwiseFunnelQuestion>>>
}

export type TweakwiseFunnelAnswer = {
  __typename?: 'TweakwiseFunnelAnswer'
  answer?: Maybe<Scalars['String']['output']>
  answerId: Scalars['ID']['output']
  caption?: Maybe<Scalars['String']['output']>
  count?: Maybe<Scalars['Int']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  isSelected?: Maybe<Scalars['Boolean']['output']>
  nextQuestionId?: Maybe<Scalars['ID']['output']>
  summary?: Maybe<Scalars['String']['output']>
}

export type TweakwiseFunnelAnswerInput = {
  answerIds: Array<InputMaybe<Scalars['ID']['input']>>
  questionId: Scalars['ID']['input']
}

export type TweakwiseFunnelItem = {
  __typename?: 'TweakwiseFunnelItem'
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  brand?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  itemNo: Scalars['ID']['output']
  labels?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Float']['output']>
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type TweakwiseFunnelParams = {
  answers?: InputMaybe<Array<InputMaybe<TweakwiseFunnelAnswerInput>>>
  code: Scalars['String']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  skipProducts?: InputMaybe<Scalars['Int']['input']>
  skippedQuestions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type TweakwiseFunnelQuestion = {
  __typename?: 'TweakwiseFunnelQuestion'
  answers?: Maybe<Array<Maybe<TweakwiseFunnelAnswer>>>
  current?: Maybe<Scalars['Boolean']['output']>
  explanation?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  image?: Maybe<Scalars['String']['output']>
  isMultiSelect?: Maybe<Scalars['Boolean']['output']>
  question?: Maybe<Scalars['String']['output']>
  skipLabel?: Maybe<Scalars['String']['output']>
  skippable?: Maybe<Scalars['Boolean']['output']>
}

export enum TweakwiseKeyboardLayout {
  AZERTY = 'azerty',
  QWERTY = 'qwerty',
  QWERTZ = 'qwertz',
}

export type TweakwiseNavigationAttribute = {
  __typename?: 'TweakwiseNavigationAttribute'
  attributeId?: Maybe<Scalars['Int']['output']>
  children?: Maybe<Scalars['TODO']['output']>
  colorSwatch?: Maybe<ColorSwatch>
  facetAttributeName: Scalars['ID']['output']
  imageTag?: Maybe<Scalars['String']['output']>
  isSelected: Scalars['Boolean']['output']
  nrOfResults: Scalars['Int']['output']
  title: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type TweakwiseNavigationFacet = {
  __typename?: 'TweakwiseNavigationFacet'
  attributes: Array<TweakwiseNavigationAttribute>
  facetSettings: FacetSettings
}

export type TweakwiseNavigationFacetFilter = {
  key: Scalars['String']['input']
  values: Array<Scalars['String']['input']>
}

export type TweakwiseNavigationItem = {
  __typename?: 'TweakwiseNavigationItem'
  brand?: Maybe<Scalars['String']['output']>
  image?: Maybe<Scalars['String']['output']>
  itemNo: Scalars['ID']['output']
  price: Scalars['Float']['output']
  product?: Maybe<ProductInterface>
  taggedData?: Maybe<TaggedTweakwiseItemData>
  title: Scalars['String']['output']
}

export type TweakwiseNavigationParameter = {
  property: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type TweakwiseNavigationParams = {
  /** The category ID to query. When filtering by a subcategory, providing the parent categoryIds will keep the category facet accurate. */
  categoryId?: InputMaybe<Array<Scalars['ID']['input']>>
  /** The facets with which the results are filtered by. */
  facets?: InputMaybe<Array<TweakwiseNavigationFacetFilter>>
  /** Overruling the linked filter template with the specified template. */
  filterTemplateId?: InputMaybe<Scalars['Int']['input']>
  /** Specify the keyboard to use for the search algorithms. */
  keyboard?: InputMaybe<TweakwiseKeyboardLayout>
  /** The page number of the page that must be displayed. */
  page?: InputMaybe<Scalars['Int']['input']>
  /** The number of products that must be displayed per page. The standard value is configured at shop level. Only use this parameter to overrule this standard configured quantity. */
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** Hidden parameters. */
  parameters?: InputMaybe<Array<TweakwiseNavigationParameter>>
  /**
   * Personal parameters.
   *
   * Personal parameters are similar to hidden parameters, except they only apply to recommendations to which the filters are assigned. This is typically useful when you are using personal merchandising and the filters should only be applied to select components.
   */
  personalParameters?: InputMaybe<Array<TweakwiseNavigationParameter>>
  /**
   * Search term entered by the user.
   *
   * This executes a text based search on the Tweakwise rest api. Passing this parameter also queries the `navigate-search` endpoint instead of the `navigate` endpoint.
   */
  query?: InputMaybe<Scalars['String']['input']>
  /** Sort direction when sortKey is set. */
  sortDirection?: InputMaybe<TweakwiseSortDirection>
  /** Sorting the results. The XML returns the values which can be used for sorting. */
  sortKey?: InputMaybe<Scalars['String']['input']>
  /** Overruling the linked sorting template with the specified template. */
  sortTemplateId?: InputMaybe<Scalars['Int']['input']>
  /**
   * The visitor key is an identifier for the person browsing your website who is initiating the navigation requests. This same identifier should also be used to identify the visitor when sending events to our Analytics API. Based on the sent events, the visitor can receive personalized results.
   *
   * The visitor key can be any string as long as it is unique to the visitor. Generate for example a Universally Unique Identifier (UUID), a new id per visitor or use an account id.
   */
  visitorKey?: InputMaybe<Scalars['String']['input']>
}

export type TweakwiseNavigationProperties = {
  __typename?: 'TweakwiseNavigationProperties'
  currentPage: Scalars['Int']['output']
  isDirectSearch: Scalars['Boolean']['output']
  isRootCategory: Scalars['Boolean']['output']
  nrOfItems: Scalars['Int']['output']
  nrOfPages: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  pageUrl: Scalars['String']['output']
  resetUrl: Scalars['String']['output']
  searchTerm?: Maybe<Scalars['String']['output']>
  selectedCategory: Scalars['Int']['output']
  sortFields: Array<TweakwiseNavigationPropertiesSortField>
  suggestedSearchTerm?: Maybe<Scalars['String']['output']>
}

export type TweakwiseNavigationPropertiesSortField = {
  __typename?: 'TweakwiseNavigationPropertiesSortField'
  displayTitle: Scalars['String']['output']
  isSelected: Scalars['Boolean']['output']
  order: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type TweakwiseNavigationRedirect = {
  __typename?: 'TweakwiseNavigationRedirect'
  url: Scalars['String']['output']
}

export type TweakwiseNavigationResult = {
  __typename?: 'TweakwiseNavigationResult'
  facets: Array<TweakwiseNavigationFacet>
  items: Array<TweakwiseNavigationItem>
  properties: TweakwiseNavigationProperties
  redirects: Array<TweakwiseNavigationRedirect>
}

export type TweakwiseProductRecommendationsTemplate = {
  __typename?: 'TweakwiseProductRecommendationsTemplate'
  id: Scalars['ID']['output']
  items: Array<TweakwiseNavigationItem>
  name: Scalars['String']['output']
}

export type TweakwiseRecommendation = {
  __typename?: 'TweakwiseRecommendation'
  id: Scalars['ID']['output']
  items: Array<TweakwiseNavigationItem>
  name?: Maybe<Scalars['String']['output']>
}

export type TweakwiseRecommendationsFeaturedParams = {
  /** The category that should contain the filtered results. If you want to provide the entire path, you can provide multiple ids. */
  categoryId?: InputMaybe<Array<Scalars['ID']['input']>>
  /**
   * Hidden parameters can be added to the URL by using the parameter 'tn_parameters'.
   *
   * When filtering by property 'brand' with value 'Coca Cola' or with value 'Pepsi' the value of tn_parameters should be: brand=Coca Cola&brand=Pepsi
   *
   * This value should then be URL encoded.
   */
  parameters?: InputMaybe<Array<TweakwiseNavigationParameter>>
}

export enum TweakwiseSortDirection {
  ASCENDING = 'Ascending',
  DESCENDING = 'Descending',
}

export type TweakwiseTemplates = {
  __typename?: 'TweakwiseTemplates'
  featuredProductsTemplate?: Maybe<Scalars['Int']['output']>
  filterWhitelist?: Maybe<Scalars['String']['output']>
  filterWhitelistValues?: Maybe<Scalars['String']['output']>
  productCrosssellGroupCode?: Maybe<Scalars['String']['output']>
  productCrosssellTemplate?: Maybe<Scalars['Int']['output']>
  productUpsellGroupCode?: Maybe<Scalars['String']['output']>
  productUpsellTemplate?: Maybe<Scalars['Int']['output']>
  relatedProductsGroupCode?: Maybe<Scalars['String']['output']>
  relatedProductsTemplate?: Maybe<Scalars['Int']['output']>
}

/** Unique Code */
export type UniqueCode = {
  __typename?: 'UniqueCode'
  /** Timestamp indicating when the plate was created. */
  createdAt: Scalars['String']['output']
  /** Status of the code */
  status: CodeStatus
  /** Unique Code */
  uniqueCode: Scalars['String']['output']
  /** Timestamp indicating when the plate was updated. */
  updatedAt: Scalars['String']['output']
}

/** Modifies the specified items in the cart. */
export type UpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input']
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<CartItemUpdateInput>>
}

/** Contains details about the cart after updating items. */
export type UpdateCartItemsOutput = {
  __typename?: 'UpdateCartItemsOutput'
  /** The cart after updating products. */
  cart: Cart
}

/** Contains the customer's wish list and any errors encountered. */
export type UpdateProductsInWishlistOutput = {
  __typename?: 'UpdateProductsInWishlistOutput'
  /** An array of errors encountered while updating products in a wish list. */
  userErrors: Array<Maybe<WishListUserInputError>>
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: Wishlist
}

/** Contains URL rewrite details. */
export type UrlRewrite = {
  __typename?: 'UrlRewrite'
  /** An array of request parameters. */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>
  /** The request URL. */
  url?: Maybe<Scalars['String']['output']>
}

/** This enumeration defines the entity type. */
export enum UrlRewriteEntityTypeEnum {
  /** @deprecated  */
  CATEGORY = 'CATEGORY',
  /** @deprecated  */
  CMS_PAGE = 'CMS_PAGE',
  /** @deprecated  */
  CRAFT = 'CRAFT',
  /** @deprecated  */
  LANDINGPAGE = 'LANDINGPAGE',
  /** @deprecated  */
  PRODUCT = 'PRODUCT',
}

/** Defines whether the attribute is filterable in layered navigation. */
export enum UseInLayeredNavigationOptions {
  /** @deprecated  */
  FILTERABLE_NO_RESULT = 'FILTERABLE_NO_RESULT',
  /** @deprecated  */
  FILTERABLE_WITH_RESULTS = 'FILTERABLE_WITH_RESULTS',
  /** @deprecated  */
  NO = 'NO',
}

/** Contains required input for payment methods with Vault support. */
export type VaultTokenInput = {
  /** The public hash of the payment token. */
  public_hash: Scalars['String']['input']
}

/** An implementation for virtual product cart items. */
export type VirtualCartItem = CartItemInterface & {
  __typename?: 'VirtualCartItem'
  /** An array containing customizable options the shopper selected. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output']
  /** PreOrder info */
  preorder?: Maybe<PreOrder>
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>
  /** Details about an item in the cart. */
  product: ProductInterface
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output']
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output']
}

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = CustomizableProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'VirtualProduct'
    /** @deprecated Use the `custom_attributes` field instead. */
    addOn?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    aerowall?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    ageRecommended?: Maybe<Scalars['Int']['output']>
    /** Ambiance Product Images */
    ambianceGallery?: Maybe<Array<Maybe<AmbianceGallery>>>
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attributeSetId?: Maybe<Scalars['Int']['output']>
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonicalUrl?: Maybe<Scalars['String']['output']>
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    collaborationLicense?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    color?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    colorVariant?: Maybe<Scalars['String']['output']>
    /** Color Variants */
    colorVariants?: Maybe<Array<Maybe<ColorVariant>>>
    /** The product's country of origin. */
    countryOfManufacture?: Maybe<Scalars['String']['output']>
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    createdAt?: Maybe<Scalars['String']['output']>
    /** Crosssell Products */
    crosssellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    drive?: Maybe<Scalars['Int']['output']>
    /** Filterable attribute with Text */
    dynamicAttributes?: Maybe<Array<Maybe<DynamicAttribute>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    electricalSupport?: Maybe<Scalars['Int']['output']>
    /** Craft entry type */
    entryType?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    framePlaybase?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    frameXlGokart?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gears?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gender?: Maybe<Scalars['Int']['output']>
    /** Indicates whether a gift message is available. */
    giftMessageAvailable?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    gokartType?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    handbrake?: Maybe<Scalars['Int']['output']>
    /** Highlight attributes */
    highlightedAttributes?: Maybe<Array<Maybe<HighlightAttribute>>>
    /** Highlight attributes PLP */
    highlightedAttributesPlp?: Maybe<Array<Maybe<HighlightAttribute>>>
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Scalars['Int']['output']
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>
    /** @deprecated Use the `custom_attributes` field instead. */
    inclSafetynet?: Maybe<Scalars['Int']['output']>
    /** Whether the product is a main product or not. */
    isMainProduct: Scalars['Boolean']['output']
    /** @deprecated Use the `custom_attributes` field instead. */
    jumpMat?: Maybe<Scalars['Int']['output']>
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    maxUserWeight?: Maybe<Scalars['Int']['output']>
    /** An array of media gallery objects. */
    mediaGallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    mediaGalleryEntries?: Maybe<Array<Maybe<MediaGalleryEntry>>>
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    metaDescription?: Maybe<Scalars['String']['output']>
    /** A comma-separated list of keywords that are visible only to search engines. */
    metaKeyword?: Maybe<Scalars['String']['output']>
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    metaTitle?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    minLengthUser?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    model?: Maybe<Scalars['Int']['output']>
    /** The product name. Customers use this name to identify the product. */
    name: Scalars['String']['output']
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    newFromDate?: Maybe<Scalars['String']['output']>
    /** The end date for new product listings. */
    newToDate?: Maybe<Scalars['String']['output']>
    /** Product stock only x left count */
    onlyXLeftInStock?: Maybe<Scalars['Float']['output']>
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>
    /** If the product has multiple options, determines where they appear on the product page. */
    optionsContainer?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pedals?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    playbaseSet?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    possibilityFor2ndSeat?: Maybe<Scalars['Int']['output']>
    /** PreOrder info */
    preorder?: Maybe<PreOrder>
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>
    /** The range of prices for the product */
    priceRange: PriceRange
    /** An array of `TierPrice` objects. */
    priceTiers?: Maybe<Array<Maybe<TierPrice>>>
    /** Product downloads */
    productDownloads?: Maybe<ProductDownload>
    /** An array of `ProductLinks` objects. */
    productLinks?: Maybe<Array<Maybe<ProductLinksInterface>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    productStatus?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    pushRod?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityLine?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    qualityStars?: Maybe<Scalars['Int']['output']>
    /** Review rating summary value. */
    ratingSummary?: Maybe<Scalars['Float']['output']>
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirectCode: Scalars['Int']['output']
    /** An array of products to be displayed in a Related Products block. */
    relatedProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relativeUrl?: Maybe<Scalars['String']['output']>
    /** Review amount of records. */
    reviewCount?: Maybe<Scalars['Int']['output']>
    /** The list of products reviews. */
    reviews: ProductReviews
    /** @deprecated Use the `custom_attributes` field instead. */
    safetynetType?: Maybe<Scalars['Int']['output']>
    /** A short description of the product. Its use depends on the theme. */
    shortDescription?: Maybe<ComplexTextValue>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeAirtrack?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeBeachwagon?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeClothing?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeJumpMat?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    sizeStep?: Maybe<Scalars['Int']['output']>
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Scalars['String']['output']
    /** The relative path to the small image, which is used on catalog pages. */
    smallImage?: Maybe<ProductImage>
    /** Get list of spareparts per product(group), per year */
    sparepartLinks?: Maybe<Array<Maybe<BergProduct>>>
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    specialFromDate?: Maybe<Scalars['String']['output']>
    /** The discounted price of the product. */
    specialPrice?: Maybe<Scalars['Float']['output']>
    /** The end date for a product with a special price. */
    specialToDate?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    springType?: Maybe<Scalars['Int']['output']>
    /** Stock status of the product */
    stockStatus?: Maybe<ProductStockStatus>
    /** The file name of a swatch image. */
    swatchImage?: Maybe<Scalars['String']['output']>
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrice?: Maybe<Scalars['Float']['output']>
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tierPrices?: Maybe<Array<Maybe<ProductTierPrices>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineShape?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    trampolineType?: Maybe<Scalars['Int']['output']>
    /** Tweakwise ID */
    tweakwiseItemNumber?: Maybe<Scalars['String']['output']>
    /** PreOrder info */
    tweakwiseTemplates?: Maybe<TweakwiseTemplates>
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    typeId?: Maybe<Scalars['String']['output']>
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID']['output']
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updatedAt?: Maybe<Scalars['String']['output']>
    /** Upsell Products */
    upsellProducts?: Maybe<Array<Maybe<ProductInterface>>>
    /** The part of the URL that identifies the product */
    urlKey: Scalars['String']['output']
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    urlPath?: Maybe<Scalars['String']['output']>
    /** URL rewrites list */
    urlRewrites?: Maybe<Array<Maybe<UrlRewrite>>>
    /** The part of the product URL that is appended after the url key */
    urlSuffix?: Maybe<Scalars['String']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    uvProtection?: Maybe<Scalars['Int']['output']>
    /** @deprecated Use the `custom_attributes` field instead. */
    warranty?: Maybe<Scalars['Int']['output']>
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>
    /** @deprecated Use the `custom_attributes` field instead. */
    wheelLights?: Maybe<Scalars['Int']['output']>
  }

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Defines a single product to add to the cart. */
export type VirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput
}

/** Contains a virtual product wish list item. */
export type VirtualWishlistItem = WishlistItemInterface & {
  __typename?: 'VirtualWishlistItem'
  /** The date and time the item was added to the wish list. */
  addedAt: Scalars['String']['output']
  /** Custom options selected for the wish list item. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output']
}

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type Website = {
  __typename?: 'Website'
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']['output']>
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  defaultGroupId?: Maybe<Scalars['String']['output']>
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']['output']>
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  isDefault?: Maybe<Scalars['Boolean']['output']>
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']['output']>
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sortOrder?: Maybe<Scalars['Int']['output']>
}

/** An error encountered while performing operations with WishList. */
export type WishListUserInputError = {
  __typename?: 'WishListUserInputError'
  /** A wish list-specific error code. */
  code: WishListUserInputErrorType
  /** A localized error message. */
  message: Scalars['String']['output']
}

/** A list of possible error types. */
export enum WishListUserInputErrorType {
  /** @deprecated  */
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  UNDEFINED = 'UNDEFINED',
}

/** Contains a customer wish list. */
export type Wishlist = {
  __typename?: 'Wishlist'
  /** The unique ID for a `Wishlist` object. */
  id?: Maybe<Scalars['ID']['output']>
  /** @deprecated Use the `items_v2` field instead. */
  items?: Maybe<Array<Maybe<WishlistItem>>>
  /** The number of items in the wish list. */
  itemsCount?: Maybe<Scalars['Int']['output']>
  /** An array of items in the customer's wish list. */
  itemsV2?: Maybe<WishlistItems>
  /** An encrypted code that Magento uses to link to the wish list. */
  sharingCode?: Maybe<Scalars['String']['output']>
  /** The time of the last modification to the wish list. */
  updatedAt?: Maybe<Scalars['String']['output']>
}

/** Contains a customer wish list. */
export type WishlistItemsV2Args = {
  currentPage?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type WishlistCartUserInputError = {
  __typename?: 'WishlistCartUserInputError'
  /** An error code that describes the error encountered. */
  code: WishlistCartUserInputErrorType
  /** A localized error message. */
  message: Scalars['String']['output']
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars['ID']['output']
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars['ID']['output']
}

/** A list of possible error types. */
export enum WishlistCartUserInputErrorType {
  /** @deprecated  */
  INSUFFICIENT_STOCK = 'INSUFFICIENT_STOCK',
  /** @deprecated  */
  NOT_SALABLE = 'NOT_SALABLE',
  /** @deprecated  */
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  /** @deprecated  */
  UNDEFINED = 'UNDEFINED',
}

/** Contains details about a wish list item. */
export type WishlistItem = {
  __typename?: 'WishlistItem'
  /** The time when the customer added the item to the wish list. */
  addedAt?: Maybe<Scalars['String']['output']>
  /** The customer's comment about this item. */
  description?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `WishlistItem` object. */
  id?: Maybe<Scalars['Int']['output']>
  /** Details about the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']['output']>
}

/** Defines the items to add to a wish list. */
export type WishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>
  /** The amount or number of items to add. */
  quantity: Scalars['Float']['input']
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars['String']['input']
}

/** The interface for wish list items. */
export type WishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  addedAt: Scalars['String']['output']
  /** Custom options selected for the wish list item. */
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output']
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output']
}

/** Defines updates to items in a wish list. */
export type WishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description?: InputMaybe<Scalars['String']['input']>
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>
  /** The new amount or number of this item. */
  quantity?: InputMaybe<Scalars['Float']['input']>
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars['ID']['input']
}

/** Contains an array of items in a wish list. */
export type WishlistItems = {
  __typename?: 'WishlistItems'
  /** A list of items in the wish list. */
  items: Array<Maybe<WishlistItemInterface>>
  /** Contains pagination metadata. */
  pageInfo?: Maybe<SearchResultPageInfo>
}

/** Deprecated: Use the `Wishlist` type instead. */
export type WishlistOutput = {
  __typename?: 'WishlistOutput'
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items?: Maybe<Array<Maybe<WishlistItem>>>
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  itemsCount?: Maybe<Scalars['Int']['output']>
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name?: Maybe<Scalars['String']['output']>
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharingCode?: Maybe<Scalars['String']['output']>
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updatedAt?: Maybe<Scalars['String']['output']>
}
